<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent" v-if="component"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <div class="editor-header">
            <h3 v-if="product.name">{{ product.name }} <span v-if="parseInt(product.archived)"> ({{_('Archived')}})</span></h3>
            <h3 v-else>{{ _('Product') }}</h3>
            <div class="header-controls small">
              <div class="form-check">
                <label class="form-check-label form-check-toggle" :title="showAllFields ? _('All details shown') : _('Show all details')">
                  <input class="form-check-input" type="checkbox" v-model="showAllFields" true-value="1" false-value="0">
                  <span>
                    <span class="hidden-xs" v-if="!showAllFields">{{ _('Show all details') }}</span>
                    <span class="hidden-xs" v-else>{{ _('All details shown') }}</span>
                  </span>
                </label>
              </div>
              <form v-if="storePreviewRedirect" method="post" action="/api/auth/storefront-preview" target="_blank" rel="noopener" class="store-preview-form">
                <input type="hidden" name="shopId" :value="shopId">
                <input type="hidden" name="redirect" :value="storePreviewRedirect">
                <button type="submit" class="btn btn-success" id="storePreviewButton" :title="_('Preview')"><i class="fa fa-fw fa-external-link"></i><span class="preview-button-label"> {{ _('Preview') }}</span></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <editor-tabs id="tabNavi" data-hint="Klikkaa välilehteä saadaksesi esille välilehdellä olevat tuotetiedot. Voit muokata tuotetietoja eri välilehdillä ja tallentaa vasta lopuksi – tehdyt muutokset säilyvät tallentamatta, kunnes poistut tuotesivulta." data-hintPosition="top-middle" data-position="bottom-right-aligned" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade" v-on:enter="tabOpened" v-on:leave="tabClosed">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <h3>{{ _('General product information') }}</h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 leftcol">
                <div class="form-group languageversioned">
                  <label for="productTitle">{{ _('Name') }}</label>
                  <input type="text" class="form-control" id="productTitle" :placeholder="_('Enter product name')" name="name" v-model="product.name" data-hint="Tuotteen nimi näytetään sekä asiakkaille että ylläpidossa. Poikkeuksena ks. Markkinointinimi.">
                </div>
              </div>
              <div class="col-lg-6 rightcol">
                <div class="form-group">
                  <label for="productType">{{ _('Product type') }}</label>
                  <select class="form-control" id="productType" v-model="type">
                    <option :disabled="typeDef.disabled" v-for="typeDef in availableTypes" :value="typeDef.type + '-' + typeDef.subtype + '-' + typeDef.displayedtype">{{ typeDef.title }}<span v-if="typeDef.subtypetitle"> ({{ typeDef.subtypetitle }})</span></option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" v-if="showAllFields && (isEpassiEnabled || isEdenredEnabled || isLoyaltyEnabled)">
              <div class="col-lg-6 leftcol" v-if="isLoyaltyEnabled">
                <div class="form-group">
                  <label for="loyaltyType">{{ _('Bonus') }}</label>
                  <select class="form-control" id="loyaltyType" v-model="loyaltyType">
                    <option :value="null">{{ _('Not selected') }}</option>
                    <option value="bonus">{{ _('Bonus') }}</option>
                    <option value="both" v-if="isPaymentMethodBenefitEnabled">{{ _('Bonus and payment method benefit') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 leftcol" v-if="isEpassiEnabled">
                <div class="form-group">
                  <label for="epassiBenefit">{{ _('ePassi benefit type') }}</label>
                  <select class="form-control" id="epassiBenefit" v-model="epassiBenefit">
                    <option :value="null">{{ _('Not selected') }}</option>
                    <option value="sport">{{ _('Sport') }}</option>
                    <option value="culture">{{ _('Culture') }}</option>
                    <option value="lunch">{{ _('Lunch') }}</option>
                    <option value="commuter">{{ _('Commuter') }}</option>
                    <option value="wellbeing">{{ _('Wellbeing') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 rightcol" v-if="isEdenredEnabled">
                <div class="form-group">
                  <label for="edenredBenefit">{{ _('Edenred benefit type') }}</label>
                  <select class="form-control" id="edenredBenefit" v-model="edenredBenefit">
                    <option :value="null">{{ _('Not selected') }}</option>
                    <option value="exercise">{{ _('Exercise') }}</option>
                    <option value="culture">{{ _('Culture') }}</option>
                    <option value="lunch">{{ _('Lunch') }}</option>
                    <option value="commuter">{{ _('Commuter') }}</option>
                    <option value="massage">{{ _('Massage') }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row hotellinx" v-if="isExternal">
              <div class="col-lg-6 leftcol">
              </div>
              <div class="col-sm-6 rightcol">
                <label for="externalId">{{ _('Linked product in backend system') }}</label>
                <select class="form-control" id="externalId" v-model="product.externalid">
                  <option value="0">{{ _('Not linked') }}</option>
                  <option v-for="externalProduct in externalProducts" :value="externalProduct.id">{{ externalProduct.name }}</option>
                </select>
              </div>
            </div>
            <div class="row hotellinx" v-if="isExternal">
              <div class="col-lg-6 leftcol">
              </div>
              <div class="col-sm-6 rightcol">
                <label for="externalRate">{{ _('Rate plan code in backend system') }}</label>
                <input type="text" class="form-control" id="externalRate" placeholder="" v-model="product.externalrate" />
              </div>
            </div>
            <div class="row" v-if="showAllFields">
              <div class="col-lg-6 leftcol">
                <div class="form-group languageversioned">
                  <label for="marketingname">{{ _('Marketing name') }}</label>
                  <input type="text" class="form-control" id="productMarketingName" :placeholder="_('Enter marketing name')" v-model="product.marketingname" :readonly="!parseInt(product.usemarketingname)" data-hint='Markkinointinimeä käyttämällä voi asettaa tuotteelle erillisen asiakkaalle näkyvän tuotenimen – silloin Johkussa Nimi-kohtaan kirjoitettu tuotenimi ei näy ollenkaan asiakkaalle vaan pelkästään ylläpidossa. Markkinointinimi-kentän saa käyttöön raksittamalla "Käytä erillistä markkinointinimeä".' />
                </div>
              </div>
              <div class="col-sm-6 rightcol">
                <label class="hidden-xs"></label>
                <div class="checkbox">
                  <label>
                  <input type="checkbox" name="usemarketingname" id="useMarketingName" v-model="product.usemarketingname" true-value="1" false-value="0" />
                  {{ _('Use a separate marketing name') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row" v-if="showAllFields">
              <div class="col-lg-6 leftcol">
                <div class="form-group languageversioned">
                  <label for="marketingname">{{ _('Direct URL') }}</label>
                  <input type="text" class="form-control" id="productDirectUrl" :placeholder="_('Enter a direct URL path fragment that can be used to access this product')" v-model="product.canonical" />
                </div>
              </div>
              <div class="col-sm-6">
                <label class="hidden-xs"></label>
                <p>
                {{ _('You can set a custom URL path fragment that is used in all the links to this item in the Storefront. It may also be displayed in the browser\'s location bar. If you don\'t specify one, it will be automatically generated for you.') }}
                </p>
              </div>
            </div>
            <div class="row" v-if="showAllFields && isFeatureEnabled('statisticsfinland') && isReservable && (hasStatisticsFinlandCredentials || product.accommodationtype)">
              <div class="col-lg-6 leftcol">
                <div class="form-group">
                  <label for="accommodationtype">{{ _('Accommodation type (Statisitcs Finland)') }}</label>
                  <select class="form-control" :class="{ 'is-invalid': !hasStatisticsFinlandCredentials }" id="accommodationtype" v-model="product.accommodationtype">
                    <option :value="null">{{ _('No reporting') }}</option>
                    <option value="hotel">{{ _('Hotel or Cottage') }}</option>
                    <option value="caravan">{{ _('Caravan') }}</option>
                    <option value="other">{{ _('Tent or other accommodation') }}</option>
                  </select>
                  <p class="help-block text-danger" v-if="!hasStatisticsFinlandCredentials">{{ _('Statistics Finland credentials are not set.') }}</p>
                </div>
              </div>
            </div>
            <div class="row" v-if="showAllFields && isFeatureEnabled('delivery2.0')">
              <div class="col-xs-12">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" name="display_name_in_workflow" v-model="product.display_name_in_workflow" true-value="1" false-value="0" />
                    {{ _('Display name in workflow') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group languageversioned">
                  <label for="description" data-hint="Lyhyt kuvaus näkyy tuotteen esittelytekstinä kauppapaikan tuotelistauksessa. Sivustolle upotetuissa tuotteissa tämä lyhyt kuvaus on ainoa Johkusta tuleva tuotteen esittelyteksti. Suosittelemme tekstiksi mahdollisimman kompaktia esittelyä. Tämä on pakollinen kenttä.">{{ _('Short description') }}</label>
                  <editor v-model="product.description" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group languageversioned">
                  <label for="channel_description" data-hint="Yleiskuvaus on tuotteen varsinainen esittelyteksti, käytä tätä kenttää pidemmälle esittelyille. Tämä on pakollinen kenttä. Majoituskohteiden tarkemmat lisätiedot kuten sijainti ja varustelu, kirjoitetaan Lisätiedot-välilehdelle.">{{ _('General description') }}</label>
                  <editor v-model="product.channeldata.description" :embeds-enabled="true" :columns-enabled="true" :extra-images="product.sharedFile || []" :queue-upload="queueDescriptionImage" @add-extra-image="addPastedExtraImage" />
                </div>
              </div>
            </div>
            <div class="row" v-if="isContent">
              <div class="col-xs-6">
                <div class="form-group languageversioned">
                  <label for="buttontext">{{ _('Action button text') }}</label>
                  <input type="text" class="form-control" id="buttonText" name="buttontext" :placeholder="_('Enter an optional custom text for the action button')" v-model="product.buttontext" />
                </div>
              </div>
            </div>
            <div class="row" v-if="showAllFields">
              <div class="col-xs-12">
                <h3>{{ _('Admin tags') }}</h3>
              </div>
            </div>
            <div class="row" v-if="showAllFields">
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="input-group flex-input-group">
                    <model-list-select :list="allSelectableAdminTags" option-value="id" option-text="title" v-model="adminTagToAdd" :placeholder="_('Type to search tags')" @searchchange="adminTagSearchChanged" @update:modelValue="addAdminTagWithId">
                    </model-list-select>
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info tagsmanagement" v-on:click="manageTagsDialog('admin')"><i class="fa fa-fw fa-tags"></i> {{ _('Manage tags') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <div id="tagsList">
                    <span v-for="tag in adminTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <p>{{ _('Admin tags can be thought of as product categories that are invisible to end users. You can use them to find products in the products list and the admin catalog view.') }}</p>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('details')" class="tab-pane active" id="details" v-if="isTabActive('details') && showDetailsTab" key="details">
            <div class="row">
              <div class="col-xs-12">
                <div class="panel-group flex-panel" id="detailsAccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-default reservablePanel" v-if="!isActivity && !isMovie">
                    <div class="panel-heading" role="tab" id="headingTwo">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('two')" aria-controls="collapseTwo" v-on:click="togglePanel('two')">
                          <span class="title-text">{{ _('Details') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseTwo" class="panel-collapse" role="tabpanel" aria-labelledby="headingTwo" v-if="isPanelOpen('two')">
                        <div class="panel-body">
                          <div class="row" v-if="!isSellable">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="streetaddress">{{ _('Street Address') }}</label>
                                <input type="text" class="form-control" id="streetAddress" :placeholder="_('Enter the street address')" v-model="product.channeldata.streetaddress" />
                              </div>
                              <div class="form-group">
                                <label for="postcode">{{ _('Postal code') }}</label>
                                <input type="text" class="form-control" id="postCode" :placeholder="_('Enter the postal code')" v-model="product.channeldata.postcode" />
                              </div>
                              <div class="form-group">
                                <label for="postarea">{{ _('Postal address') }}</label>
                                <input type="text" class="form-control" id="postArea" :placeholder="_('Enter the postal address')" v-model="product.channeldata.postarea" />
                              </div>
                              <div class="form-group">
                                <label for="municipality">{{ _('Municipality') }}</label>
                                <input type="text" class="form-control" id="municipality" :placeholder="_('Enter the municipality')" v-model="product.channeldata.municipality" />
                              </div>
                              <div class="form-group">
                                <label for="country">{{ _('Country') }}</label>
                                <select class="form-control" name="channel_country" id="country" v-model="product.channeldata.country">
                                  <option value="FI">{{ countries['FI'] }}</option>
                                  <template v-for="(country, id) in countries" :key="id">
                                    <option v-if="isPriorityCountry(id) && id !== 'FI'" :value="id">{{ country }}</option>
                                  </template>
                                  <option class="select-separator" disabled="disabled">────────────</option>
                                  <option v-for="(country, id) in countries" :value="id">{{ country }}</option>
                                </select>
                              </div>
                              <template v-if="hasAccommodationFields">
                                <div class="form-group">
                                  <label for="apartmenttype">{{ _('Holiday apartment type') }}</label>
                                  <select class="form-control" id="holidayApartmentType" v-model="product.channeldata.apartmenttype">
                                    <option value="">-</option>
                                    <option value="cottage">{{ _('Cottage') }}</option>
                                    <option value="villa">{{ _('Villa') }}</option>
                                    <option value="cabin">{{ _('Cabin') }}</option>
                                    <option value="chalet">{{ _('Chalet') }}</option>
                                    <option value="bnb">{{ _('Bed and breakfast') }}</option>
                                    <option value="lapphut">{{ _('Lapp hut') }}</option>
                                    <option value="castle">{{ _('Castle') }}</option>
                                    <option value="farm">{{ _('Farm') }}</option>
                                    <option value="farmhouse">{{ _('Farmhouse') }}</option>
                                    <option value="house">{{ _('House') }}</option>
                                    <option value="apartment">{{ _('Apartment') }}</option>
                                    <option value="room">{{ _('Room') }}</option>
                                    <option value="granary">{{ _('Granary') }}</option>
                                    <option value="campingsite">{{ _('Camping site') }}</option>
                                    <option value="other">{{ _('Other') }}</option>
                                  </select>
                                </div>
                                <div class="form-group">
                                  <label for="numberofbedrooms">{{ _('Number of bedrooms') }}</label>
                                  <input type="text" class="form-control" id="numberOfBedRooms" :placeholder="_('Enter the number of bedrooms')" v-model="product.channeldata.numberofbedrooms" />
                                </div>
                                <div class="form-group">
                                  <label for="numberofbeds">{{ _('Number of beds') }}</label>
                                  <input type="text" class="form-control" id="numberOfBeds" :placeholder="_('Enter the number of beds')" v-model="product.channeldata.numberofbeds" />
                                </div>
                                <div class="form-group">
                                  <label for="extrabeds">{{ _('Extra beds') }}</label>
                                  <input type="text" class="form-control" id="extraBeds" :placeholder="_('Enter the number of extra beds')" v-model="product.channeldata.extrabeds" />
                                </div>
                                <div class="form-group">
                                  <label for="livingarea">{{ _('Living area') }}</label>
                                  <input type="text" class="form-control" id="livingArea" :placeholder="_('Enter the living area in square meters')" v-model="product.channeldata.livingarea" />
                                </div>
                              </template>
                            </div>
                            <div class="col-sm-6 panel-column">
                              <template v-if="hasAccommodationFields">
                                <div class="form-group">
                                  <label for="constructionyear">{{ _('Construction year') }}</label>
                                  <input type="text" class="form-control" id="constructionYear" :placeholder="_('Enter the construction year')" v-model="product.channeldata.constructionyear" />
                                </div>
                                <div class="form-group">
                                  <label for="renovationyear">{{ _('Renovation year') }}</label>
                                  <input type="text" class="form-control" id="renovationYear" :placeholder="_('Enter the renovation year')" v-model="product.channeldata.renovationyear" />
                                </div>
                                <div class="form-group">
                                  <label for="malorating">{{ _('MaLo rating') }}</label>
                                  <select class="form-control" id="maloRating" v-model="product.channeldata.malorating">
                                    <option value="">-</option>
                                    <option value="5">5</option>
                                    <option value="4">4</option>
                                    <option value="3">3</option>
                                    <option value="2">2</option>
                                    <option value="1">1</option>
                                  </select>
                                </div>
                              </template>
                              <div class="form-group languageversioned">
                                <label for="furtherinformation">{{ _('Further information') }}</label>
                                <textarea id="furtherInformation" class="form-control" rows="10" wrap="virtual" v-model="product.channeldata.furtherinformation"></textarea>
                              </div>
                              <div class="form-group" v-if="!isTheater && !isConcert">
                                <label for="infourl">{{ _('Website') }}</label>
                                <input type="text" class="form-control" id="infoUrl" :placeholder="_('Enter the website URL')" v-model="product.channeldata.website" />
                              </div>
                            </div>
                          </div>
                          <div class="row show-sellable show-reservable">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="channel_latitude">{{ _('Latitude') }}</label>
                                <input type="text" class="form-control" id="latitude" :placeholder="_('Enter the latitude')" v-model="product.channeldata.latitude" />
                              </div>
                              <div class="form-group">
                                <label for="channel_longitude">{{ _('Longitude') }}</label>
                                <input type="text" class="form-control" id="longitude" :placeholder="_('Enter the longitude')" v-model="product.channeldata.longitude" />
                              </div>
                              <div class="form-group">
                                <button type="button" class="btn btn-success" id="pickLocationButton" v-on:click="pickLocation"><i class="fa fa-fw fa-map-marker"></i> {{ _('Pick location from the map') }}</button>
                              </div>
                              <div class="form-group">
                                <label for="channel_custom" class="text-danger">{{ _('Custom map code') }} (beta)</label>
                                <textarea id="customHtml" class="form-control" rows="10" wrap="virtual" v-model="product.channeldata.custom"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row show-sellable hide-reservable" v-if="!isContent">
                            <div class="col-sm-6">
                              <div class="form-group" v-if="isSellable">
                                <label for="ean">{{ _('Barcode') }}</label>
                                <input type="text" class="form-control" id="ean" :placeholder="_('Enter or scan the product EAN code')" v-model="product.ean" />
                              </div>
                              <div class="form-group" v-if="isValuecard || isExchangedValuecard || product.channeldata.terms">
                                <label for="terms">{{ _('Terms') }}</label>
                                <textarea id="terms" class="form-control" rows="10" wrap="virtual" v-model="product.channeldata.terms"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="panel panel-default activityPanel" v-if="isReservable && isActivity">
                    <div class="panel-heading" role="tab" id="headingTwoB">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('twoB')" aria-controls="collapseTwoB" v-on:click="togglePanel('twoB')">
                          <span class="title-text">{{ _('Details') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseTwoB" class="panel-collapse" role="tabpanel" aria-labelledby="headingTwoB" v-if="isPanelOpen('twoB')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="streetaddress">{{ _('Street Address') }}</label>
                                <input type="text" class="form-control" id="streetAddress2" :placeholder="_('Enter the street address')" v-model="product.channeldata.streetaddress" />
                              </div>
                              <div class="form-group">
                                <label for="postcode">{{ _('Postal code') }}</label>
                                <input type="text" class="form-control" id="postCode2" :placeholder="_('Enter the postal code')" v-model="product.channeldata.postcode" />
                              </div>
                              <div class="form-group">
                                <label for="postarea">{{ _('Postal address') }}</label>
                                <input type="text" class="form-control" id="postArea2" :placeholder="_('Enter the postal address')" v-model="product.channeldata.postarea" />
                              </div>
                              <div class="form-group">
                                <label for="municipality">{{ _('Municipality') }}</label>
                                <input type="text" class="form-control" id="municipality2" :placeholder="_('Enter the municipality')" v-model="product.channeldata.municipality" />
                              </div>
                              <div class="form-group">
                                <label for="country">{{ _('Country') }}</label>
                                <select class="form-control" name="channel_country" id="country" v-model="product.channeldata.country">
                                  <option v-for="(country, id) in countries" :value="id" v-if="id == 'FI'">{{ country }}</option>
                                  <option v-for="(country, id) in countries" :value="id" v-if="isPriorityCountry(id)">{{ country }}</option>
                                  <option class="select-separator" disabled="disabled">────────────</option>
                                  <option v-for="(country, id) in countries" :value="id">{{ country }}</option>
                                </select>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="difficulty">{{ _('Difficulty') }}</label>
                                <input type="text" class="form-control" id="difficulty" :placeholder="_('Enter the difficulty of this activity')" v-model="product.channeldata.difficulty" />
                              </div>
                              <div class="form-group languageversioned">
                                <label for="languages">{{ _('Languages') }}</label>
                                <input type="text" class="form-control" id="languages" :placeholder="_('Enter the languages this activity is available in')" v-model="product.channeldata.languages" />
                              </div>
                              <div class="form-group languageversioned">
                                <label for="suitability">{{ _('Suitable for') }}</label>
                                <textarea id="suitability" class="form-control" :placeholder="_('Enter the types of people this activity is suitable for')" v-model="product.channeldata.suitability"></textarea>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="insurances">{{ _('Insurance plans') }}</label>
                                <textarea id="insurances" class="form-control" :placeholder="_('Enter the insurance plans you have')" name="activity_insurances" rows="5" wrap="virtual" v-model="product.channeldata.insurances"></textarea>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="qualifications">{{ _('Qualifications') }}</label>
                                <textarea id="qualifications" class="form-control" :placeholder="_('Enter the qualifications you have')" name="activity_qualifications" rows="5" wrap="virtual" v-model="product.channeldata.qualifications"></textarea>
                              </div>
                            </div>
                            <div class="col-sm-6 panel-column">
                              <div class="form-group" v-if="activityCategories">
                                <label for="furtherinformation">{{ _('Classification') }}</label>
                                <p v-html="activityCategories"></p>
                                <button class="btn btn-danger" v-on:click="channelCategories = []">{{ _('Remove') }}</button>
                              </div>
                              
                              <div class="form-group languageversioned">
                                <label for="furtherinformation">{{ _('Further information') }}</label>
                                <textarea id="furtherInformation2" class="form-control" rows="10" wrap="virtual" v-model="product.channeldata.furtherinformation"></textarea>
                              </div>
                              <div class="form-group">
                                <label for="infourl">{{ _('Website') }}</label>
                                <input type="text" class="form-control" id="infoUrl2" :placeholder="_('Enter the website URL')" v-model="product.channeldata.website" />
                              </div>
                              <div class="form-group">
                                <label for="activity_latitude">{{ _('Latitude') }}</label>
                                <input type="text" class="form-control" id="latitude2" :placeholder="_('Enter the latitude of the starting point')" v-model="product.channeldata.latitude" />
                              </div>
                              <div class="form-group">
                                <label for="activity_longitude">{{ _('Longitude') }}</label>
                                <input type="text" class="form-control" id="longitude2" :placeholder="_('Enter the longitude of the starting point')" v-model="product.channeldata.longitude" />
                              </div>
                              <div class="form-group">
                                <button type="button" class="btn btn-success" id="pickLocationButton" v-on:click="pickLocation"><i class="fa fa-fw fa-map-marker"></i> {{ _('Pick location from the map') }}</button>
                              </div>
                              <div class="form-group">
                                <label for="activity_custom" class="text-danger">{{ _('Custom map code') }} (beta)</label>
                                <textarea id="customHtml2" class="form-control" rows="10" wrap="virtual" v-model="product.channeldata.custom"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>

                  <div class="panel panel-default" v-if="isEvent">
                    <div class="panel-heading" role="tab" id="headingTwoC">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('twoC')" aria-controls="collapseTwoC" v-on:click="togglePanel('twoC')">
                          <span class="title-text">{{ _('Event details') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseTwoC" class="panel-collapse" role="tabpanel" aria-labelledby="headingTwoC" v-if="isPanelOpen('twoC')">
                        <div class="panel-body">
                          <div class="row" v-if="product.displayedtype === 'movie'">
                            <div class="col-sm-12">
                              <button type="button" class="btn btn-info filmsearchbutton" v-on:click="findMovie('filmikamari', _('Find in Filmikamari'))"><i class="fa fa-fw fa-external-link"></i> {{ _('Find in Filmikamari') }}</button>
                              <button type="button" class="btn btn-info filmsearchbutton" v-on:click="findMovie('maccsbox', _('Find in MaccsBox'))"><i class="fa fa-fw fa-external-link"></i> {{ _('Find in MaccsBox') }}</button>
                              <button type="button" class="btn btn-info filmsearchbutton" v-on:click="findMovie('tmdb', _('Find in TheMovieDatabase'))"><i class="fa fa-fw fa-external-link"></i> {{ _('Find in TheMovieDatabase') }}</button>
                            </div>
                          </div>
                          <hr class="hide-event show-movie" v-if="product.displayedtype === 'movie'" />
                          <div class="row">
                            <div class="col-sm-6 leftcol">
                              <h4>{{ _('Properties') }}</h4>
                              <div class="form-group">
                                <label for="movieOriginalTitle">{{ _('Original title') }}</label>
                                <input type="text" class="form-control" id="movieOriginalTitle" :placeholder="_('Enter the original title')" v-model="product.channeldata.originaltitle" />
                              </div>
                              <div class="form-group" v-if="!isTheater">
                                <label for="movieDistributor">{{ _('Distributor') }}</label>
                                <select class="form-control" id="movieDistributor" v-model="product.channeldata.distributor">
                                  <option value="-">{{ _('Select') }}</option>
                                  <option v-for="distributor in distributors" :value="distributor.id">{{ distributor.name }}</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <label for="movieDuration">{{ _('Duration') }}</label>
                                <div class="input-group">
                                  <input type="number" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" id="movieDuration" :placeholder="_('Enter the duration')" v-model="product.channeldata.duration" />
                                  <div class="input-group-addon"> {{ _('min') }}</div>
                                </div>
                              </div>
                              <div class="form-group">
                                <label for="movieWebsite">{{ _('Website') }}</label>
                                <input type="text" class="form-control" id="movieWebsite" :placeholder="_('Enter the website URL')" v-model="product.channeldata.website" />
                              </div>
                              <div class="form-group">
                                <label for="movieTrailerUrl">{{ _('Trailer URL') }}</label>
                                <input type="text" class="form-control" id="movieTrailerUrl" :placeholder="_('Enter the URL of the trailer')" v-model="product.channeldata.trailerurl" />
                              </div>
                              <div class="form-group" v-if="product.displayedtype === 'movie'">
                                <label for="movieImdb">{{ _('IMDb') }}</label>
                                <input type="text" class="form-control" id="movieImdb" :placeholder="_('Enter the IMDb id of the movie')" v-model="product.channeldata.imdb" />
                              </div>
                              <div class="form-group" v-if="product.displayedtype === 'movie'">
                                <label for="movieFilmikamari">{{ _('Filmikamari ID') }}</label>
                                <input type="text" class="form-control" id="movieFilmikamari" :placeholder="_('Enter the Filmikamari id of the movie')" v-model="product.channeldata.filmikamari" />
                              </div>
                            </div>
                            <div class="col-sm-6 rightcol" v-if="product.displayedtype === 'movie'">
                              <h4>{{ _('MaccsBox') }}</h4>
                              <div class="form-group">
                                <label for="movieMaccsboxTitle">{{ _('MaccsBox title') }}</label>
                                <input type="text" class="form-control" id="movieMaccsboxTitle" :placeholder="_('Find the movie in MaccsBox')" v-model="product.channeldata.maccsboxtitle" />
                              </div>
                              <div class="form-group">
                                <label for="movieMaccsboxId">{{ _('MaccsBox ID') }}</label>
                                <input type="text" class="form-control" id="movieMaccsboxId" :placeholder="_('Find the movie in MaccsBox')" v-model="product.channeldata.maccsboxid" />
                              </div>
                              <div class="form-group" v-if="product.channeldata.maccsboxref">
                                <label for="movieMaccsboxRef">{{ _('Assigned film reference') }}</label>
                                <p id="movieMaccsboxRef">{{ product.channeldata.maccsboxref }}</p>
                                <button class="btn btn-primary" @click="clearMovieReference()">{{ _('Reset the film reference')}}</button>
                              </div>
                              <div class="form-group">
                                <div class="input-group" id="movieMaccsboxVersions">
                                  <label>{{ _('Version information') }}</label>
                                  <div>
                                    <div class="checkbox"><label class="radiolabel"><input class="maccsboxversioncheckbox" type="checkbox" v-model="channelAttributes" value="2d" /> {{ _('2D') }}</label></div>
                                    <div class="checkbox"><label class="radiolabel"><input class="maccsboxversioncheckbox" type="checkbox" v-model="channelAttributes" value="3d" /> {{ _('3D') }}</label></div>
                                    <div class="checkbox"><label class="radiolabel"><input class="maccsboxversioncheckbox" type="checkbox" v-model="channelAttributes" value="hfr" /> {{ _('HFR') }}</label></div>
                                    <div class="checkbox"><label class="radiolabel"><input class="maccsboxversioncheckbox" type="checkbox" v-model="channelAttributes" value="2k" /> {{ _('2K') }}</label></div>
                                    <div class="checkbox"><label class="radiolabel"><input class="maccsboxversioncheckbox" type="checkbox" v-model="channelAttributes" value="4k" /> {{ _('4K') }}</label></div>
                                  </div>
                                </div>
                              </div>	
                              <div class="form-group">
                                <label for="movieMaccsboxLanguage">{{ _('Language') }}</label>
                                <select class="form-control" id="movieMaccsboxLanguage" v-model="product.channeldata.maccsboxlanguage">
                                  <option value="-">{{ _('Select') }}</option>
                                  <option value="OV">{{ _('Original') }} (OV)</option>
                                  <option value="EN">{{ _('English') }} (EN)</option>
                                  <option value="FR">{{ _('French') }} (FR)</option>
                                  <option value="SE">{{ _('Swedish') }} (SE)</option>
                                  <option value="DE">{{ _('German') }} (DE)</option>
                                  <option value="FI">{{ _('Finnish') }} (FI)</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <label for="movieMaccsboxSubtitles">{{ _('Subtitles') }}</label>
                                <select class="form-control" id="movieMaccsboxSubtitles" v-model="product.channeldata.maccsboxsubtitles">
                                  <option value="-">{{ _('Select') }}</option>
                                  <option value="XX">{{ _('No subtitles') }} (XX)</option>
                                  <option value="EN">{{ _('English') }} (EN)</option>
                                  <option value="SE">{{ _('Swedish') }} (SE)</option>
                                  <option value="FI">{{ _('Finnish') }} (FI)</option>
                                  <option value="FI-SE">{{ _('Finnish-Swedish') }} (FI-SE)</option>
                                  <option value="FI-EN">{{ _('Finnish-English') }} (FI-EN)</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <hr v-if="product.displayedtype === 'movie'" />
                          <div class="row">
                            <div class="col-md-6 leftcol">
                              <h4>{{ _('Details') }}</h4>
                              <div class="form-group">
                                <label for="movieAgeLimit">{{ _('Age limit') }}</label>
                                <select class="form-control" id="movieAgeLimit" v-model="product.channeldata.agelimit">
                                  <option value="-">{{ _('Select') }}</option>
                                  <option value="S">{{ _('Suitable for all ages') }} (S)</option>
                                  <option value="K-7">{{ _('Over 7 years') }} (K-7)</option>
                                  <option value="K-12">{{ _('Over 12 years') }} (K-12)</option>
                                  <option value="K-16">{{ _('Over 16 years') }} (K-16)</option>
                                  <option value="K-18">{{ _('Adults only') }} (K-18)</option>
                                </select>
                              </div>
                              <div class="form-group" v-if="isMovie">
                                <div class="input-group">
                                  <label>{{ _('Content ratings') }}</label>
                                  <div>
                                    <label class="radiolabel"><input class="contentratingcheckbox" type="checkbox" v-model="channelAttributes" value="violent" /> {{ _('Violent content') }}</label><br />
                                    <label class="radiolabel"><input class="contentratingcheckbox" type="checkbox" v-model="channelAttributes" value="sexual" /> {{ _('Sexual content') }}</label><br />
                                    <label class="radiolabel"><input class="contentratingcheckbox" type="checkbox" v-model="channelAttributes" value="disturbing" /> {{ _('Disturbing content') }}</label><br />
                                    <label class="radiolabel"><input class="contentratingcheckbox" type="checkbox" v-model="channelAttributes" value="drugs" /> {{ _('Drugs/alcohol use') }}</label><br />
                                  </div>
                                </div>
                              </div>
                              <div class="form-group" v-if="product.displayedtype === 'movie'" >
                                <label>{{ _('Genres') }}</label>
                                <div>
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="animation" /> {{ _('animation') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="anime" /> {{ _('anime') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="documentary" /> {{ _('documentary') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="drama" /> {{ _('drama') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="dubbed" /> {{ _('dubbed') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="fantasy" /> {{ _('fantasy') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="suspense" /> {{ _('suspense') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="horror" /> {{ _('horror') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="family" /> {{ _('family') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="comedy" /> {{ _('comedy') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="domestic" /> {{ _('domestic') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="music" /> {{ _('music') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="musical" /> {{ _('musical') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="original" /> {{ _('original') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="romantic drama" /> {{ _('romantic drama') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="romantic comedy" /> {{ _('romantic comedy') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="scifi" /> {{ _('scifi') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="adventure" /> {{ _('adventure') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="war" /> {{ _('war') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="action" /> {{ _('action') }}</label><br />
                                  <label class="radiolabel"><input class="genrecheckbox" type="checkbox" v-model="channelCategories" value="western" /> {{ _('western') }}</label><br />
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 rightcol" v-if="product.displayedtype === 'movie'">
                              <h4>&nbsp;</h4>
                              <div class="form-group">
                                <label for="movieExtraInfo">{{ _('Extra information') }}</label>
                                <textarea id="movieExtraInfo" class="form-control" rows="4" wrap="virtual" v-model="product.channeldata.furtherinformation"></textarea>
                              </div>
                              <div class="form-group">
                                <label for="movieDirector">{{ _('Director') }}</label>
                                <input type="text" class="form-control" id="movieDirector" :placeholder="_('Enter the name of the movie director')" v-model="product.channeldata.director" />
                              </div>
                              <div class="form-group">
                                <label for="movieScript">{{ _('Script') }}</label>
                                <input type="text" class="form-control" id="movieScript" :placeholder="_('Enter the name of the movie script writer')" v-model="product.channeldata.script" />
                              </div>
                              <div class="form-group">
                                <label for="movieActors">{{ _('Actors') }}</label>
                                <textarea id="movieActors" class="form-control" rows="4" wrap="virtual" v-model="product.channeldata.actors"></textarea>
                              </div>
                              <div class="form-group">
                                <label for="movieMaterialNotes">{{ _('Material notes') }}</label>
                                <textarea id="movieMaterialNotes" class="form-control" rows="4" wrap="virtual" v-model="product.channeldata.materialnotes"></textarea>
                              </div>
                              <div class="form-group">
                                <label for="movieCreditsMisc">{{ _('Miscellaneous credits') }}</label>
                                <textarea id="movieCreditsMisc" class="form-control" rows="4" wrap="virtual" v-model="product.channeldata.creditsmisc"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>	
                  
                  <div class="panel panel-default reservablePanel hide-sellable hide-activity hide-event show-reservable" v-if="isReservable && !isEvent && !isActivity && hasAccommodationFields">
                    <div class="panel-heading" role="tab" id="headingThree">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('three')" aria-controls="collapseThree" v-on:click="togglePanel('three')">
                          <span class="title-text">{{ _('Properties') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseThree" class="panel-collapse" role="tabpanel" aria-labelledby="headingThree" v-if="isPanelOpen('three')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-6 panel-column">
                              <h4>{{ _('Restrictions') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <span>{{ _('Pets') }}</span><br />
                                  <label class="radiolabel"><input class="petscheckbox" type="checkbox" :checked="channelAttributes.includes('pets')" v-on:change="setExclusiveChannelAttribute('pets', 'nopets', $event.target.checked)" /> {{ _('Allowed') }}</label>&nbsp;&nbsp;&nbsp;
                                  <label class="radiolabel"><input class="petscheckbox" type="checkbox" :checked="channelAttributes.includes('nopets')" v-on:change="setExclusiveChannelAttribute('nopets', 'pets', $event.target.checked)" /> {{ _('Not allowed') }}</label><br /><br />
                                </div>
                                <div class="input-group">
                                  <span>{{ _('Smoking') }}</span><br />
                                  <label class="radiolabel"><input class="smokingcheckbox" type="checkbox" :checked="channelAttributes.includes('smoking')" v-on:change="setExclusiveChannelAttribute('smoking', 'nosmoking', $event.target.checked)" /> {{ _('Allowed') }}</label>&nbsp;&nbsp;&nbsp;
                                  <label class="radiolabel"><input class="smokingcheckbox" type="checkbox" :checked="channelAttributes.includes('nosmoking')" v-on:change="setExclusiveChannelAttribute('nosmoking', 'smoking', $event.target.checked)" /> {{ _('Not allowed') }}</label><br />
                                </div>
                              </div>
                              <h4>{{ _('Entertainment') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="internet" /> {{ _('Internet connection') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="tv" /> {{ _('TV') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="cable" /> {{ _('Satellite or cable TV') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="radio" /> {{ _('Radio') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="cd" /> {{ _('CD player') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="dvd" /> {{ _('DVD player') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="bluray" /> {{ _('Blu-ray player') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="computer" /> {{ _('Computer') }}</label><br />
                                </div>
                              </div>
                              <h4>{{ _('Kitchen equipment') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="toaster" /> {{ _('Toaster') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="blender" /> {{ _('Blender') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="stove" /> {{ _('Stove') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="oven" /> {{ _('Oven') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="coffee" /> {{ _('Coffee machine') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="waterboiler" /> {{ _('Electric water boiler') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="cooking" /> {{ _('Cooking equipment') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="refrigerator" /> {{ _('Refrigerator') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="freezer" /> {{ _('Freezer') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="cooler" /> {{ _('Cooler') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="microwave" /> {{ _('Microwave oven') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="dishwasher" /> {{ _('Dish washer') }}</label><br />
                                </div>
                              </div>
                              <div class="form-group">
                                <label for="numberofkitchensets">{{ _('Number of kitchen sets') }}</label>
                                <input type="text" class="form-control" id="numberOfKitchenSets" :placeholder="_('Enter the number of kitchen sets')" v-model="product.channeldata.numberofkitchensets" />
                              </div>
                              <div class="form-group languageversioned">
                                <label for="channel_kitcheninformation">{{ _('Kitchen description') }}</label>
                                <textarea id="kitchenInformation" class="form-control" rows="5" wrap="virtual" v-model="product.channeldata.kitcheninformation"></textarea>
                              </div>
                              <h4>{{ _('Facilities') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="fireplace" /> {{ _('Fireplace') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="washingmachine" /> {{ _('Washing machine') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="bathtub" /> {{ _('Bath tub') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="hottub" /> {{ _('Hot tub') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="shower" /> {{ _('Shower') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="indoorsauna" /> {{ _('Indoor sauna') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="outdoorsauna" /> {{ _('Outdoor sauna') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="saunaonshore" /> {{ _('Sauna on shore') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="smokesauna" /> {{ _('Smoke sauna') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="steamsauna" /> {{ _('Steam sauna') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="publicsauna" /> {{ _('Public sauna') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="wc" /> {{ _('WC') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="outhouse" /> {{ _('Outhouse') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="dryer" /> {{ _('Dryer') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="dryercloset" /> {{ _('Dryer closet') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="floorheating" /> {{ _('Floor heating') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="iron" /> {{ _('Iron and ironing board') }}</label><br />
                                </div>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="channel_featuredescription">{{ _('Feature description') }}</label>
                                <textarea id="featureDescription" class="form-control" name="channel_featuredescription" rows="5" wrap="virtual" v-model="product.channeldata.featuredescription"></textarea>
                              </div>
                            </div>
                            <div class="col-sm-6 panel-column">
                              <h4>{{ _('Garden equipment') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="barbeque" /> {{ _('Barbeque') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="garden" /> {{ _('Garden') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="terrace" /> {{ _('Terrace') }}</label><br />
                                </div>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="channel_yarddescription">{{ _('Yard description') }}</label>
                                <textarea id="yardDescription" class="form-control" name="channel_yarddescription" rows="5" wrap="virtual" v-model="product.channeldata.yarddescription"></textarea>
                              </div>
                              <h4>{{ _('Shore') }}</h4>
                              <div class="form-group">
                                <label for="shoretype">{{ _('Shore type') }}</label>
                                <select class="form-control" id="shoreType" v-model="product.channeldata.shoretype">
                                  <option value="">-</option>
                                  <option value="lake">{{ _('lake') }}</option>
                                  <option value="pond">{{ _('pond') }}</option>
                                  <option value="river">{{ _('river') }}</option>
                                  <option value="sea">{{ _('sea') }}</option>
                                </select>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="shoredescription">{{ _('Shore description') }}</label>
                                <textarea id="shoreDescription" class="form-control" rows="5" wrap="virtual" v-model="product.channeldata.shoredescription"></textarea>
                              </div>
                              <h4>{{ _('Accessibility') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="carnecessary" /> {{ _('Car necessary') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="weelchairaccessible" /> {{ _('Wheelchair-accessible') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="suitableforchildren" /> {{ _('Suitable for children') }}</label><br />
                                </div>
                              </div>
                              <h4>{{ _('Car') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="carsocketslot" /> {{ _('Socket slot') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="parkingsquare" /> {{ _('Parking square') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="carshelter" /> {{ _('Car shelter') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="garage" /> {{ _('Garage') }}</label><br />
                                </div>
                              </div>
                              <h4>{{ _('Activities') }}</h4>
                              <div class="form-group">
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="fishing" /> {{ _('Fishing') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="downhillskiing" /> {{ _('Downhill skiing') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="crosscountryskiing" /> {{ _('Cross-country skiing') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="hiking" /> {{ _('Hiking') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="canoeing" /> {{ _('Canoeing') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="horsebackriding" /> {{ _('Horseback riding') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="swimming" /> {{ _('Swimming') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="diving" /> {{ _('Diving') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="tennis" /> {{ _('Tennis') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="golf" /> {{ _('Golf') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="picking" /> {{ _('Picking mushrooms / berries') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="biking" /> {{ _('Biking') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="iceskating" /> {{ _('Ice skating') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="rollerskating" /> {{ _('Roller skating') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="hunting" /> {{ _('Hunting') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="waterskiing" /> {{ _('Water skiing') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="motorsledging" /> {{ _('Motor sledging') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="boating" /> {{ _('Boating') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="sightseeing" /> {{ _('Sightseeing') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="activitiesforchildren" /> {{ _('Activities for children') }}</label><br />
                                </div>
                                <div class="input-group">
                                  <label class="radiolabel"><input type="checkbox" v-model="channelAttributes" value="spa" /> {{ _('Spa') }}</label><br />
                                </div>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="activitiesdescription">{{ _('Activities description') }}</label>
                                <textarea id="activitiesDescription" class="form-control" rows="5" wrap="virtual" v-model="product.channeldata.activitiesdescription"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  
                  <div class="panel panel-default reservablePanel" v-if="isReservable && !isActivity && !isEvent">
                    <div class="panel-heading" role="tab" id="headingFour">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('four')" aria-controls="collapseFour" v-on:click="togglePanel('four')">
                          <span class="title-text">{{ _('Transportation and distances') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseFour" class="panel-collapse" role="tabpanel" aria-labelledby="headingFour" v-if="isPanelOpen('four')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-6 panel-column">
                              <h4>{{ _('Distances') }}</h4>
                              <div class="well">
                                {{ _('Add distances to nearby locations by clicking the button below.') }}
                              </div>
                              <table class="table table-striped sortable" v-if="product.ownDistance && product.ownDistance.length">
                                <thead>
                                  <tr>
                                    <th>{{ _('Location') }}</th>
                                    <th>{{ _('Distance') }}</th>
                                  </tr>
                                </thead>
                                <tbody class="distances" id="distances">
                                  <tr v-for="distance in product.ownDistance" class="distance" v-on:click="editDistance(distance)">
                                    <td>{{ distance.name }}</td>
                                    <td>{{ distance.distance }} {{ distance.unit }}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <button class="adddistance btn btn-success" id="addDistanceButton" type="button" v-on:click="addDistance"><i class="fa fa-fw fa-plus"></i> {{ _('Add distance') }}</button>
                            </div>
                            <div class="col-sm-6 panel-column">
                              <h4>{{ _('Additional information') }}</h4>
                              <div class="form-group languageversioned">
                                <label for="serviceinformation">{{ _('Services') }}</label>
                                <textarea id="serviceInformation" class="form-control" rows="5" wrap="virtual" v-model="product.channeldata.serviceinformation"></textarea>
                              </div>					
                              <div class="form-group languageversioned">
                                <label for="trafficconnections">{{ _('Traffic connections') }}</label>
                                <textarea id="trafficConnections" class="form-control" rows="5" wrap="virtual" v-model="product.channeldata.trafficconnections"></textarea>
                              </div>					
                              <div class="form-group languageversioned">
                                <label for="drivinginstructions">{{ _('Driving instructions') }}</label>
                                <textarea id="drivingInstructions" class="form-control" rows="5" wrap="virtual" v-model="product.channeldata.drivinginstructions"></textarea>
                              </div>					
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  
                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="headingFive">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('five')" aria-controls="collapseFive" v-on:click="togglePanel('five')">
                          <span class="title-text">{{ _('Tags') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseFive" class="panel-collapse" role="tabpanel" aria-labelledby="headingFive" v-if="isPanelOpen('five')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <div class="input-group flex-input-group">
                                  <model-list-select :list="allSelectableProductTags" option-value="id" option-text="title" v-model="productTagToAdd" :custom-text="formatProductTag" :placeholder="_('Type to search tags')" @searchchange="productTagSearchChanged" @update:modelValue="addProductTagWithId">
                                  </model-list-select>
                                  <span class="input-group-btn">
                                    <button type="button" class="btn btn-info tagsmanagement" v-on:click="manageTagsDialog('product')"><i class="fa fa-fw fa-tags"></i> {{ _('Manage tags') }}</button>
                                  </span>
                                </div>
                              </div>
                              <div class="form-group" v-if="versionlessProductTags.length">
                                <h5>{{ _('Tags used in any language version') }}:</h5>
                                <div id="tagsList">
                                  <span v-for="tag in versionlessProductTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                                </div>
                              </div>
                              <div class="form-group" v-if="currentVersionProductTags.length">
                                <h5>{{ _('Tags used only in the selected language version') }}:</h5>
                                <div id="tagsList">
                                  <span v-for="tag in currentVersionProductTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                                </div>
                              </div>
                              <div class="form-group" v-if="otherVersionProductTags.length">
                                <h5>{{ _('Tags used in other language versions') }}:</h5>
                                <div id="tagsList">
                                  <span v-for="tag in otherVersionProductTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-6" style="min-height: 150px"></div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <h3>{{ _('Saleschannel tags') }}</h3>
                            </div>
                            <div class="col-sm-4" v-for="(tagArr, channel) in johkuSalesChannelTags">
                              <h4>{{ channel }}</h4>
                              <div class="checkbox" v-for="tagRow in tagArr">
                                <label>
                                  <input type="checkbox" class="tag-checkbox" :data-tag="'product:::' + tagRow.title" v-on:input="productTagChanged(tagRow.title, $event.target.checked)" :checked="isSalesChannelTagChecked(tagRow.title)">{{ tagRow.title.split(':::')[1] }}<br />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="headingSix">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('six')" aria-controls="collapseSix" v-on:click="togglePanel('six')">
                          <span class="title-text">{{ _('SEO') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseSix" class="panel-collapse" role="tabpanel" aria-labelledby="headingSix" v-if="isPanelOpen('six')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group languageversioned">
                                <label for="pagetitle">{{ _('Page title') }}</label>
                                <input type="text" class="form-control" id="pagetitle" v-model="product.pagetitle" />
                              </div>
                              <div class="form-group">
                                <label for="seoTags">{{ _('SEO Tags') }}</label>
                                <div class="input-group flex-input-group">
                                  <model-list-select id="seoTags" :list="allSelectableSeoTags" option-value="id" option-text="title" v-model="seoTagToAdd" :custom-text="formatProductTag" :placeholder="_('Type to search tags')" @searchchange="seoTagSearchChanged" @update:modelValue="addSeoTagWithId">
                                  </model-list-select>
                                  <span class="input-group-btn">
                                    <button type="button" class="btn btn-info tagsmanagement" v-on:click="manageTagsDialog('seo')"><i class="fa fa-fw fa-tags"></i> {{ _('Manage tags') }}</button>
                                  </span>
                                </div>
                              </div>
                              <div class="form-group" v-if="versionlessSeoTags.length">
                                <h5>{{ _('Tags used in any language version') }}:</h5>
                                <div id="tagsList">
                                  <span v-for="tag in versionlessSeoTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                                </div>
                              </div>
                              <div class="form-group" v-if="currentVersionSeoTags.length">
                                <h5>{{ _('Tags used only in the selected language version') }}:</h5>
                                <div id="tagsList">
                                  <span v-for="tag in currentVersionSeoTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                                </div>
                              </div>
                              <div class="form-group" v-if="otherVersionSeoTags.length">
                                <h5>{{ _('Tags used in other language versions') }}:</h5>
                                <div id="tagsList">
                                  <span v-for="tag in otherVersionSeoTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                                </div>
                              </div>
                              <p>{{ _('SEO Tags are used in Johku Storefront in the metadata that is shown to search engines.') }}</p>
                              <div class="form-group languageversioned">
                                <label>{{ _('Published') }}</label>
                                <DatePicker v-model="seoDatePublished" :shortLocale="shortLocale" :staticInput="true" :time-picker="true" :time-picker-inline="true" :clearable="true" :placeholder="_('Select date')" field="datepublished"></DatePicker>
                              </div>
                              <div class="form-group languageversioned">
                                <label>{{ _('Last modified') }}</label>
                                <DatePicker v-model="seoDateModified" :shortLocale="shortLocale" :staticInput="true" :time-picker="true" :time-picker-inline="true" :clearable="true" :placeholder="_('Select date')" field="datemodified"></DatePicker>
                              </div>
                              <div class="form-group languageversioned">
                                <label for="datedisplay">{{ _('Date display') }}</label>
                                <select class="form-control" id="datedisplay" v-model="seoDateDisplay">
                                  <option value="">{{ _('Hidden') }}</option>
                                  <option value="published">{{ _('Published date only') }}</option>
                                  <option value="modified">{{ _('Last modified date only') }}</option>
                                  <option value="both">{{ _('Both published & modified') }}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-6" style="min-height: 150px">
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="headingSeven">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="javascript:;" :aria-expanded="isPanelOpen('seven')" aria-controls="collapseSeven" v-on:click="togglePanel('seven')">
                          <span class="title-text">{{ _('Terms and required customer information') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseSeven" class="panel-collapse" role="tabpanel" aria-labelledby="headingSeven" v-if="isPanelOpen('seven')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="requiredInformation">{{ _('Required customer information') }}</label>
                                <select class="form-control" id="requiredInformation" v-model="product.requiredinfo">
                                  <option value="minimal">{{ _('Name and email') }}</option>
                                  <option value="minimalphone">{{ _('Name, email and phone') }}</option>
                                  <option value="default">{{ _('Full details') }}</option>
                                  <option v-if="isFeatureEnabled('strongauthentication') || product.requiredinfo === 'authentication'" value="authentication">{{ _('Strong authentication') }} (€)</option>
                                </select>
                              </div>
                              <p><i>{{ _('You can optionally set the level of customer information required to be able to purchase the product.') }} {{ _('If there are products in the basket with different requirement levels, the largest requirement will be used.') }}</i></p>
                              <p v-if="product.requiredinfo === 'authentication'"><i><strong>{{ _('Strong authentication is a paid feature, priced per authentication attempt.') }}</strong></i></p>
                              <a v-if="product.requiredinfo === 'authentication'" href="https://johku.fi/fi/hinnatjapalvelut" target="_blank"><i>{{ _('Pricing') }}</i></a>
                            </div>
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label>{{ _('Product-specific terms') }}</label>
                                <div class="input-group flex-input-group">
                                  <select class="form-control" id="productTerms" v-model="product.terms_id">
                                    <option :value="null">{{ _('No terms selected') }}</option>
                                    <option v-for="termsOption in termsOptions" :value="termsOption.id">{{ termsOption.name }}</option>
                                  </select>
                                  <span class="input-group-btn">
                                    <button type="button" class="btn btn-info termsmanagement" v-on:click="manageTermsDialog">{{ _('Manage terms') }}</button>
                                  </span>
                                </div>
                              </div>
                              <div class="checkbox">
                                <label>
                                <input type="checkbox" v-model="product.disable_orderrequest_cancellation" true-value="1" false-value="0" />
                                {{ _('Disable cancellation requests') }}
                                </label>
                              </div>
                              <div class="checkbox">
                                <label>
                                <input type="checkbox" v-model="product.disable_orderrequest_move" true-value="1" false-value="0" />
                                {{ _('Disable move requests') }}
                                </label>
                              </div>
                              <div class="form-group">
                                <label>{{ _('Product-specific form') }}</label>
                                <div class="input-group flex-input-group">
                                  <select class="form-control" id="productForm" v-model="product.form_id" :disabled="!isFeatureEnabled('forms')">
                                    <option :value="null">{{ _('No form selected') }}</option>
                                    <option v-for="formOption in formOptions" :value="formOption.id">{{ formOption.name }}</option>
                                  </select>
                                  <span class="input-group-btn">
                                    <button type="button" class="btn btn-info formsmanagement" v-on:click="manageFormsDialog" :disabled="!isFeatureEnabled('forms')">{{ _('Manage forms') }}</button>
                                  </span>
                                </div>
                                <p><i>{{ _('You can optionally select a form that the customer will be required to fill when purchasing the product.') }}</i></p>
                                <p v-if="!isFeatureEnabled('forms')"><i><strong>{{ _('Forms are a paid feature. Please contact customer support to enable them.') }}</strong></i></p>
                                <a v-if="!isFeatureEnabled('forms')" href="https://johku.fi/fi/hinnatjapalvelut" target="_blank"><i>{{ _('Pricing') }}</i></a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('prices')" class="tab-pane active" id="prices" v-if="isTabActive('prices')" key="prices">
            <div class="pricing-tab-header">
              <div class="form-group pricing-tab-heading">
                <h3>{{ _('Pricing') }}</h3>
              </div>
              <div v-if="showAllFields && (parseInt(product.subtype, 10) !== SUBTYPE_TICKET || parseInt(hidePricing, 10) !== PRICING_NORMAL)" class="form-group pricing-mode-field">
                <select class="form-control" id="hidePricing" name="hide_pricing" v-model="hidePricing">
                  <option :value="PRICING_NORMAL">{{ _('Normal pricing') }}</option>
                  <option v-if="isActivity" :value="PRICING_TICKET">{{ _('Ticket pricing') }}</option>
                  <option :value="PRICING_SHOW_OPEN_ALLOWPAYMENT">{{ _('Open order') }} ({{ _('Allow payment') }})</option>
                  <option :value="PRICING_SHOW_OPEN">{{ _('Open order') }} ({{ _('Show pricing') }})</option>
                  <option :value="PRICING_HIDE_OPEN">{{ _('Open order') }} ({{ _('Hide pricing') }})</option>
                  <option :value="PRICING_SHOW_CONFIRMED">{{ _('Confirmed order') }} ({{ _('Show pricing') }})</option>
                  <option :value="PRICING_HIDE_CONFIRMED">{{ _('Confirmed order') }} ({{ _('Hide pricing') }})</option>
                  <option v-if="isReservable" :value="PRICING_DISABLED">{{ _('Prevent reservations') }}</option>
                  <option v-else :value="PRICING_DISABLED">{{ _('Disable purchasing') }}</option>
                </select>
              </div>
            </div>
            <div id="ticketPricing" v-if="isEvent">
              <div class="row">
                <div class="col-sm-9 leftcol">
                  <div class="form-group">
                    <div class="well">
                      {{ _('Event pricing is done by selecting a default pricing model for the product and optionally selecting a specific pricing model for individual shows.') }}
                      {{ _('Each pricing model contains one or more available ticket types, which can be set as user-selectable or automatically selected.') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 leftcol">
                  <div class="form-group">
                    <label for="defaultProductPricing">{{ _('Default pricing') }}</label>
                    <div class="input-group">
                      <select class="form-control" id="defaultProductPricing" v-model="product.pricing_id">
                        <option v-for="pricingOption in pricingOptions" :value="pricingOption.id">{{ pricingOption.name }}</option>
                      </select>
                      <span class="input-group-btn">
                        <button type="button" class="btn btn-info pricingmanagement" v-on:click="managePricingDialog">{{ _('Manage pricing') }}</button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <showtimes-calendar :column="column" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :resourceSelector="false" :productSelector="false" :product="product" />
              <hr />
              <div class="row" v-if="parseInt(product.subtype, 10) !== SUBTYPE_TICKET">
                <div class="col-xs-6">
                  <div class="form-group languageversioned">
                    <label for="buttontext">{{ _('Action button text') }}</label>
                    <input type="text" class="form-control" id="buttonText" name="buttontext" :placeholder="_('Enter an optional custom text for the action button')" v-model="product.buttontext" />
                  </div>
                </div>
              </div>
            </div>
            <div id="simplePricing" v-if="isSellable">
              <div class="row" id="voucherLinkerContainer" v-if="isValuecard || isExchangedValuecard">
                <div class="col-xs-12 col-md-6">
                  <h4>{{ _('Voucher') }}</h4>
                  <div class="form-group form-inline">
                    <select class="form-control" name="vouchers" id="voucherCount" v-model="product.vouchers" v-if="isVoucherCountAvailable">
                      <option v-for="vouchercount in 100" :value="vouchercount">{{ vouchercount }} x</option>
                    </select>
                    <select class="form-control" name="voucher_id" id="voucherId" v-model="product.voucher_id">
                      <option value="">{{ _('Select') }}</option>
                      <option v-for="voucher in vouchers" :value="voucher.id">{{ voucher.name }} ({{ voucher.value }} {{ settings.currency }})</option>
                    </select>
                  </div>
                  <button style="margin-bottom: 10px" type="button" class="btn btn-info vouchermanagement" v-on:click="manageVouchersDialog">{{ _('Manage vouchers') }}</button>
                  <p>{{ _('Select the voucher that will be used when paying for items with this value card and how many vouchers will be included.') }}</p>
                </div>
                <div class="col-xs-12 col-md-6">
                  <h4>{{ _('Validity') }}</h4>
                  <div class="form-group">
                    <div class="radio">
                      <label><input type="radio" id="validUnlimited" name="validity" v-model="voucherValidity" value="unlimited" /> {{ _('Unlimited') }}</label>
                    </div>
                    <div class="radio">
                      <label><input type="radio" id="validDuration" name="validity" v-model="voucherValidity" value="duration" /> {{ _('Fixed duration from purchase') }}</label>
                    </div>
                    <div class="durationselector-container form-inline" v-if="voucherValidity === 'duration'">
                      <select class="form-control" id="voucherDurationStart" v-model="voucherDurationStart">
                        <option v-for="number in 100" :value="'+' + number">{{ number }}</option>
                      </select>
                      <select class="form-control" id="voucherDurationEnd" v-model="voucherDurationEnd">
                        <option value="days">{{ _('days') }}</option>
                        <option value="weeks">{{ _('weeks') }}</option>
                        <option value="months">{{ _('months') }}</option>
                        <option value="years">{{ _('years') }}</option>
                      </select>
                    </div>
                    <div class="radio">
                      <label><input type="radio" id="validRange" name="validity" v-model="voucherValidity" value="range" /> {{ _('Specified date range') }}</label>
                    </div>
                    <div class="dateselector-containe form-inline" v-if="voucherValidity === 'range'">
                      <div class="form-group form-group-inline">
                        <DatePicker v-model="voucherStart" :shortLocale="shortLocale" :placeholder="_('Select date')" :staticInput="true"></DatePicker>
                      </div>
                      <div class="form-group form-group-inline">
                        <p class="form-control-static">&nbsp;-&nbsp;</p>
                      </div>
                      <div class="form-group form-group-inline">
                        <DatePicker v-model="voucherEnd" :shortLocale="shortLocale" :placeholder="_('Select date')" :staticInput="true"></DatePicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr id="voucherLinkerSpacer" v-if="isValuecard || isExchangedValuecard" />
              <div class="row">
                <div class="col-lg-6 leftcol">
                  <div class="form-group">
                    <label v-if="isOpenValueCard">{{ _('Default price (inc. vat)') }}</label>
                    <label v-else>{{ _('Unit price (inc. vat)') }}</label>
                    <div class="input-group">
                      <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" id="stdPrice" :placeholder="_(isOpenValueCard ? 'Enter default price' : 'Enter unit price')" v-model="product.price" />
                      <div class="input-group-addon"> {{ currencySymbol(settings.currency) }}</div>
                    </div>
                  </div>
                  <div class="form-group" v-if="isOpenValueCard">
                    <label>{{ _('Minimum price (inc. vat)') }}</label>
                    <div class="input-group">
                      <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" id="stdPrice" :placeholder="_('Enter minimum price')" v-model="product.minprice" />
                      <div class="input-group-addon"> {{ currencySymbol(settings.currency) }}</div>
                    </div>
                  </div>
                  <div class="form-group" v-if="isOpenValueCard">
                    <label>{{ _('Maximum price (inc. vat)') }}</label>
                    <div class="input-group">
                      <input type="number" data-android-inputmode="decimal" step="any" :lang="numberLocale" class="form-control" id="maxPrice" :placeholder="_('Enter maximum price')" v-model="product.maxprice" />
                      <div class="input-group-addon"> {{ currencySymbol(settings.currency) }}</div>
                    </div>
                  </div>
                  <div id="voucherPriceWarning" class="alert alert-danger" v-if="showVoucherPriceWarning">
                    <p><button type="button" class="btn btn-default pull-right" id="setSuggestedPrice" v-on:click="setSuggestedPrice"><i class="fa fa-fw fa-check"></i> {{ _('Set') }}</button></p>
                    <p>{{ _('The price of the value card should be equal to the price of the voucher multiplied by the number of vouchers selected in the availability page.') }} <span id="suggestedPrice"></span></p>
                  </div>
                </div>
                <div class="col-lg-6 rightcol">
                  <div class="hidden-lg">&nbsp;</div>
                  <div class="form-group">
                    <label>{{ _('Value added tax') }}</label>
                    <select class="form-control" id="stdVat" v-model="productVat">
                      <option v-for="vat in vats" :value="vat">{{ formatVat(vat, numberFormat) }} %</option>
                    </select>
                  </div>
                  <div id="voucherVatWarning" class="alert alert-danger" v-if="showVoucherVatWarning">
                    <p><button type="button" class="btn btn-default pull-right" id="setSuggestedVat" v-on:click="setSuggestedVat"><i class="fa fa-fw fa-check"></i> {{ _('Set') }}</button></p>
                    <p>{{ _('The voucher is set as available to use for other merchants, which means that the VAT percentage should be zero.') }}</p>
                  </div>
                </div>
              </div>
              <div class="row" v-if="showAllFields && parseInt(product.subtype, 10) !== SUBTYPE_TICKET">
                <div class="col-xs-6">
                  <div class="form-group languageversioned">
                    <label for="buttontext">{{ _('Action button text') }}</label>
                    <input type="text" class="form-control" id="buttonText" name="buttontext" :placeholder="_('Enter an optional custom text for the action button')" v-model="product.buttontext" />
                  </div>
                </div>
              </div>
              <div class="row" v-if="showAllFields && parseInt(product.subtype, 10) === SUBTYPE_TICKET">
                <div class="col-lg-6 leftcol">
                  <template v-if="pricings.length">
                    <h3>{{ _('Pricing that uses this ticket') }}</h3>
                    <table class="table table-striped">
                      <thead> </thead>
                      <tbody>
                        <tr v-for="pricing in pricings">
                          <td>{{ pricing.id }}</td>
                          <td>{{ pricing.name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                  <hr v-else />
                  <button class="btn btn-info" v-on:click="managePricingDialog">{{ _('Manage pricing') }}</button>
                </div>
              </div>
              <hr v-if="!isFeatureEnabled('delivery2.0')" />
              <div class="row" v-if="!isFeatureEnabled('delivery2.0')">
                <div class="col-lg-6 leftcol">
                  <div class="form-group">
                    <h3>{{ _('Available delivery methods:') }}</h3>
                  </div>
                  <div class="checkbox" v-for="method in enabledDeliveryMethods">
                    <label for="displayname"><input type="checkbox" v-model="product.sharedDeliverymethod" :value="method" /> {{ method.name }}, {{ method.price }} <span v-html="currencyEntity(settings.currency)"></span></label>
                  </div>
                  <hr />
                  <p>{{ _('All products must share at least one delivery method!') }}</p>
                </div>
              </div>
            </div>
            <div id="dynamicPricing" v-if="isReservable && !isEvent">
              <div class="row" v-if="canUseCalendarEngine || canUseActivityCalendarEngine">
                <div class="col-sm-9 leftcol">
                  <div class="form-group">
                    <select class="form-control" v-model="product.pricing_engine" :aria-label="_('Pricing')" v-on:change="pricingEngineChanged">
                      <option value="pricerow">{{ _('Price rows') }}</option>
                      <option value="calendar" v-if="canUseCalendarEngine">{{ _('Price calendar') }}</option>
                      <option value="activitycalendar" v-if="canUseActivityCalendarEngine">{{ _('Price calendar') }}</option>
                    </select>
                  </div>
                  <div class="well" v-if="isCalendarPricing">
                    {{ calendarPricingIntro }}
                  </div>
                </div>
              </div>
              <calendar-pricing-editor
                v-if="isCalendarPricing"
                :product="product"
                :settings="settings"
                :shopId="shopId"
                :apiKey="apiKey"
                :baseDomain="baseDomain"
                :canEditRates="isSavedAsCalendar"
                :termsOptions="termsOptions"
                :withPlanTerms="isActivityPricingEnabled"
                :pricetiers="product.sharedPricetier || []"
              ></calendar-pricing-editor>
              <div class="row" v-if="!isCalendarPricing">
                <div class="col-sm-9 leftcol">
                  <template v-if="isActivityCalendarPricing">
                    <div class="well">
                      {{ _('Prices are set per weekday and start time, and can be changed or closed for single dates.') }}
                    </div>
                    <div class="form-group">
                      <label for="activityDuration0">{{ activityDurations.length > 1 ? _('Durations') : _('Duration') }}</label>
                      <div class="activity-durations">
                        <div class="input-group activity-duration" v-for="(duration, index) in activityDurations" :key="'ad-' + index">
                          <input type="number" min="1" step="1" class="form-control" :id="'activityDuration' + index" v-model="duration.value" />
                          <span class="input-group-btn">
                            <select class="form-control" v-model="duration.unit" :aria-label="_('Duration')">
                              <option :value="UNIT_MINUTE">{{ _('minutes') }}</option>
                              <option :value="UNIT_HOUR">{{ _('hours') }}</option>
                            </select>
                            <button type="button" class="btn btn-default" v-if="activityDurations.length > 1" :title="_('Remove')" :aria-label="_('Remove')" v-on:click="activityDurations.splice(index, 1)"><i class="fa fa-fw fa-trash"></i></button>
                          </span>
                        </div>
                        <button type="button" class="btn btn-success btn-sm activity-duration-add" v-on:click="activityDurations.push({ value: '', unit: UNIT_HOUR })"><i class="fa fa-fw fa-plus"></i> {{ _('Add duration') }}</button>
                      </div>
                      <p class="help-block">{{ activityDurations.length > 1 ? _('The customer chooses the duration. Each one has prices of its own.') : _('How long each booking lasts.') }}</p>
                    </div>
                    <div class="well" v-if="!isSavedAsActivityCalendar">
                      {{ _('Save the product first to edit the prices of the activity. Prices are edited after saving.') }}
                    </div>
                  </template>
                  <div class="form-group" v-if="!isActivityCalendarPricing">
                    <div class="well">
                      {{ _('Set the pricing of rentable products by adding one or more price rows. Each price row supplements previous rows, so the last one has the highest priority.') }}
                      {{ _('If you define multiple price rows, you can select the default price that gets shown to the customers by clicking on the star in the first column.') }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-3 rightcol">
                  <div class="form-group">
                    <label>{{ _('Value added tax') }}</label>
                    <select class="form-control" id="dynVat" v-model="productVat">
                      <option v-for="vat in vats" :value="vat">{{ vat }} %</option>
                    </select>
                  </div>
                </div>
              </div>
              <activity-rates-editor
                v-if="isActivityCalendarPricing && isSavedAsActivityCalendar"
                :product="product"
                :settings="settings"
                :shopId="shopId"
                :apiKey="apiKey"
                :baseDomain="baseDomain"
                :canEditRates="isSavedAsActivityCalendar"
                :pricetiers="product.sharedPricetier || []"
                :starttimes="activityStartMinutes"
                :termsOptions="termsOptions"
              ></activity-rates-editor>
              <div id="rateplanManagementContainer" v-if="hasPricerowRateplans">
                <div class="row">
                  <div class="col-xs-12">
                    <h3>{{ _('Rates') }}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-8 leftcol">
                    <div class="well" v-if="!product.id">{{ _('Save the product first to add rates.') }}</div>
                    <template v-else>
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>&nbsp;</th><th>{{ _('Name') }}</th><th>{{ _('Terms') }}</th><th>{{ _('Cancellation requests') }}</th><th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!pricerowRateplans.length">
                            <td colspan="5">{{ _('No rates have been added. All price rows apply to every booking.') }}</td>
                          </tr>
                          <tr v-for="rateplan in pricerowRateplans" :key="rateplan.id" style="cursor: pointer">
                            <td class="defaultPricerow" v-on:click.stop="setDefaultRateplan(rateplan)" :title="_('Default rate')"><i :class="'fa fa-fw fa-star ' + (parseInt(rateplan.is_default) ? ' isDefaultPricerow' : '')"></i></td>
                            <td v-on:click="editRateplanDialog(rateplan)">{{ rateplan.title }}</td>
                            <td v-on:click="editRateplanDialog(rateplan)">{{ rateplanTermsName(rateplan) }}</td>
                            <td v-on:click="editRateplanDialog(rateplan)">{{ rateplanCancellationLabel(rateplan) }}</td>
                            <td><a href="javascript:;" class="pull-right" v-on:click.stop="deleteRateplan(rateplan)"><i class="fa fa-fw fa-close"></i></a></td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="btn btn-success" type="button" v-on:click="addRateplanDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Add rate') }}</button>
                    </template>
                  </div>
                  <div class="col-lg-4 rightcol">
                    <p>{{ _('Rates let customers choose between alternatives such as a flexible and a non-refundable price. Each price row applies either to one rate or to all rates.') }}</p>
                    <p>{{ _('Rates are saved immediately.') }}</p>
                  </div>
                </div>
                <hr />
              </div>
              <div class="row" v-if="isActivityCalendarPricing && product.ownPricerow && product.ownPricerow.length">
                <div class="col-xs-12">
                  <p class="help-block">{{ _('The price rows of this product are kept but not used with the activity calendar. They are used again if you switch back to price rows.') }}</p>
                </div>
              </div>
              <div class="row" v-if="!isCalendarPricing && !isActivityCalendarPricing">
                <div class="col-xs-12">
                  <div class="form-inline pricerow-rateplan-filter" v-if="showPricerowRateplans">
                    <div class="form-group">
                      <label for="pricerowRateplanFilter">{{ _('Filter by rate') }}</label>
                      <select class="form-control" id="pricerowRateplanFilter" v-model="pricerowRateplanFilter">
                        <option value="">{{ _('All price rows') }}</option>
                        <option value="none">{{ _('Price rows for all rates') }}</option>
                        <option v-for="rateplan in pricerowRateplans" :value="String(rateplan.id)">{{ rateplan.title }}</option>
                      </select>
                    </div>
                  </div>
                  <table class="table table-striped sortable">
                    <thead>
                      <tr>
                        <th>&nbsp;</th><th>{{ _('Name') }}</th><th v-if="showPricerowRateplans">{{ _('Rate plan') }}</th><th>{{ _('Validity') }}</th><th>{{ _('Price') }}</th><th class="multiselectcol"><input type="checkbox" v-model="pricerowToggle"></th>
                      </tr>
                    </thead>
                    <tbody class="pricerows" id="priceRows" v-if="!product.ownPricerow || !product.ownPricerow.length">
                      <tr>
                        <td :colspan="showPricerowRateplans ? 6 : 5">{{ _('No price rows have been defined.') }}</td>
                      </tr>
                    </tbody>
                    <draggable v-else v-model="product.ownPricerow" tag="tbody" draggable=".pricerow" :delay="100" :delayOnTouchOnly="true">
                      <tr class="pricerow" style="cursor: pointer" v-for="pricerow in product.ownPricerow" v-show="isPricerowVisible(pricerow)">
                        <td class="defaultPricerow" v-on:click.stop="toggleDefaultPricerow(pricerow)"><i :class="'fa fa-fw fa-star ' + (parseInt(pricerow.isdefault) ? ' isDefaultPricerow' : '')"></i></td>
                        <td class="sortable" v-on:click="editPricerow(pricerow)">{{ pricerow.name }}</td>
                        <td class="sortable" v-if="showPricerowRateplans" v-on:click="editPricerow(pricerow)">{{ pricerowRateplanName(pricerow) }}</td>
                        <td class="sortable" v-on:click="editPricerow(pricerow)" v-html="makePricerowDesc(pricerow)"></td>
                        <td class="sortable" v-on:click="editPricerow(pricerow)" v-html="makePricerowPriceDesc(pricerow)"></td>
                        <td class="multiselectcol"><input type="checkbox" v-model="selectedPricerows" :value="pricerow.id" /></td>
                      </tr>
                    </draggable>
                  </table>
                  <button class="addpricerow btn btn-success" v-on:click="addPricerow" type="button"><i class="fa fa-fw fa-plus"></i> <span class="hidden-xs">{{ _('Add price row') }}</span><span class="visible-xs-inline">{{ _('Add') }}</span></button>
                  <button v-if="parseInt(product.hide_pricing) === PRICING_TICKET" type="button" class="btn btn-info pricingmanagement" v-on:click="managePricingDialog"><span class="hidden-xs">{{ _('Manage pricing') }}</span><span class="visible-xs-inline">{{ _('Manage') }}</span></button>
                  <!-- <button class="copypricerows btn btn-info" v-on:click="copyPricerows" type="button"><i class="fa fa-fw fa-clone"></i> {{ _('Copy price rows') }}</button> -->
                  <button class="modifypricerows btn btn-primary pull-right" v-on:click="modifyPricerows" type="button" v-if="true || selectedPricerows.length"><i class="fa fa-fw fa-pencil"></i> <span class="hidden-xs">{{ _('Modify price rows') }}</span><span class="visible-xs-inline  ">{{ _('Modify') }}</span></button>
                  <button style="margin-right: 5px" class="deletepricerows btn btn-danger pull-right" v-on:click="deletePricerows" type="button" v-if="selectedPricerows && selectedPricerows.length"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete selected price rows') }}</span></button>
                </div>
              </div>
              <div id="pricetierManagementContainer" v-if="parseInt(product.hide_pricing) !== PRICING_TICKET">
                <hr class="pricetier-content" />
                <div class="row pricetier-content">
                  <div class="col-xs-12"><h3>{{ _('Price tiers') }}</h3></div>
                </div>
                <div class="row pricetier-content">
                  <div class="col-lg-6 leftcol">
                    <div class="form-group languageversioned" v-if="isReservable">
                      <label>{{ _('Quantity selector title') }}</label>
                      <input type="text" class="form-control" id="quantityTitle" :placeholder="_('Enter a descriptive title for the quantity selector')" v-model="product.quantitytitle" />
                    </div>
                    <div class="form-group">
                      <div class="input-group pricetier-input-group" id="enabledPricetiersList">
                        <div class="checkbox" v-if="!isCalendarPricing">
                          <label class="radiolabel">
                            <input type="checkbox" name="enable_participant_pricing" v-model="product.enable_participant_pricing" true-value="1" false-value="0" /> {{ _('Enable pricing based on the number of participants') }}
                          </label>
                        </div>
                        <div class="pricetier-items">
                          <div v-for="pricetier in allPricetiers" :class="'list-group-item pricetier-item' + (isPricetierSelected(pricetier) ? ' is-selected' : '')" :key="pricetier.id">
                            <label class="pricetier-name radiolabel">
                              <input type="checkbox" class="pricetier" v-model="selectedPricetiers" :value="pricetier.id" />
                              <span class="pricetier-title">{{ pricetier.name }}</span>
                            </label>
                            <div class="pricetier-default" v-if="isPricetierSelected(pricetier)" :title="_('How many participants of this price tier are preselected when the customer opens the product')">
                              <span class="pricetier-default-label">{{ _('Preselected') }}</span>
                              <div class="btn-group btn-group-sm">
                                <button type="button" class="btn btn-default" :disabled="!(parseInt(pricetier.default_count) > 0)" :aria-label="_('Decrease')" v-on:click="subtract(pricetier)"><i class="fa fa-fw fa-minus"></i></button>
                                <span class="btn btn-default pricetier-default-value">{{ parseInt(pricetier.default_count) > 0 ? pricetier.default_count : '–' }}</span>
                                <button type="button" class="btn btn-default" :aria-label="_('Increase')" v-on:click="add(pricetier)"><i class="fa fa-fw fa-plus"></i></button>
                              </div>
                            </div>
                            <div class="pricetier-rules" v-if="isActivityPricingEnabled && isPricetierSelected(pricetier) && pricetierRuleText(pricetier, allPricetiers)">
                              <template v-if="arePricetierRulesApplied(pricetier)">
                                <span>{{ pricetierRuleText(pricetier, allPricetiers) }}</span>
                                · <a href="javascript:;" v-on:click="setPricetierRulesApplied(pricetier, false)">{{ _("Don't apply to this product") }}</a>
                              </template>
                              <template v-else>
                                <s>{{ pricetierRuleText(pricetier, allPricetiers) }}</s>
                                · {{ _('Rules not applied') }} · <a href="javascript:;" v-on:click="setPricetierRulesApplied(pricetier, true)">{{ _('Apply') }}</a>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="isParticipantTicketsVisible">
                      <div class="checkbox">
                        <label>
                        <input type="checkbox" v-model="product.participant_tickets" id="participantTickets" true-value="1" false-value="0" />
                        {{ _('QR ticket per participant') }}
                        </label>
                      </div>
                      <p><i>{{ _('Each participant of a booking gets a QR ticket of their own, like event tickets.') }}</i></p>
                    </div>
                  </div>
                  <div class="col-lg-6 rightcol">
                    <p v-if="isCalendarPricing">{{ _('Select the price tiers of the guests. The rate plans set a nightly price per extra guest for each price tier. Adults, children and infants are the price tiers with those traveller categories, or else the first three; they are also used in Channex.') }}</p>
                    <p v-else-if="isActivityCalendarPricing">{{ _('Select the ticket types of this activity. Their prices are set in the weekly prices and on the calendar of each rate.') }}</p>
                    <p v-else>{{ _('Price tiers enable pricing based on customer age or similar criteria. Select the price tiers to use in this product from the adjacent list.') }}</p>
                    <p>{{ _('If you have set up the linked resources in a way that makes it possible to reserve multiple items at once, you can also define a custom title for the quantity selector, such as "Items", "Rooms", etc.') }}</p>
                    <p><a href="javascript:;" class="btn btn-info" v-on:click="pricetierManagement">{{ _('Price tier management') }}</a></p>
                  </div>
                </div>
              </div>
              <div class="row" v-if="isFeatureEnabled('paymentplans')">
                <hr />
                <div class="col-xs-6">
                  <h3>{{ _('Payment plan') }}</h3>
                  <div class="form-group">
                    <label for="paymentplan">{{ _('Payment plan') }}</label>
                    <select class="form-control" id="paymentplan" v-model="product.paymentplan_id">
                      <option :value="null">{{ _('No payment plan') }}</option>
                      <option v-for="paymentplan in selectablePaymentPlans" :value="paymentplan.id">{{ paymentplan.name }}</option>
                    </select>
                    <p class="help-block text-danger" v-if="hasRecurringPlanOnReservable">{{ _('Recurring payment plans cannot be used with reservable products.') }}</p>
                  </div>
                  <button class="btn btn-info" v-on:click="managePaymentplansDialog">{{ _('Manage payment plans') }}</button>
                </div>
              </div>
              <div class="row" v-if="showAllFields">
                <hr />
                <div class="col-xs-6" v-if="parseInt(product.subtype, 10) !== SUBTYPE_TICKET">
                  <div class="form-group languageversioned">
                    <label for="buttontext">{{ _('Action button text') }}</label>
                    <input type="text" class="form-control" id="buttonText" name="buttontext" :placeholder="_('Enter an optional custom text for the action button')" v-model="product.buttontext" />
                  </div>
                </div>
              </div>
              <div class="row" v-if="showAllFields && allCommissions.length">
                <div class="col-xs-12">
                  <hr />
                  <h3>{{ _('Commissions') }}</h3>
                </div>
              </div>
              <div class="row" v-if="showAllFields && allCommissions.length">
                <div class="col-lg-6 leftcol">
                  <div class="form-group">
                    <div class="input-group">
                      <div class="checkbox" v-for="commission in allCommissions">
                        <label class="radiolabel">
                          <input type="checkbox" v-model="product.sharedCommission" :value="commission" /> {{ commission.name }}, {{ commission.price }} <span v-if="parseInt(commission.type) === COMMISSION_PERCENTAGE">%</span><span v-else v-html="currencyEntity(settings.currency)"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <p>{{ _('The selected commission will be included in the price of the product, not added on top of it.') }}</p>
                </div>
                <div class="col-lg-6 rightcol">
                  <label class="radiolabel">
                    <input type="checkbox" v-model="product.margin_travel_agent" true-value="1" false-value="0" /> {{ _('Product is eligible for the travel agents tax margin scheme') }}
                  </label><br/>
                </div>
              </div>
            </div>
            <div class="row" v-if="showBuyablePaymentPlan">
              <hr />
              <div class="col-xs-6">
                <h3>{{ _('Payment plan') }}</h3>
                <div class="form-group">
                  <label for="buyablePaymentplan">{{ _('Payment plan') }}</label>
                  <select class="form-control" id="buyablePaymentplan" v-model="product.paymentplan_id">
                    <option :value="null">{{ _('No payment plan') }}</option>
                    <option v-for="paymentplan in selectablePaymentPlans" :value="paymentplan.id">{{ paymentplan.name }}</option>
                  </select>
                </div>
                <button class="btn btn-info" v-on:click="managePaymentplansDialog">{{ _('Manage payment plans') }}</button>
              </div>
            </div>

            <div id="deliveryMethods" v-if="showAllFields && isFeatureEnabled('delivery2.0')">
              <hr />
              <div class="row">
                <div class="col-lg-6 leftcol">
                  <template v-if="externalDeliveryMethods && externalDeliveryMethods.length">
                    <h3>{{ _('Available delivery methods:') }}</h3>
                    <div v-for="method in externalDeliveryMethods">
                      <p v-if="parseInt(method.shipit_pricing)">{{ method.name }}, +{{ method.shipit_margin }} %</p>
                      <p v-else>{{ method.name }}, {{ method.price }} <span v-html="currencyEntity(settings.currency)"></span></p>
                    </div>
                  </template>
                  <template v-if="internalDeliveryMethods && internalDeliveryMethods.length">
                    <h3>{{ _('Internal delivery methods:') }}</h3>
                    <div v-for="method in internalDeliveryMethods">
                      <p>{{ method.name }}</p>
                    </div>
                  </template>
                  <button class="btn btn-info" v-on:click="manageDeliverymethodsDialog"><i class="fa fa-fw fa-truck"></i> {{ _('Delivery settings') }}</button>
                </div>
                <div class="col-lg-6 rightcol">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="product.enable_deliverymethods_storefront" true-value="1" false-value="0" />
                      {{ _('Display delivery methods at the storefront') }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('availability')" class="tab-pane active" id="availability" v-if="isTabActive('availability')" key="availability">
            <div id="resourceAvailabilityHelper" class="row" v-if="isAvailabilityConfigurationVisible">
              <div class="col-xs-12">
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab">
                    <h4 class="panel-title">
                      <a role="button" data-toggle="collapse" :aria-expanded="isPanelOpen('availability')" v-on:click="togglePanel('availability')">
                        {{ _('Configure availability') }}
                      </a>
                    </h4>
                  </div>
                  <transition v-on="slideTransition">
                    <div class="panel-collapse" role="tabpanel" v-if="isPanelOpen('availability')">
                      <div class="panel-body">
                        <div class="row radio">
                          <div class="col-xs-4">
                            <label>
                              <input type="radio" name="ignore_availabilitytype" id="singleResource" v-model="availabilityType" value="single" checked="checked"> <span id="singleResourceText">{{ getRadioText('single') }}</span>
                            </label>
                          </div>
                          <div class="col-xs-4">
                            <label>
                              <input type="radio" name="ignore_availabilitytype" id="multipleResources" v-model="availabilityType" value="multi"> <span id="multiResourceText">{{ getRadioText('multi') }}</span>
                            </label>
                          </div>
                          <div class="col-xs-4">
                            <label>
                              <input type="radio" name="ignore_availabilitytype" id="existingResources" v-model="availabilityType" value="existing"> <span id="existingResourceText">{{ getRadioText('existing') }}</span>
                            </label>
                          </div>
                        </div>
                        <div class="row" id="countRow" v-if="availabilityType !== 'existing'">
                          <div class="col-xs-6" id="resourceCountContainer" v-if="availabilityType === 'multi'">
                            <div class="form-group">
                              <label for="resourceCount" id="resourceCountText">{{ getResourceCountText() }}</label>
                              <input type="number" min="1" :lang="numberLocale" v-model.number="createResourceCount" class="form-control" id="resourceCount" :placeholder="_('Enter the amount')" name="ignore_resourcecount">
                            </div>
                          </div>
                          <div class="col-xs-6" id="seatCountContainer">
                            <div class="form-group">
                              <label for="seatCount" id="seatCountText">{{ getSeatCountText() }}</label>
                              <input type="number" min="1" v-model.number="createSeatCount" class="form-control" id="seatCount" :placeholder="_('Enter the amount')" name="ignore_seatcount">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-xs-12">
                            <p id="resourceAvailabilityInfo">{{ getInfoText(availabilityType) }}</p>
                            <p><button type="button" class="btn btn-primary" v-on:click="confirmResourceAvailability" :disabled="confirmingAvailability">{{ confirmText }}</button></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div class="row" v-if="resourceOrPoolCount && !isContent">
              <div class="col-xs-12">
                <div class="form-group">
                  <h3>{{ _('Availability is controlled by these resources') }}</h3>
                </div>
              </div>
            </div>
            <div class="row" v-if="!isContent">
              <div class="col-xs-12">
                <div class="panel-group flex-panel" id="availabilityAccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-default" v-if="isSellable || resourceCount > 1">
                    <div class="panel-heading" role="tab" id="availabilityHeadingSummary">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#availabilityAccordion" href="javascript:;" :aria-expanded="isPanelOpen('availabilitySummary')" aria-controls="availabilityCollapseSummary" v-on:click="togglePanel('availabilitySummary')">
                          <span class="title-text">{{ _('Summary') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="availabilityCollapseSummary" class="panel-collapse" role="tabpanel" aria-labelledby="availabilityHeadingSummary" v-if="isPanelOpen('availabilitySummary')">
                        <div class="panel-body">
                          <div class="alert alert-danger" v-if="resourcesTainted">
                            <i class="fa fa-info-circle"></i> {{ _('The summary will update after saving changes.') }}
                          </div>
                          <div class="row" :style="resourcesTainted ? 'opacity: 0.5' : ''">
                            <div class="col-lg-6 leftcol" v-if="isReservable">
                              <h3>{{ _('availability|Reservable') }}</h3>
                              <table class="table">
                                <tbody class="timerows" id="ranges">
                                  <tr v-for="range in ranges" :class="getRangeClass(range)">
                                    <td v-html="makeRangeDesc(range)"></td>
                                  </tr>
                                </tbody>
                              </table>
                              <p>{{ _('The reservable times shown above are determined by the resource(s) attached to the product. Edit the resource(s) to change the limits.') }}</p>
                            </div>
                            <div class="col-lg-6 rightcol">
                              <h3 v-if="isSellable">{{ _('Stock balance') }}</h3>
                              <h3 v-else>{{ _('Capacity') }}</h3>
                              <p v-if="isReservable">{{ _('The maximum capacity of this product is derived from the maximum capacities of the resources attached to the product:') }}</p>
                              <table class="table table-striped" v-if="isReservable">
                                <thead>
                                  <tr>
                                    <th>{{ _('Name') }}</th>
                                    <th>{{ _('Type') }}</th>
                                    <th>{{ _('Capacity') }}</th>
                                  </tr>
                                </thead>
                                <tbody class="resourcerows" id="warehouseResourcesList">
                                  <tr v-for="res in product.warehouse_count_resources" :data-local="res.local" :data-id="res.id"><td>{{ res.name }}</td><td v-if="parseInt(res.local) === 1">{{ _('Local') }}</td><td v-else>{{ _('Remote') }}</td><td class="countcol">{{ res.count }}</td></tr>
                                </tbody>
                              </table>
                              <p v-if="isSellable">{{ _('The stock balance of this product is derived from the stock balances of the resources attached to the product:') }}</p>
                              <input v-if="isSellable" :value="totalStockBalance" type="number" step="any" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" :readonly="!parseInt(product.allow_sale_under_warehouse)" />
                              <div class="checkbox" v-if="isSellable">
                                <label>
                                <input type="checkbox" v-model="product.allow_sale_under_warehouse" true-value="1" false-value="0" />
                                {{ _('Disconnect sales from stock balance') }}
                                </label>
                              </div>
                              <div class="checkbox" v-if="showAllFields && isSellable">
                                <label>
                                <input type="checkbox" v-model="product.hide_units" id="hideUnits" true-value="1" false-value="0" />
                                {{ _('Hide units') }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div v-for="(resource, resourceIndex) in product.sharedResource" class="panel panel-default">
                    <div class="panel-heading" role="tab" :id="'availabilityHeading' + resource.id">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#availabilityAccordion" href="javascript:;" :aria-expanded="isPanelOpen('availabilityCollapse' + resource.id)" :aria-controls="'availabilityCollapse' + resource.id" v-on:click="togglePanel('availabilityCollapse' + resource.id)">
                          <span class="title-text">
                            <i :class="'fa fa-fw fa-' + (resource.displayedtype === 'openinghours' ? 'clock-o' : 'cube')"></i> {{ resource.name }}
                          </span>
                          <span v-if="showAllFields && resourceOrPoolCount > 1" class="panel-extra removeresource" v-on:click="removeResource(resource)"><span class="fa fa-fw fa-unlink"></span> <span class="hidden-xs">{{ _('Remove from this product') }}</span></span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'availabilityCollapse' + resource.id" class="panel-collapse" role="tabpanel" :aria-labelledby="'availabilityHeading' + resource.id" v-if="isPanelOpen('availabilityCollapse' + resource.id)">
                        <div class="panel-body">
                          <div class="row" id="routeContainer" v-if="parseInt(product.subtype) === SUBTYPE_TRANSPORTATION">
                            <div class="col-lg-6 leftcol">
                              <div class="form-group">
                                <h3>{{ _('Routes') }}</h3>
                              </div>
                              <div class="form-group">
                                <ul class="o-sortable-routes list-group">
                                  <li v-for="route in resource.sharedRoute" class="list-group-item">{{ route.name }} ({{ route.type }})<a class="pull-right remove-route" href="javascript:;" v-on:click="removeRouteFromResource(resource, route)"><i class="fa fa-fw fa-trash"></i></a></li>
                                </ul>
                              </div>
                              <div class="form-group">
                                <button class="addroutebutton btn btn-success" type="button" v-on:click="selectRoute(resource, resourceIndex)"><i class="fa fa-fw fa-plus"></i> {{ _('Add route') }}</button>
                              </div>
                            </div>
                            <div class="col-lg-6 rightcol">
                              <p>{{ _('Add one or more routes to the resource to enable pricing.') }}</p>
                              <p><a href="javascript:;" class="btn btn-info routemanagement" v-on:click="manageRoutesDialog">{{ _('Route management') }}</a></p>
                            </div>
                            <div class="col-xs-12">
                              <hr />
                            </div>
                          </div>
                          <div class="row" v-if="isSellable">
                            <div class="col-lg-6 leftcol">
                              <div class="form-group">
                                <label for="resourcename">{{ _('Resource name') }}</label>
                                <input class="form-control" type="text" name="resourcename" v-model="resource.name" />
                              </div>
                            </div>
                            <div class="col-lg-3 rightcol">
                              <div class="form-group">
                                <label for="count">{{ _('Stock balance') }}</label>
                                <div class="input-group">
                                  <input class="form-control resourcecount" step="any" type="number" data-android-inputmode="decimal" :lang="numberLocale" v-model.number="resourceCapacity[resource.id]" />
                                  <div class="input-group-addon">{{ resource.unit === 'pcs' ? _('pcs') : resource.unit }}</div>
                                </div>
                                <p v-if="getBasketItemCount(resource)">{{ _('Stock balance currently in baskets:') }} {{ getBasketItemCount(resource) }}</p>
                              </div>
                            </div>
                            <div class="col-lg-3 rightcol">
                              <div class="form-group">
                                <label for="count">{{ _('One product includes') }}</label>
                                <div class="input-group">
                                  <input class="form-control resourceunits" type="number" data-android-inputmode="decimal" :lang="numberLocale" v-model.number="resourceUnits[resource.id]" />
                                  <div class="input-group-addon">{{ resource.unit === 'pcs' ? _('pcs') : resource.unit }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-else>
                            <div  class="col-lg-6 leftcol">
                              <div class="form-group">
                                <h3>{{ _('availability|Reservable') }}</h3>
                              </div>
                              <table class="table">
                                <tbody class="timerows resourceranges">
                                  <tr v-for="range in resource.ownRange" :class="getRangeClass(range)">
                                    <td v-html="makeRangeDesc(range)" v-on:click="editRange(range)"></td>
                                  </tr>
                                </tbody>
                              </table>
                              <button class="addrangebutton btn btn-success" type="button" v-on:click="addRange(resource)"><i class="fa fa-fw fa-plus"></i> {{ _('Add range') }}</button>
                              <div class="form-group" v-if="showAllFields && settings.calendarauthcode">
                                <hr />
                                <div class="form-group">
                                  <h3>{{ _('Google Calendar') }}</h3>
                                </div>
                                <div class="form-group">
                                  <label class="googlecalendardesc" v-if="resource.google_calendar_id">{{ _('Limit availability based on events in calendar:') }} {{ resource.google_calendar_title }} ({{ resource.google_calendar_id }}) {{ parseInt(resource.google_calendar_mode) ? _('Allow dates') : _('Deny dates') }}</label>
                                  <label class="googlecalendardesc" v-else>{{ _('Select a calendar to limit availability based on the events in it.') }}</label>
                                </div>
                                <button v-if="!resource.google_calendar_id" class="selectcalendar btn btn-success" id="selectCalendarButton" type="button" v-on:click="selectCalendar(resource)"><i class="fa fa-fw fa-calendar-o"></i> {{ _('Select calendar') }}</button>
                                <button v-else class="detachcalendar btn btn-danger" id="detachCalendarButton" type="button" v-on:click="detachCalendar(resource)"><i class="fa fa-fw fa-calendar-times-o"></i> {{ _('Detach calendar') }}</button>
                              </div>
                              <template v-if="showAllFields && (resource.displayedtype !== 'openinghours' && (resource.igloohome_lockcode || resource.ratna_lockcode))">
                                <hr />
                                <div class="row">
                                  <div class="col-xs-12">
                                    <div class="form-group">
                                      <h3>{{ _('Locking') }}</h3>
                                    </div>
                                    <div class="form-group">
                                      <label v-if="resource.igloohome_lockcode">
                                      {{ _('Linked to Igloohome lock') }}: {{ resource.igloohome_lockname }}
                                      </label>
                                      <label v-else-if="resource.ratna_lockcode">
                                      {{ _('Linked to Ratna lock') }}: {{ resource.ratna_lockname }} ({{ resource.ratna_lockcode }})
                                      </label>
                                      <label v-else>
                                      {{ _('Select a lock to link this resource to.') }}
                                      </label>
                                    </div>
                                    <div class="form-group row" id="iglooOffsetContainer" v-if="resource.igloohome_lockcode">
                                      <div class="col-xs-6">
                                        <label for="igloohome_startoffset">{{ _('Number of hours to enable PIN code before reservation start') }}</label>
                                        <input type="number" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" name="igloohome_startoffset" v-model.number="resource.igloohome_startoffset" />
                                      </div>
                                      <div class="col-xs-6">
                                        <label for="igloohome_endoffset">{{ _('Number of hours to extend PIN code validity after reservation end') }}</label>
                                        <input type="number" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" name="igloohome_endoffset" v-model.number="resource.igloohome_endoffset" />
                                      </div>
                                    </div>
                                    <div class="form-group row" id="ratnaOffsetContainer" v-else-if="resource.ratna_lockcode">
                                      <div class="col-xs-6">
                                        <label for="ratna_startoffset">{{ _('Number of hours to enable PIN code before reservation start') }}</label>
                                        <input type="number" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" name="ratna_startoffset" v-model.number="resource.ratna_startoffset" />
                                      </div>
                                      <div class="col-xs-6">
                                        <label for="ratna_endoffset">{{ _('Number of hours to extend PIN code validity after reservation end') }}</label>
                                        <input type="number" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" name="ratna_endoffset" v-model.number="resource.ratna_endoffset" />
                                      </div>
                                    </div>
                                    <template v-if="settings.igloohome_apikey && !resource.ratna_lockcode">
                                      <button class="selectigloo btn btn-success" id="selectIglooButton" type="button" v-if="!resource.igloohome_lockcode" v-on:click="selectIglooLock(resource)"><i class="fa fa-fw fa-lock"></i> {{ _('Select Igloohome lock') }}</button>
                                      <button class="detachigloo btn btn-danger" id="detachIglooButton" type="button" v-else v-on:click="detachIglooLock(resource)"><i class="fa fa-fw fa-lock"></i> {{ _('Detach Igloohome lock') }}</button>
                                    </template>
                                    <template v-if="settings.ratna_username && !resource.igloohome_lockcode">
                                      <button class="selectratna btn btn-success" id="selectRatnaButton" type="button" v-if="!resource.ratna_lockcode" v-on:click="selectRatnaApartment(resource)"><i class="fa fa-fw fa-lock"></i> {{ _('Select Ratna apartment') }}</button>
                                      <button class="detachratna btn btn-danger" id="detachRatnaButton" type="button" v-else v-on:click="detachRatnaApartment(resource)"><i class="fa fa-fw fa-lock"></i> {{ _('Detach Ratna apartment') }}</button>
                                    </template>
                                  </div>
                                </div>
                              </template>
                              <template v-if="showAllFields">
                                <div class="localproducts" v-if="localProducts[resource.id]">
                                  <hr />
                                  <h3>{{ _('Local products using the resource') }}</h3>
                                  <div class="list-group">
                                    <a class="list-group-item local-products-item" v-for="localProduct in localProducts[resource.id]">
                                      <h4 class="list-group-item-heading">{{ localProduct.name }}</h4>
                                    </a>
                                  </div>
                                </div>
                                <div class="localproducts well" v-else>
                                  {{ _('There are no local products using this resource.') }}
                                </div>
                              </template>
                            </div>
                            <div class="col-lg-6 rightcol" v-if="resource.displayedtype !== 'openinghours'">
                              <div class="form-group">
                                <label for="resourcename">{{ _('Resource name') }}</label>
                                <input class="form-control" type="text" name="resourcename" v-model="resource.name" />
                              </div>
                              <h3>{{ _('Capacity') }}</h3>
                              <div v-if="showAllFields" class="form-group">
                                <label for="mincount">{{ _('Minimum capacity of the resource') }}</label>
                                <input class="form-control" type="number" data-android-inputmode="decimal" :lang="numberLocale" v-model.number="resource.mincount" />
                              </div>
                              <p v-if="showAllFields">{{ _('If you want to set a minimum number of participants for the reservation, you can enter the value in the field "Minimum capacity of the resource".') }}</p>
                              <div class="form-group">
                                <label for="count">{{ _('Maximum capacity of the resource') }}</label>
                                <input class="form-control resourcecount" type="number" data-android-inputmode="decimal" :lang="numberLocale" v-model.number="resource.count" />
                              </div>
                              <p>{{ _('The capacity of a single resource is defined by entering the value in the field "Maximum capacity of the resource".') }}
                              {{ _('In practice this means that a single room may have several beds or a single canoe may have more than one seat.') }}</p>
                              <div class="form-group" v-if="showAllFields">
                                <label for="extraCount">{{ _('Extra capacity of the resource') }}</label>
                                <input id="extraCount" class="form-control" name="extraCount" type="number" data-android-inputmode="decimal" :lang="numberLocale" v-model="resource.extracount" />
                              </div>
                              <p v-if="showAllFields">{{ _('If you would like to have extra capacity available via the POS/management interface, enter the number of extra seats in this field.') }}</p>
                              <div class="checkbox" v-if="showAllFields">
                                <label>
                                <input type="checkbox" :disabled="parseInt(resource.quantity) > 1" v-model="resource.enable_shared_reservation" true-value="1" false-value="0" />
                                {{ _('Allow separate reservations at the same time') }}
                                </label>
                              </div>
                              <p v-if="showAllFields">{{ _('The setting "Allow separate reservations at the same time" is used to enable/disable simultaneous reservations of the resource during the same time.') }}
                              {{ _('For example, if you rent bicycles, you can allow anyone to reserve them even one at a time.') }}
                              {{ _('On the other hand, if you offer something like private tours, you\'ll want to disable this setting.') }}</p>
                              <template v-if="showAllFields && parseInt(resource.enable_shared_reservation) === 1">
                                <div class="checkbox">
                                  <label>
                                  <input type="checkbox" v-model="resource.shared_reservation_scope" true-value="departure" false-value="" />
                                  {{ _('Share only within the same departure') }}
                                  </label>
                                </div>
                                <p>{{ _('When this is on, the resource accepts several reservations for the same product and start time, but it is unavailable for other products at overlapping times.') }}
                                {{ _('Use this for guides who can lead only one activity at a time.') }}</p>
                              </template>
                            </div>
                          </div>
                        </div>
                        <div v-if="showAllFields" class="panel-footer space-between">
                          <a v-if="!resourcesTainted" class="btn btn-primary manageresource" href="javascript:;" v-on:click="editResourceDialog(resource)"><i class="fa fa-fw fa-pencil"></i> {{ _('Edit resource') }}</a>
                          <template v-else>
                            <a class="btn btn-primary manageresource disabled" href="javascript:;" disabled><i class="fa fa-fw fa-pencil"></i> {{ _('Edit resource') }}</a>
                            <span>{{ _('Save the product to enable editing of the resource.')}}</span>
                          </template>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="panel panel-default" v-for="(resourcePool, index) in product.sharedResourcepool">
                    <div class="panel-heading" role="tab" :id="'availabilityHeading' + resourcePool.id + '-pool'">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#availabilityAccordion" href="javascript:;" :aria-expanded="isPanelOpen('availabilityCollapse' + resourcePool.id + '-pool')" :aria-controls="'availabilityCollapse' + resourcePool.id + '-pool'" v-on:click="togglePanel('availabilityCollapse' + resourcePool.id + '-pool')">
                          <span class="title-text"><i class="fa fa-fw fa-sitemap"></i> {{ resourcePool.name }}</span>
                          <span v-if="resourceOrPoolCount > 1" class="panel-extra removeresourcepool" v-on:click="removeResourcepool(resourcePool)"><span class="fa fa-fw fa-unlink"></span> <span class="hidden-xs">{{ _('Remove from this product') }}</span></span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'availabilityCollapse' + resourcePool.id + '-pool'" class="panel-collapse" role="tabpanel" :aria-labelledby="'availabilityHeading' + resourcePool.id + '-pool'" v-if="isPanelOpen('availabilityCollapse' + resourcePool.id + '-pool', index)">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-xs-6">
                              <a class="btn btn-primary manageresourcepool" href="javascript:;" v-on:click="editResourcepoolDialog(resourcePool)"><i class="fa fa-fw fa-pencil"></i> {{ _('Manage resource pool') }}</a>
                            </div>
                            <div class="col-lg-6 rightcol" v-if="isSellable">
                              <div class="form-group">
                                <label for="count">{{ _('One product includes') }}</label>
                                <div class="input-group">
                                  <input class="form-control resourceunits" type="number" data-android-inputmode="decimal" :lang="numberLocale" v-model.number="resourcePoolUnits[resourcePool.id]" />
                                  <div class="input-group-addon">{{ _('pcs') }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" id="resourceLinkerContainer" v-if="(showAllFields || (!(product.sharedResourcepool && product.sharedResourcepool.length) && !(product.sharedResource && product.sharedResource.length))) && isResourceLinkerVisible">
              <div class="col-xs-12">
                <p v-if="isSellable">{{ _('Each product must have at least one connected resource. A resource represents the actual item that gets sold, for example a shirt or a bike. If a resource is connected to more than one product, they all share the same availability. Use the auto-completing search field to find an existing resource or type in the name of the resource you wish to create and then press "Add".') }}</p>
                <p v-else>{{ _('Each reservable product must have at least one connected resource. A resource represents the actual item that gets reserved, for example a cottage or a bike. If a resource is connected to more than one product, they all share the same reservation calendar. Use the auto-completing search field to find an existing resource or type in the name of the resource you wish to create and then press "Add".') }}</p>
                <div class="form-inline flex-row">
                  <button type="button" class="btn btn-info" v-on:click="addResourceDialog"><i class="fa fa-fw fa-cube"></i> {{ _('Attach resource') }}</button>
                  <button type="button" class="btn btn-info" v-on:click="addResourcepoolDialog" v-if="!(isSellable && product.sharedResourcepool.length >= 1)"><i class="fa fa-fw fa-sitemap"></i> {{ _('Attach resource pool') }}</button>
                </div>
              </div>
            </div>
            <hr v-if="showAllFields && !isContent" />
            <div class="row" v-if="isReservable || settings.availabilitysearch">
              <div class="col-lg-6 leftcol" v-if="isReservable && !isEvent">
                <div id="startEndTimesContainer">
                  <h3 class="startEndTitle">{{ _('Reservation start and end times') }}</h3>
                  <table class="table">
                    <tbody class="timerows starttimes" id="startTimes">
                      <tr class="starttime" v-for="starttime in productStarttimes" v-on:click="editStarttime(starttime)">
                        <td v-html="makeStarttimeDesc(starttime)"></td>
                        <td style="text-align: right;">
                          <button class="btn btn-danger btn-xs" style="margin-left: 5px; padding: 0 5px;" v-on:click.stop="removeStarttime(starttime)"><i class="fa fa-fw fa-close"></i></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button class="addstarttimebutton btn btn-success" type="button" v-on:click="addStarttime"><i class="fa fa-fw fa-plus"></i> {{ _('Add') }}</button>
                </div>
                <template v-if="showAllFields">
                  <h3 class="preselectedTitle">{{ _('Preselected dates') }}</h3>
                  <p>{{ _('You can optionally preselect one or more dates for reservations and skip showing the calendar date picker.') }}
                  {{ _('This is useful for events and other products that are only available on a limited number of dates.') }}</p>
                  <div id="preselected_dates_container">
                    <div class="hidden-lg">&nbsp;</div>
                    <div class="form-inline">
                      <div id="preselectedDatesList">
                        <div class="btn-group" v-for="pd in preselectedDates" style="margin-right: 5px">
                          <button type="button" class="btn btn-default preselectedDate">{{ DateTime.fromFormat(pd, 'd.M.yyyy').toFormat(dateFormat) }}</button>
                          <button type="button" class="btn btn-default removeDate" v-on:click="removePreselectedDate(pd)"><i class="fa fa-fw fa-close"></i></button>
                        </div>
                      </div>
                      <hr v-if="preselectedDates.length" />
                      <div class="timeinput group">
                        <DatePicker v-model="preselectedDate" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select date')"></DatePicker>
                        <button class="btn btn-success" id="addPreselectedDate" type="button" :disabled="!preselectedDate" v-on:click="addPreselectedDate"><i class="fa fa-fw fa-plus"></i> {{ _('Add') }}</button>
                      </div>
                    </div>
                    <div style="clear: both">&nbsp;</div>
                  </div>
                </template>
              </div>
              <div class="col-lg-6 rightcol">
                <h3 v-if="showAllFields">{{ _('Additional settings') }}</h3>
                <div v-if="showAllFields && isReservable">
                  <div class="form-group">
                    <label>{{ _('Must be reserved') }}</label>
                    <p v-if="channexProperty"><button class="pull-right btn btn-info btn-xs" v-on:click="openSalesChannelSettings(channexProperty)"><i class="fa fa-fw fa-cog"></i> {{ _('Settings') }}</button><i>{{ _('Please note that this setting is not compatible with external sales channels.') }} {{ _('To set a cut-off time for properties in external sales channels, modify the property in Settings.') }}</i>
                    </p>
                    <div class="input-group">
                      <input type="text" class="form-control" id="deadlineOffsetDays" v-model="deadlineOffsetDays" /> 
                      <div class="input-group-addon">{{ _('d') }}</div>
                      <input type="text" class="form-control" id="deadlineOffsetHours" v-model="deadlineOffsetHours" /> 
                      <div class="input-group-addon">{{ _('h') }}</div>
                      <input type="text" class="form-control" id="deadlineOffsetMinutes" v-model="deadlineOffsetMinutes" /> 
                      <div class="input-group-addon">{{ _('min') }}</div>
                    </div>
                    <select class="form-control" v-model="deadlineOffsetOption">
                      <option value="prior">{{ _('prior to reservation start') }}</option>
                      <option value="after">{{ _('after reservation start') }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ _('Limit availability to') }}</label>
                      <div class="input-group">
                      <input type="number" class="form-control" id="reservableUntilDays" v-model="product.reservableuntil" /> 
                      <div class="input-group-addon">{{ _('d') }}</div>
                    </div>
                    <p><i>{{ _('Limits how many days in advance visitors can make reservations, from when they check availability.') }}</i></p>
                  </div>
                  <div class="form-group">
                    <label>{{ _('Maintenance window after each reservation') }}</label>
                    <div class="input-group">
                      <input type="number" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" v-model.number="product.maintenancewindow" /> 
                      <div class="input-group-addon">{{ _('min') }}</div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ _('Maximum number of seats allowed in a single basket') }}</label>
                    <input type="number" data-android-inputmode="decimal" :lang="numberLocale" class="form-control" v-model.number="product.maxallowedseats" /> 
                  </div>
                  <div class="checkbox">
                    <label>
                    <input type="checkbox" v-model="product.allow_multiday" id="allowMultiDay" true-value="1" false-value="0" />
                    {{ _('Allow multi-day reservations') }}
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                    <input type="checkbox" v-model="product.hide_times" id="hideTimes" true-value="1" false-value="0" />
                    {{ _('Hide start and end times') }}
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                    <input type="checkbox" v-model="product.hide_units" id="hideUnits" true-value="1" false-value="0" />
                    {{ _('Hide units') }}
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                    <input type="checkbox" v-model="product.hide_capacity" id="hideCapacity" true-value="1" false-value="0" />
                    {{ _('Hide remaining capacity') }}
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                    <input type="checkbox" v-model="product.hide_checkin" id="hideCheckin" true-value="1" false-value="0" />
                    {{ _('Hide self-service checkin/checkout') }}
                    </label>
                  </div>
                  <div class="checkbox" v-if="settings.calendarauthcode && settings.calendarrefreshtoken">
                    <label>
                      <input type="checkbox" v-model="product.enable_calendar" true-value="1" false-value="0" />
                      {{ _('Synchronize reservations to Google Calendar') }}
                    </label>
                  </div>
                </div>
                <div class="form-group" v-if="showAllFields && settings.availabilitysearch">
                  <label>{{ _('Include in availability search') }}</label>
                  <div class="radio">
                    <label>
                      <input type="radio" v-model="product.enable_availability" id="enableAvailabilityAlways" value="2" /> {{ _('Always') }}
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input type="radio" v-model="product.enable_availability" id="enableAvailability" value="1" /> {{ _('When enabled in Storefront') }}
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input type="radio" v-model="product.enable_availability" id="disableAvailability" value="0" /> {{ _('Never') }}
                    </label>
                  </div>
                  <div v-if="isReservable">
                    <label>{{ _('Limit availability search') }}</label>
                    <div class="checkbox">
                      <label>
                      <input type="checkbox" v-model="product.limit_availability" id="limitAvailability" true-value="1" false-value="0" />
                      {{ _('Limit availability to minimum duration') }}
                      </label>
                    </div>
                  </div>
                  <div v-if="isReservable && isActivity">
                    <label>{{ _('Joinable bookings') }}</label>
                    <div class="checkbox">
                      <label>
                      <input type="checkbox" v-model="product.relaxmincount" id="relaxmincount" true-value="1" false-value="0" />
                      {{ _('Allow later bookings to join an already-started time slot') }}
                      </label>
                    </div>
                    <p>{{ _('The first booking still has to meet the resource minimum if one is set. After that, later bookings on the same date and time can be smaller. Selecting fewer than the minimum only shows slots that are already open.') }}
                    {{ _('Shared reservations must be allowed on the resource. In a single-allocation pool, later bookings stay on the resource that is already in use and only open another when it is full. The pool allocation mode (random, priority, and so on) still decides which resource is opened first.') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('links')" class="tab-pane active" id="links" v-if="showAllFields && isTabActive('links')" key="links">
            <div class="row">
              <div class="col-lg-6 leftcol hide-groupdeal show-sellable show-reservable" v-if="!isGroupDeal">
                <div v-if="isProductOptionsVisible">
                  <div class="hidden-lg">&nbsp;</div>
                  <div class="form-group">
                    <h3>{{ _('Product options') }}</h3>
                  </div>
                  <table class="table table-striped" v-if="!productOptions.length || ungroupedOptionList.length || isActivityPricingEnabled">
                    <thead>
                      <tr>
                        <th>{{ _('Name') }}</th>
                      </tr>
                    </thead>
                    <tbody class="resourcerows o-sortable-linkedproducts" id="productOptionsList" v-if="!productOptions.length || (!ungroupedOptionList.length && !isActivityPricingEnabled)">
                      <tr>
                        <td><p>{{ _('No product options have been linked.') }}</p></td>
                      </tr>
                    </tbody>
                    <draggable v-else v-model="ungroupedOptionList" tag="tbody" draggable=".productoption" :group="isActivityPricingEnabled ? 'productoptions' : undefined" :delay="100" :delayOnTouchOnly="true">
                      <tr class="productoption" v-for="product in ungroupedOptionList" :key="product.id" :data-optional="Number(product.type) === LINKEDPRODUCT_OPTIONAL ? '1' : '0'" v-on:click="editLinkedProductDialog(product)">
                        <td style="cursor: pointer">{{ product.linkedproduct.name }}</td>
                        <td style="cursor: pointer">{{ linkedProductType(product) }}</td>
                        <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeLinkedProduct(product)"><i class="fa fa-fw fa-close"></i></a></td>
                      </tr>
                    </draggable>
                  </table>
                  <!-- Activity pricing: choices, each drawn like the storefront shows it (one radio per option) -->
                  <draggable v-if="isActivityPricingEnabled && optionGroups.length" v-model="optionGroupList" tag="div" class="choice-groups" draggable=".choice-group" handle=".choice-group-handle" :delay="100" :delayOnTouchOnly="true">
                    <div class="panel panel-default choice-group" v-for="group in optionGroups" :key="optionGroupRef(group)">
                      <div class="panel-heading choice-group-heading">
                        <i class="fa fa-fw fa-bars choice-group-handle" :title="_('Drag to reorder')"></i>
                        <div class="languageversioned choice-group-name">
                          <input type="text" class="form-control input-sm" :aria-label="_('Name')" :placeholder="choiceGroupPlaceholder(group)" v-model="group.name" />
                        </div>
                        <span class="label label-info choice-group-role" v-if="isPlaceGroup(group)"><i class="fa fa-fw fa-map-marker"></i> {{ group.role === 'dropoff' ? _('Drop-off') : _('Pick-up') }}</span>
                        <a href="javascript:;" class="choice-group-remove" :title="_('Remove choice')" :aria-label="_('Remove choice')" v-on:click="removeOptionGroup(group)"><i class="fa fa-fw fa-close"></i></a>
                      </div>
                      <draggable :modelValue="groupOptions(group)" v-on:update:modelValue="setGroupOptions(group, $event)" tag="ul" :class="'list-group choice-group-options choice-group-drop' + (groupOptions(group).length ? '' : ' choice-group-empty')" draggable=".choice-group-option" :group="choiceDragGroup" :delay="100" :delayOnTouchOnly="true">
                        <li class="list-group-item choice-group-option" v-for="lp in groupOptions(group)" :key="lp.id" data-optional="1" v-on:click="editLinkedProductDialog(lp)">
                          <div class="choice-group-option-body">
                            <a href="javascript:;" class="pull-right" :title="_('Move out of the choice')" :aria-label="_('Move out of the choice')" v-on:click.stop="setLinkedProductGroup(lp, '')"><i class="fa fa-fw fa-close"></i></a>
                            <i :class="'fa fa-fw text-muted ' + (isOnlyChoice(group) ? 'fa-dot-circle-o' : 'fa-circle-o')"></i>
                            {{ lp.linkedproduct.name }}<span class="text-muted" v-if="placeTimeText(lp, group)"> · {{ placeTimeText(lp, group) }}</span>
                            <div class="small choice-group-transport" v-if="isPlaceGroup(group) && isTransportOption(lp)" v-on:click.stop>
                              <div class="choice-group-transport-controls">
                                <label :class="lp.stop_id ? '' : 'has-warning'">
                                  {{ group.role === 'dropoff' ? _('Picks up from') : _('Drops off at') }}
                                  <select class="form-control input-sm" :value="lp.stop_id ? String(lp.stop_id) : ''" v-on:change="setTransportStop(lp, $event.target.value)">
                                    <option value="">{{ _('Choose a stop') }}</option>
                                    <option v-for="stop in transportStops(lp)" :key="stop.id" :value="String(stop.id)">{{ stop.name }}</option>
                                  </select>
                                </label>
                                <select class="form-control input-sm" :aria-label="_('Timing')" :value="lp.stoptiming === 'timetable' ? 'timetable' : 'activity'" v-on:change="lp.stoptiming = $event.target.value">
                                  <option value="activity">{{ _('Relative to the activity') }}</option>
                                  <option value="timetable">{{ _("Transport's timetable") }}</option>
                                </select>
                              </div>
                              <div class="text-muted" v-if="lp.stop_id"><i class="fa fa-fw fa-map-marker"></i> {{ transportPlacesText(lp, group) }}</div>
                              <div class="text-warning" v-else><i class="fa fa-fw fa-exclamation-triangle"></i> {{ _('Choose a stop to offer its places.') }}</div>
                            </div>
                            <div class="small text-muted choice-group-place" v-else-if="isPlaceGroup(group)">
                              <i class="fa fa-fw fa-map-marker"></i> {{ pickupPlaceAddress(lp) }}
                              <a href="javascript:;" v-on:click.stop="openLinkedProduct(lp)">{{ _('Edit place') }}</a>
                            </div>
                          </div>
                        </li>
                      </draggable>
                      <ul class="list-group choice-group-options">
                        <li class="list-group-item choice-group-none" v-if="!parseInt(group.required)">
                          <a href="javascript:;" class="pull-right" :title="_('Customers must choose')" :aria-label="_('Customers must choose')" v-on:click="group.required = '1'"><i class="fa fa-fw fa-close"></i></a>
                          <i class="fa fa-fw fa-circle-o text-muted"></i> <span class="text-muted">{{ _('No selection') }}</span>
                        </li>
                        <li class="list-group-item choice-group-none" v-else>
                          <a href="javascript:;" class="text-muted" v-on:click="group.required = '0'"><i class="fa fa-fw fa-plus"></i> {{ _('Allow no selection') }}</a>
                        </li>
                      </ul>
                      <div class="panel-footer choice-group-footer">
                        <button type="button" class="btn btn-default btn-sm" v-on:click="addOptionToGroup(group)"><i class="fa fa-fw fa-plus"></i> {{ isPlaceGroup(group) ? _('Add a place') : _('Add option') }}</button>
                        <div :class="'btn-group' + (moveMenuGroup === optionGroupRef(group) ? ' open' : '')" v-if="ungroupedOptionalOptions.length">
                          <button type="button" class="btn btn-default btn-sm dropdown-toggle" aria-haspopup="true" :aria-expanded="moveMenuGroup === optionGroupRef(group) ? 'true' : 'false'" v-on:click="toggleMoveMenu(group)" v-on:blur="closeMoveMenu"><i class="fa fa-fw fa-level-down"></i> {{ _('Move an option here') }} <span class="caret"></span></button>
                          <ul class="dropdown-menu">
                            <li v-for="lp in ungroupedOptionalOptions" :key="lp.id"><a href="javascript:;" v-on:mousedown.prevent="moveOptionToGroup(group, lp)">{{ lp.linkedproduct.name }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </draggable>
                  <div class="form-group choice-group-buttons">
                    <button type="button" class="btn btn-info" id="addLinkedProduct" v-on:click="selectLinkedProductDialog()"><i class="fa fa-fw fa-link"></i> {{ _('Link product') }}</button>
                    <div :class="'btn-group' + (addChoiceMenuOpen ? ' open' : '')" v-if="isActivityPricingEnabled">
                      <button type="button" class="btn btn-success dropdown-toggle" aria-haspopup="true" :aria-expanded="addChoiceMenuOpen ? 'true' : 'false'" v-on:click="addChoiceMenuOpen = !addChoiceMenuOpen" v-on:blur="closeAddChoiceMenu"><i class="fa fa-fw fa-plus"></i> {{ _('Add a choice') }} <span class="caret"></span></button>
                      <ul class="dropdown-menu">
                        <li><a href="javascript:;" v-on:mousedown.prevent="addOptionGroup(null)"><i class="fa fa-fw fa-dot-circle-o"></i> {{ _('Customer chooses one') }}</a></li>
                        <li><a href="javascript:;" v-on:mousedown.prevent="addOptionGroup('pickup')"><i class="fa fa-fw fa-map-marker"></i> {{ _('Pick-up place') }}</a></li>
                        <li><a href="javascript:;" v-on:mousedown.prevent="addOptionGroup('dropoff')"><i class="fa fa-fw fa-map-marker"></i> {{ _('Drop-off place') }}</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-group languageversioned">
                    <label>{{ _('Product options title') }}</label>
                    <input type="text" class="form-control" :placeholder="_('Enter a descriptive title for product options in the Storefront')" v-model="product.optionstitle" />
                  </div>
                  <div class="checkbox" v-if="isSellable && productOptions && productOptions.length">
                    <label>
                    <input type="checkbox" name="display_optinprice" v-model="product.display_optionprice" true-value="1" false-value="0" />
                    {{ _('Display the total price of the product and its mandatory options in lists') }}
                    </label>
                  </div>
                  <hr />
                </div>
                <template v-if="isPackagingVisible">
                  <div class="hidden-lg">&nbsp;</div>
                  <div class="form-group">
                    <h3>{{ _('Packaged products') }}</h3>
                    <p><i>{{ _('Packaged products can either be buyable products or reservable products that will be allocated for the entire duration of the main product\'s reservation.') }}</i></p>
                  </div>
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>{{ _('Name') }}</th>
                      </tr>
                    </thead>
                    <tbody class="resourcerows o-sortable-linkedproducts" id="packageOptionsList" v-if="!packageOptions || !packageOptions.length">
                      <tr>
                        <td><p>{{ _('No packaged products have been linked.') }}</p></td>
                      </tr>
                    </tbody>
                    <draggable v-else :model-value="groupedPackageOptions" v-on:update:model-value="updatePackageOptionsOrder" tag="tbody" draggable=".productoption" :delay="100" :delayOnTouchOnly="true">
                      <tr class="productoption" v-for="(item, index) in groupedPackageOptions" v-on:click="item.type === 'linkedproduct' && editLinkedProductDialog(item.product)">
                        <template v-if="item.type === 'linkedproduct'">
                          <td style="cursor: pointer">{{ item.product.linkedproduct.name }}</td>
                          <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeLinkedProduct(item.product)"><i class="fa fa-fw fa-close"></i></a></td>
                        </template>
                        <template v-else-if="item.type === 'group'">
                          <td colspan="2">
                            <div style="margin-top: -5px; cursor: pointer"><strong><small>{{ item.products[0].group }}</small></strong></div>
                            <draggable :model-value="item.products" v-on:update:model-value="updateGroupOrder(index, $event)" draggable=".groupitem" :delay="100" :delayOnTouchOnly="true">
                              <div class="groupitem" v-for="product in item.products">
                                <a style="display: inline-block" href="javascript:;" class="pull-right" v-on:click.stop="removeLinkedProduct(product)"><i class="fa fa-fw fa-close"></i></a>
                                <div style="margin-top: 8px; cursor: pointer" v-on:click="editLinkedProductDialog(product)">{{ product.linkedproduct.name }}</div>
                              </div>
                            </draggable>
                          </td>
                        </template>
                      </tr>
                    </draggable>
                  </table>
                  <div class="form-group">
                    <button type="button" class="btn btn-info" id="addLinkedProduct" v-on:click="selectLinkedProductDialog(LINKEDPRODUCT_PACKAGED)"><i class="fa fa-fw fa-link"></i> {{ _('Link product') }}</button>
                  </div>
                  <div class="form-group languageversioned">
                    <label>{{ _('Packaged products title') }}</label>
                    <input type="text" class="form-control" :placeholder="_('Enter a descriptive title for product packages in the Storefront')" v-model="product.packagingtitle" />
                  </div>
                  <hr />
                </template>
                <div class="form-group">
                  <h3>{{ _('Linked items') }}</h3>
                </div>
                <div class="form-group">
                  <h4>{{ _('Linked products and content') }}</h4>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                    </tr>
                  </thead>
                  <tbody class="resourcerows o-sortable-linkedproducts" id="linkedProductsList" v-if="!separatelyLinkedProducts || !separatelyLinkedProducts.length">
                    <tr>
                      <td><p>{{ _('No products have been linked.') }}</p></td>
                    </tr>
                  </tbody>
                  <draggable v-else v-model="separatelyLinkedProducts" tag="tbody" draggable=".linkedproduct" :delay="100" :delayOnTouchOnly="true">
                    <tr class="linkedproduct" v-for="product in separatelyLinkedProducts" v-on:click="editLinkedProductDialog(product)">
                      <td style="cursor: pointer">{{ product.linkedproduct.name }}</td>
                      <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeLinkedProduct(product)"><i class="fa fa-fw fa-close"></i></a></td>
                    </tr>
                  </draggable>
                </table>
                <div class="form-group">
                  <h4>{{ _('Linked categories') }}</h4>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                    </tr>
                  </thead>
                  <tbody class="resourcerows o-sortable-linkedcategories" id="linkedCategoriesList" v-if="!linkedCategories || !linkedCategories.length">
                    <tr>
                      <td><p>{{ _('No categories have been linked.') }}</p></td>
                    </tr>
                  </tbody>
                  <draggable v-else v-model="linkedCategories" tag="tbody" draggable=".linkedcategory" :delay="100" :delayOnTouchOnly="true">
                    <tr class="linkedcategory" v-for="category in linkedCategories" v-on:click="editLinkedCategoryDialog(category)">
                      <td style="cursor: pointer">{{ category.linkedcategory.name }}</td>
                      <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeLinkedCategory(category)"><i class="fa fa-fw fa-close"></i></a></td>
                    </tr>
                  </draggable>
                </table>
                <div class="button-col">
                  <button type="button" class="btn btn-info" id="addLinkedProduct" v-on:click="selectLinkedProductDialog(LINKEDPRODUCT_OFFER)"><i class="fa fa-fw fa-link"></i> {{ _('Link product') }}</button>
                  <button type="button" class="btn btn-info" id="addLinkedCategory" v-on:click="selectLinkedCategoryDialog"><i class="fa fa-fw fa-link"></i> {{ _('Link category') }}</button>
                </div>
                <hr />
                <p>{{ _('You can add product options to this product in four ways:') }}</p>
                <ul>
                  <li>{{ _('Mandatory') }}</li>
                  <li>{{ _('Hidden') }}</li>
                  <li>{{ _('Optional') }}</li>
                  <li>{{ _('Linked product') }}</li>
                </ul>
                <p>{{ _('Mandatory options are included in the price automatically and shown to the customer in the basket.') }} {{ _('Hidden options must not have a price, and will be hidden from the customer.') }} {{ _('Optional product options are selectable by the customer and will increase the total price.') }} {{ _('Linked products are displayed as separate products that the customer can add to the basket individually.') }}</p>
              </div>
              <div class="col-lg-6 rightcol" v-if="isAccountingConfigured">
                <div class="form-group" v-if="product.sharedDimension">
                  <h3>{{ _('Cost objects') }}</h3>
                  <draggable-multi-selector v-model="product.sharedDimension" :items="allDimensions" :groups="true" :single-select="isBrioxAccountingMode" itemProperty="name" :selectorTitle="_('Link a Cost object')" />
                </div>
              </div>
            </div>
          </div>  
          <div v-bind="tabPanel('images')" class="tab-pane active" id="images" v-if="isTabActive('images')" key="images">
            <div class="row">
              <div class="col-lg-6 leftcol">
                <h3>{{ _('Main image') }}</h3>
                <image-slot :file-id="product.file_id" :ext="product.file_ext" :owner-key="uploadOwnerKey" upload-slot="main" :empty-text="_('This product has no main image.')" input-id="mainImage" image-element-id="productImage" remove-button-id="removeImageButton" v-on:upload="queueUploads($event, 'main')" v-on:library="chooseFromLibrary('main')" v-on:remove="removeImage('main')" v-on:details="editCaption('main')" />
                <h4>{{ _('Main image layout')}}</h4>
                <select class="form-control" id="mainImageFormat" v-model="product.mainimagelayout">
                  <option value="large">{{ _('Large main image') }}</option>
                  <option value="inline">{{ _('Adjacent main image') }}</option>
                  <option value="grouped">{{ _('Grouped main image')}}</option>
                  <option value="hidden">{{ _('Hidden main image')}}</option>
                </select>
                <div style="margin-top: 5px">
                  <p v-if="product.mainimagelayout === 'large'">{{ _('Main image is displayed prominently at the top of the product page.') }}</p>
                  <p v-else-if="product.mainimagelayout === 'inline'">{{ _('Main image is shown next to the page content.') }}</p>
                  <p v-else-if="product.mainimagelayout === 'grouped'">{{ _('Main image is grouped together with additional product images.') }}</p>
                  <p v-else-if="product.mainimagelayout === 'hidden'">{{ _('Main image is hidden from the product page and only used in listings.') }}</p>
                </div>
                <hr/>
                <h3>{{ _('Mobile main image') }}</h3>
                <span v-if="!parseInt(product.file_id)">
                  <p>{{ _('This product has no main image.') }}</p>
                </span>
                <image-slot v-else :file-id="product.mobileimage_id" :ext="product.mobileimage_ext" :owner-key="uploadOwnerKey" upload-slot="mobile" :empty-text="_('This product has no mobile main image.')" input-id="mobileMainImage" image-element-id="productMobileImage" remove-button-id="removeMobileImageButton" v-on:upload="queueUploads($event, 'mobile')" v-on:library="chooseFromLibrary('mobile')" v-on:remove="removeImage('mobile')" v-on:details="editCaption('mobile')" />
              </div>
              <div class="col-lg-6 rightcol">
                <h3>{{ _('Additional images') }}</h3>
                <image-gallery id="additionalImages" v-if="product" v-model:images="product.sharedFile" :owner-key="uploadOwnerKey" upload-slot="gallery" :empty-text="_('This product has no additional images.')" input-id="additionalImage" v-on:upload="queueUploads($event, 'gallery')" v-on:library="chooseFromLibrary('gallery', { multiple: true, max: $event })" v-on:remove="removeImage($event)" v-on:details="editCaption($event)">
                  <template #badge="{ image }">
                    <span :class="isEmbeddedExtraImage(image) ? 'label label-info extra-image-badge' : 'label label-default extra-image-badge'">{{ isEmbeddedExtraImage(image) ? _('In description') : _('Gallery') }}</span>
                  </template>
                </image-gallery>
                <div class="row">
                  <div class="col-xs-12">
                    <hr/>
                    <p>{{ _('The main image is used in the embeddable widget and in Johku storefront. This image is also used in channels that enable setting a main image. The product may have a maximum of twenty images in addition to the main image.') }}</p>
                    <p class="text-muted">{{ _('Images marked In description are shown in the product description and omitted from the storefront gallery.') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('messages')" class="tab-pane active" id="messages" v-if="isTabActive('messages')" key="messages">
            <div class="row">
              <div class="col-xs-12 languageversioned">
                <h3>{{ _('Scheduled messages') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 leftcol">
                <table class="table table-striped" v-if="notifications.length">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                      <th colspan="2">{{ _('Type') }}</th>
                    </tr>
                  </thead>
                  <tbody class="messagerows" id="notifications">
                    <tr v-for="notification in notifications">
                      <td class="notification" v-on:click="editNotification(notification)">{{ makeNotificationDesc(notification) }}</td>
                      <td v-on:click="editNotification(notification)">{{ makeNotificationType(notification) }} </td>
                      <td style="width: 20px"><a class="deleteNotification pull-right" href="javascript:;" v-on:click="deleteNotification(notification)"><i class="fa fa-fw fa-close"></i></a></td>
                    </tr>
                  </tbody>
                </table>
                <div v-else>
                  <p>{{ _('No notifications have been defined.') }}</p>
                </div>
                <button type="button" class="addmessage btn btn-success" v-on:click="addNotification()"><i class="fa fa-fw fa-plus"></i> {{ _('Add message') }}</button>
              </div>
              <div class="col-sm-6 rightcol">
                <div class="row">
                  <div class="col-xs-12">
                    <p>{{ _('Create customer messages that can be sent automatically in response to various events related to orders and reservations. You can use these messages to, for example, inform the customer of delivery or ask for feedback after the reservation has ended.') }} <a id="gotoSupportSite" href="http://support.johku.com" target="_blank">{{ _('Learn more on the support site.') }}</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('johkuchannels')" class="tab-pane active" id="johkuchannels" v-if="isTabActive('johkuchannels')" key="johkuchannels">
            <div class="row">
              <div class="col-xs-12">
                <div class="publishing-status-row" style="margin-bottom: 10px;">
                  <div class="button-col" style="flex-wrap: wrap;">
                    <div class="btn-group" role="group">
                      <button type="button" :class="['btn publishing-mode-btn', publishingMode === 'none' ? 'btn-default active' : 'btn-default']" :aria-pressed="publishingMode === 'none'" v-on:click="setPublishingStatus('none')">
                        <i class="fa fa-fw fa-eye-slash"></i> {{ _('Not published') }}
                        <input type="checkbox" tabindex="-1" aria-hidden="true" :checked="publishingMode === 'none'" />
                      </button>
                      <button type="button" :class="['btn publishing-mode-btn', publishingMode === 'all' ? 'btn-success active' : 'btn-default']" :aria-pressed="publishingMode === 'all'" v-on:click="setPublishingStatus('all')">
                        <i class="fa fa-fw fa-globe"></i> {{ _('Published to all') }}
                        <input type="checkbox" tabindex="-1" aria-hidden="true" :checked="publishingMode === 'all'" />
                      </button>
                      <button type="button" :class="['btn publishing-mode-btn', publishingMode === 'selected' ? 'btn-primary active' : 'btn-default']" :aria-pressed="publishingMode === 'selected'" v-on:click="setPublishingStatus('selected')">
                        <i class="fa fa-fw fa-users"></i> {{ _('Published to selected people') }}
                        <input type="checkbox" tabindex="-1" aria-hidden="true" :checked="publishingMode === 'selected'" />
                      </button>
                    </div>
                    <button class="btn btn-info" type="button" v-on:click="scheduleVisibility"><i class="fa fa-fw fa-timer"></i> {{ _('Schedule visibility') }}</button>
                  </div>
                </div>
                <ul class="list-group" v-if="scheduledTasks.length" style="margin-bottom: 15px">
                  <li class="list-group-item" v-for="task in scheduledTasks"><i class="fa fa-fw fa-timer"></i> <a href="javascript:;" v-on:click="openScheduledTask(task.id)">{{ getTaskActionTitle(task.data.action) }} {{ DateTime.fromSeconds(Number(task.ts), { zone: timezone }).toFormat(dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(task.ts), { zone: timezone }).toFormat(timeFormat) }} <i></i></a></li>
                </ul>
                <div class="panel-group flex-panel" id="accordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="channelHeadingOne">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="javascript:;" :aria-expanded="isPanelOpen('channelOne')" aria-controls="channelCollapseOne" v-on:click="togglePanel('channelOne')">
                          <span class="title-text">{{ _('Enabled Sales Channels for this Product') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseOne" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingOne" v-if="isPanelOpen('channelOne')">
                        <div class="panel-body">
                          <div class="row" v-if="publishingMode !== 'none'">
                            <div class="col-sm-6 panel-column">
                              <div class="well well-sm" style="margin-bottom: 8px">
                                <p style="font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; margin: 0 0 6px; color: #888">{{ _('Visible in') }}</p>
                                <div class="checkbox" style="margin-top: 0">
                                  <label>
                                    <input type="checkbox" class="globalCatalogCheckbox" :checked="enabledVersionsList.length > 0 && enabledVersionsList.length === storefrontversions.length" v-on:input="versionsChanged('global', $event.target.checked)" />
                                    <strong>{{ _('All language versions') }}</strong>
                                  </label>
                                </div>
                                <template v-if="storefrontversions && storefrontversions.length">
                                  <hr style="margin: 6px 0">
                                  <div class="checkbox" style="margin-top: 4px" v-for="version in storefrontversions" :key="version">
                                    <label>
                                      <input type="checkbox" class="versionCatalogCheckbox" :checked="enabledVersionsList.includes(version)" v-on:input="versionsChanged(version, $event.target.checked)" />
                                      {{ getVersionName(version) }}
                                    </label>
                                  </div>
                                </template>
                              </div>
                              <p v-if="!publishingModeIsValid" class="text-danger" style="margin-top: -4px; margin-bottom: 8px"><i class="fa fa-fw fa-warning"></i> {{ _('At least one language must be selected.') }}</p>
                            </div>
                            <div class="col-sm-6 panel-column">
                              <div class="well well-sm" style="margin-bottom: 8px">
                                <p style="font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; margin: 0 0 6px; color: #888">{{ _('Collections') }}</p>
                                <div v-if="collectionsWithCategories.length">
                                  <div v-for="(collection, index) in collectionsWithCategories" :key="collection.id" class="collection-categories-group" style="margin-bottom: 15px;">
                                    <h4 style="margin-top: 0; margin-bottom: 10px; font-weight: 600">
                                      <label style="margin: 0; cursor: pointer; font-weight: 600">
                                        <input type="checkbox" :checked="isCollectionPublished(collection)" v-on:change="toggleCollectionPublished(collection, $event.target.checked)" />
                                        {{ collection.name }}
                                      </label>
                                    </h4>
                                    <div v-if="collection.sharedCategory && collection.sharedCategory.length">
                                      <template v-for="cat in collection.sharedCategory" :key="cat.id">
                                        <div class="checkbox">
                                          <label>
                                            <input type="checkbox" class="categoryCheckbox" :value="cat.id" v-model="enabledLocalSaleschannelCategories" />
                                            {{ cat.name }}
                                          </label>
                                        </div>
                                      </template>
                                      <hr v-if="index !== collectionsWithCategories.length - 1">
                                    </div>
                                    <p v-else class="text-muted"><small>{{ _('No categories') }}</small></p>
                                  </div>
                                </div>
                                <p v-else class="text-muted">{{ _('No collections available') }}</p>
                                <button v-if="publishingMode === 'selected'" type="button" class="btn btn-info" style="margin-top: 10px" v-on:click="openCollectionSettings"><i class="fa fa-fw fa-layer-group"></i> {{ _('Collections') }}</button>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-6 panel-column">
                              <div class="alert alert-danger" v-if="publishingMode === 'none'" style="margin-top: 10px">
                                <i class="fa fa-fw fa-warning"></i> {{ _('You can select any category, but this product will be visible only in Johku App.') }}
                              </div>
                              <div class="alert alert-danger" v-else-if="publishingMode === 'selected'" style="margin-top: 10px">
                                <i class="fa fa-fw fa-warning"></i> {{ _('You can select any category, but this product will be visible only to those who have access to the selected collections.') }}
                              </div>
                              <small style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em; color: #888" v-if="publishingMode !== 'none'">{{ _('Storefront') }}</small>
                              <h4 style="margin-top: 2px">{{ _('Categories') }}</h4>
                              <div class="privatechannels" v-if="(product.privateSaleschannels && product.privateSaleschannels.length) || (product.localSaleschannelCategories && product.localSaleschannelCategories.length)">
                                <div class="checkbox" v-for="privateSaleschannel in product.privateSaleschannels">
                                  <label>
                                    <input type="checkbox" :value="privateSaleschannel" v-model="product.sharedSaleschannel" />
                                    {{ privateSaleschannel.name }}
                                  </label>
                                </div>
                                <div class="checkbox" v-for="lscc in product.localSaleschannelCategories">
                                  <label>
                                    <input type="checkbox" class="categoryCheckbox" :value="lscc.id" v-model="enabledLocalSaleschannelCategories" />
                                    {{ lscc.name }}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <template v-if="publishingMode === 'all'">
                              <div v-for="jsc in product.johkuSaleschannels" :class="'col-sm-6 panel-column foreignchannel' + (!parseInt(jsc.active) ? ' inactivechannel' : '')">
                                <small style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em; color: #888">{{ _('Merchant') }}</small>
                                <h4 style="margin-top: 2px">{{ jsc.title ? jsc.title : jsc.channel }} <span v-if="!parseInt(jsc.active)"> ({{ _('waiting for approval') }})</span></h4>
                                <div v-for="jscc in product.johkuSaleschannelCategories[jsc.channel]" class="checkbox">
                                  <label>
                                    <input type="checkbox" class="categoryCheckbox" v-model="enabledLocalSaleschannelCategories" :value="jscc.id" />
                                    {{ jscc.name }}
                                  </label>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="panel panel-default" v-if="enabledStorefrontversions.length">
                    <div class="panel-heading" role="tab" id="channelHeadingTwo">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="javascript:;" :aria-expanded="isPanelOpen('channelTwo')" aria-controls="channelCollapseTwo" v-on:click="togglePanel('channelTwo')">
                          <span class="title-text">{{ _('QR code') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseTwo" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingTwo" v-if="isPanelOpen('channelTwo')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-12 panel-column">
                              <p>{{ _('The QR code can be used to enable mobile phone and tablet users to purchase the product directly with their device.') }}</p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-8 panel-column">
                              <div class="row">
                                <div class="col-sm-4" v-for="ver in enabledStorefrontversions">
                                  <h4>{{ getVersionName(ver) }}</h4>
                                  <div class="form-group languageversioned">
                                    <img class="img-responsive" :src="qrUrl(ver)" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4 panel-column languageversioned" v-if="isMobilePayEnabled">
                              <hr class="hidden-md hidden-lg">
                              <label><h4>{{ _('MobilePay QR code') }}</h4></label>
                              <template v-if="!hasCurrentLocaleQrCode">
                                <button style="margin-bottom: 10px" class="btn btn-primary" v-on:click="generateMobilePayQrCode()"><i class="fa fa-fw fa-qrcode"></i> {{ _('Generate MobilePay QR code') }}</button>
                              </template>
                              <template v-else>
                                <img class="img-responsive" style="max-width: 250px; margin-bottom: 10px;" :src="currentLocaleQrCode" />
                                <button style="margin-bottom: 10px" class="btn btn-danger" v-on:click="deactivateMobilePayQrCode()"><i class="fa fa-fw fa-trash"></i> {{ _('Deactivate MobilePay QR code') }}</button>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="panel panel-default" v-if="isActivityPricingEnabled && product.id && !isContent">
                    <div class="panel-heading" role="tab" id="channelPricesHeading">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="javascript:;" :aria-expanded="isPanelOpen('channelPrices')" aria-controls="channelCollapsePrices" v-on:click="togglePanel('channelPrices')">
                          <span class="title-text">{{ _('Sales channel prices') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapsePrices" class="panel-collapse" role="tabpanel" aria-labelledby="channelPricesHeading" v-if="isPanelOpen('channelPrices')">
                        <div class="panel-body">
                          <p class="help-block">{{ _('Partners and sales channels can get net prices. The general rule of each channel is set in the sales channel settings; here you can override it for this product.') }}</p>
                          <channel-price-rules :product-id="Number(product.id)" />
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="channelAccessHeading">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="javascript:;" :aria-expanded="isPanelOpen('channelAccess')" aria-controls="channelCollapseAccess" v-on:click="togglePanel('channelAccess')">
                          <span class="title-text">{{ advancedCollections ? _('Group Access') : _('Collection Access') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseAccess" class="panel-collapse" role="tabpanel" aria-labelledby="channelAccessHeading" v-if="isPanelOpen('channelAccess')">
                        <div class="panel-body">
                          <p class="help-block">{{ advancedCollections ? _('When a customer purchases or reserves this product, they are automatically added as a member of the selected groups.') : _('When a customer purchases or reserves this product, they are automatically granted access to the selected collections.') }}</p>
                          <div class="form-group">
                            <label>{{ advancedCollections ? _('User groups') : _('Collections') }}</label>
                            <draggable-multi-selector v-model="accessRules.groups" :items="accessOptions" :selectorTitle="advancedCollections ? _('Add user group') : _('Add collection')" />
                          </div>
                          <div class="form-group" v-if="accessRules.groups.length">
                            <label>{{ _('Membership duration') }}</label>
                            <select class="form-control" v-model="accessRules.duration_type">
                              <option value="permanent">{{ _('Permanent') }}</option>
                              <option value="fixed">{{ _('Fixed dates') }}</option>
                              <option value="offset">{{ _('Duration from purchase date') }}</option>
                              <option value="booking" v-if="isReservable">{{ _('Based on booking start and end date') }}</option>
                            </select>
                          </div>
                          <template v-if="accessRules.groups.length && accessRules.duration_type === 'fixed'">
                            <div class="row">
                              <div class="col-sm-6">
                                <div class="form-group">
                                  <DatePicker v-model="accessStartDate" :shortLocale="shortLocale" :title="_('Membership start date')" :placeholder="_('No start date')" :staticInput="true" :clearable="true" field="accessstart"></DatePicker>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div class="form-group">
                                  <DatePicker v-model="accessEndDate" :shortLocale="shortLocale" :title="_('Membership end date')" :placeholder="_('No end date')" :staticInput="true" :clearable="true" field="accessend"></DatePicker>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="accessRules.groups.length && accessRules.duration_type === 'offset'">
                            <div class="form-group">
                              <label>{{ _('Membership duration') }}</label>
                              <div class="row">
                                <div class="col-xs-6">
                                  <input type="number" class="form-control" v-model.number="accessRules.offset_value" min="1" />
                                </div>
                                <div class="col-xs-6">
                                  <select class="form-control" v-model="accessRules.offset_unit">
                                    <option value="day">{{ _('Days') }}</option>
                                    <option value="week">{{ _('Weeks') }}</option>
                                    <option value="month">{{ _('Months') }}</option>
                                    <option value="year">{{ _('Years') }}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="accessRules.groups.length && accessRules.duration_type === 'booking'">
                            <p class="help-block"><i class="fa fa-fw fa-info-circle"></i> {{ _('Membership will be active from the booking start time to the booking end time.') }}</p>
                          </template>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('otherchannels')" class="tab-pane active" id="otherchannels" v-if="isOtherChannelsAvailable && isTabActive('otherchannels')" key="otherchannels">
            <div class="row">
              <div class="col-xs-12">
                <div class="panel-group flex-panel" id="otheraccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-default" v-if="isChannexEnabled && !isSellable && !isEvent">
                    <div class="panel-heading" role="tab" id="otherHeadingOne">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#otheraccordion" href="javascript:;" :aria-expanded="isPanelOpen('otherChannelOne')" aria-controls="otherCollapseOne" v-on:click="togglePanel('otherChannelOne')">
                          <span class="title-text">{{ _('External Sales Channels') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="otherCollapseOne" class="panel-collapse" role="tabpanel" aria-labelledby="otherHeadingOne" v-if="isPanelOpen('otherChannelOne')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-12 panel-column" v-if="!channexProperty">
                              <div class="form-inline">
                                <button v-if="isChannexConnected" type="button" class="btn btn-success" v-on:click="linkChannexPropertyDialog()" :disabled="!isBillingInformationOk"><i class="fa fa-fw fa-link"></i> {{ _('building|Link Property') }}</button>
                                <button v-else-if="isAdmin" type="button" class="btn btn-success" v-on:click="enableChannex"><i class="fa fa-fw fa-magic"></i> {{ _('Enable External Sales Channels') }}</button>
                                <p v-else class="text-muted">{{ _('Ask an administrator to enable external sales channels.') }}</p>
                              </div>
                              <div class="alert alert-danger" style="margin-top: 10px" v-if="!isBillingInformationOk">
                                <p>{{ _('In order to link products to external sales channel properties you must first provide your billing details. You can do this in the Company Profile section of Johku Settings.') }}</p>
                                <button style="margin-top: 10px" class="btn btn-danger" type="button" v-on:click="openCompanyProfile"><i class="fa fa-fw fa-building-o"></i> {{ _('Open Company Profile') }}</button>
                              </div>
                            </div>
                            <div class="col-sm-12 panel-column" v-if="channexProperty">
                              <label>{{ channexProperty.title }}</label> ({{ getChannexPropertyTypeTitle(channexProperty.property_type) }})
                              <template v-if="channexRoomType">
                                <div class="pull-right">
                                  <button class="btn btn-primary btn-xs" type="button" v-on:click="modifyChannexPropertyDialog(channexProperty)"><i class="fa fa-fw fa-cog"></i> {{ _('Settings') }}</button>
                                  <button class="btn btn-primary btn-xs" type="button" v-on:click="modifyChannexRoomTypeDialog(channexProperty, channexRoomType, loadChannexRoomType)"><i class="fa fa-fw fa-pencil"></i> {{ _('Modify') }}</button>
                                </div>
                                <label>{{ channexRoomType.title }}</label>, <span>{{ _('Rooms') }}: {{ channexRoomType.count_of_rooms }}</span>, 
                                {{ _('Occupancy') }}: {{ channexRoomType.default_occupancy }} ({{ _('Adults') }}: {{ channexRoomType.occ_adults }}, {{ _('Children') }}: {{ channexRoomType.occ_children }}, {{ _('Infants') }}: {{ channexRoomType.occ_infants }})
                              </template>
                            </div>
                          </div>
                          <div class="row" v-if="channexToken && channexProperty">
                            <div class="col-sm-12">
                              <h4>{{ _('Search for existing channels or connect to new ones') }}</h4>
                            </div>
                            <iframe frameBorder="0" width="100%" height="600px" :src="channexToken.server + '/auth/exchange?oauth_session_key=' + channexToken.token + '&app_mode=headless&allow_notifications_edit=true&redirect_to=/channels&group_id=' + settings.channex_group"></iframe>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="panel panel-default" v-if="isGofinlandEnabled || isRetkipaikkaEnabled || isMyAllocatorEnabled || ((isBokunEnabled || isGygEnabled) && isActivity)">
                    <div class="panel-heading" role="tab" id="otherHeadingTwo">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#otheraccordion" href="javascript:;" :aria-expanded="isPanelOpen('otherChannelTwo')" aria-controls="otherCollapseTwo" v-on:click="togglePanel('otherChannelTwo')">
                          <span class="title-text">{{ _('Other Sales Channels') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="otherCollapseTwo" class="panel-collapse" role="tabpanel" aria-labelledby="otherHeadingTwo" v-if="isPanelOpen('otherChannelTwo')">
                        <div class="panel-body">
                          <div class="row">
                            <div v-if="isGofinlandEnabled && !isSellable && !isEvent && (!isActivity || parseInt(product.enable_gofinland))" class="col-sm-6 panel-column reservablePanel hide-sellable hide-generic show-reservable">
                              <h4>{{ _('Nettimökki') }}</h4>
                              <div class="checkbox">
                                <label>
                                  <input type="checkbox" name="enable_gofinland" v-model="product.enable_gofinland" true-value="1" false-value="0" />
                                  {{ _('Include in Nettimökki') }}
                                  <span v-if="false && isActivity">
                                    <i v-if="isGofinlandSuccess" class="fa fa-fw fa-check-circle" style="color: #cddc39"></i>
                                    <i v-else class="fa fa-fw fa-exclamation-triangle" style="color: red" :title="gofinlandError"></i>
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div v-if="isRetkipaikkaEnabled && !isSellable" class="col-sm-6 panel-column reservablePanel hide-sellable show-reservable">
                              <h4>Retkipaikka.fi</h4>
                              <div class="checkbox">
                                <label>
                                  <input type="checkbox" name="enable_retkipaikka" v-model="product.enable_retkipaikka" true-value="1" false-value="0" />
                                  {{ _('Include in Retkipaikka') }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="isMyAllocatorVisible">
                            <div class="col-sm-12 panel-column reservablePanel hide-sellable hide-generic show-reservable" v-if="!isSellable && !isEvent">
                              <h4>{{ _('MyAllocator') }}<span v-if="product.ma_roomid"> (Property ID {{ product.ma_propertyid }}, Room ID {{ product.ma_roomid }})</span></h4>
                              <iframe width="100%" style="border-width: 0" :src="myAllocatorUrl"></iframe>
                            </div>
                          </div>
                          <div class="row" v-if="isBokunEnabled && isActivity">
                            <div class="col-sm-12 panel-column reservablePanel hide-sellable hide-generic show-reservable">
                              <h4>{{ _('Bókun') }}</h4>
                              <div class="checkbox">
                                <label>
                                  <input type="checkbox" name="enable_bokun" v-model="product.enable_bokun" true-value="1" false-value="0" />
                                  {{ _('Include in Bókun') }}
                                </label>
                              </div>
                              <p class="help-block" v-if="isActivityPricingEnabled && isActivityCalendarPricing">{{ _('Bókun cannot add a price per extra participant to a booking price. So in a product with one ticket type, each rate with a maximum number of participants goes to Bókun as one rate per group size, priced per booking, for example 249 € for 2 and 294 € for 3 (up to 30 group sizes). If the rates change, map them again in Bókun.') }}</p>
                              <p class="help-block" v-else-if="isActivityPricingEnabled">{{ _('Bókun cannot add a price per extra participant to a booking price. So when a price row has a booking price that includes participants or a participant price on top of it, it goes to Bókun as one rate per group size, priced per booking, for example 249 € for 2 and 294 € for 3. This needs one ticket type and a maximum number of participants on the price row or its rate (up to 30 group sizes). If the rates change, map them again in Bókun.') }}</p>
                              <div class="form-group" v-if="isActivityPricingEnabled">
                                <label for="bokunId">{{ _('Bókun experience id') }}</label>
                                <input type="text" class="form-control" id="bokunId" v-model="product.bokun_id" :placeholder="_('Enter the id of the linked Bókun experience')" />
                                <p class="help-block">{{ _('Rates, ticket categories and start times are sent to the linked Bókun experience when updating linked Bókun experiences is on in the sales channel settings.') }}</p>
                              </div>
                              <template v-if="bokunRatesProductId">
                                <h5>{{ _('Rates in Bókun') }} <i class="fa fa-fw fa-cog fa-spin text-muted" v-if="bokunRatesLoading && bokunRates"></i></h5>
                                <div class="form-inline bokunrates-filters">
                                  <div class="form-group form-group-inline">
                                    <DatePicker v-model="bokunRatesDate" :shortLocale="shortLocale" :title="_('Date')" :staticInput="true" field="bokunratesdate"></DatePicker>
                                  </div>
                                  <div class="form-group form-group-inline" v-if="bokunRateTimes.length > 1">
                                    <label for="bokunRatesTime">{{ _('Start time') }}</label>
                                    <select class="form-control input-sm" id="bokunRatesTime" v-model="bokunRatesTime">
                                      <option v-for="time in bokunRateTimes" :key="time" :value="time">{{ time }}</option>
                                    </select>
                                  </div>
                                </div>
                                <!-- A reload keeps the previous rates on screen, so the panel doesn't shrink and jump -->
                                <p v-if="bokunRatesLoading && !bokunRates" class="text-muted"><i class="fa fa-fw fa-cog fa-spin"></i> {{ _('Loading...') }}</p>
                                <template v-else-if="bokunRates">
                                  <div class="alert alert-warning" v-if="bokunRates.warnings && bokunRates.warnings.length">
                                    <ul class="list-unstyled">
                                      <li v-for="warning in bokunRates.warnings" :key="warning.code"><i class="fa fa-fw fa-exclamation-triangle"></i> {{ warning.message }}</li>
                                    </ul>
                                  </div>
                                  <div class="table-responsive" v-if="bokunRateSlot">
                                    <table class="table table-striped bokunrates">
                                      <thead>
                                        <tr>
                                          <th>{{ _('Rate plan') }}</th>
                                          <th>{{ _('Rate ID') }}</th>
                                          <th>{{ _('Price') }}</th>
                                          <th>{{ _('Pricing') }}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="rate in bokunRateSlot.rates" :key="rate.id">
                                          <td>{{ bokunRateText(rate) }}<br /><small class="text-muted">{{ _('In Bókun: %s').replace('%s', rate.label) }}</small></td>
                                          <td><code>{{ rate.id }}</code></td>
                                          <td v-if="rate.price.per === 'booking'">{{ bokunMoney(rate.price.amount) }}</td>
                                          <td v-else><span v-for="(tier, i) in rate.price.tiers" :key="tier.id">{{ i ? ', ' : '' }}{{ tier.name }} {{ bokunMoney(tier.amount) }}</span></td>
                                          <td>{{ rate.price.per === 'booking' ? _('Per booking') : _('Per person') }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <p v-else class="text-muted">{{ _('No prices on this date.') }}</p>
                                  <p class="help-block">{{ _('The rates and prices Bókun gets on this date, from the saved product.') }}</p>
                                </template>
                              </template>
                              <p v-else-if="isActivityPricingEnabled && parseInt(product.enable_bokun) && isNewProduct" class="help-block">{{ _('Save the product to see its rates in Bókun.') }}</p>
                            </div>
                          </div>
                          <div class="row" v-if="isGygEnabled && isActivity">
                            <div class="col-sm-12 panel-column reservablePanel hide-sellable hide-generic show-reservable">
                              <h4>GetYourGuide</h4>
                              <div class="checkbox">
                                <label>
                                  <input type="checkbox" name="enable_gyg" :checked="!!parseInt(product.enable_gyg)" v-on:change="toggleGyg($event)" />
                                  {{ _('Include in GetYourGuide') }}
                                </label>
                              </div>
                              <template v-if="gygOptionsProductId">
                                <p class="help-block">
                                  {{ _('Each row is connected to its own option in GetYourGuide\'s Supplier Portal, in the option\'s Connectivity Settings.') }}
                                  {{ _('The first connection needs the product ID pasted there. After that, and from the start if you registered with GetYourGuide through Johku, you can choose the products by name.') }}
                                  <a href="https://supplier.getyourguide.com" target="_blank" rel="noopener">{{ _('Open the Supplier Portal') }}</a>
                                </p>
                                <p v-if="gygOptionsLoading" class="text-muted"><i class="fa fa-fw fa-cog fa-spin"></i> {{ _('Loading...') }}</p>
                                <!-- Ticked but not saved yet: the server still has the product outside GetYourGuide -->
                                <p v-else-if="gygOptions && gygOptions.enabled === false" class="help-block">{{ _('Save the product to see the product IDs for GetYourGuide.') }}</p>
                                <template v-else-if="gygOptions">
                                  <div class="alert alert-warning" v-if="gygOptions.product_problems && gygOptions.product_problems.length">
                                    <ul class="list-unstyled">
                                      <li v-for="problem in gygOptions.product_problems"><i class="fa fa-fw fa-exclamation-triangle"></i> {{ problem }}</li>
                                    </ul>
                                  </div>
                                  <div class="table-responsive" v-if="gygOptions.options && gygOptions.options.length">
                                    <table class="table table-striped gygoptions">
                                      <thead>
                                        <tr>
                                          <th>{{ _('Product ID') }}</th>
                                          <th>{{ _('Duration') }}</th>
                                          <th>{{ _('Pricing') }}</th>
                                          <th>{{ _('Type') }}</th>
                                          <th>{{ _('Status') }}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="option in gygOptions.options" :key="option.key">
                                          <td class="text-nowrap">
                                            <code>{{ option.key }}</code>
                                            <button type="button" class="btn btn-default btn-xs" v-on:click="copyGygProductId(option.key)" :title="_('Copy to clipboard')"><i class="fa fa-fw fa-clipboard"></i></button>
                                          </td>
                                          <td>
                                            {{ option.label }}
                                            <ul class="list-unstyled text-danger" v-if="!option.eligible && option.problems && option.problems.length">
                                              <li v-for="problem in option.problems"><small><i class="fa fa-fw fa-exclamation-triangle"></i> {{ problem }}</small></li>
                                            </ul>
                                          </td>
                                          <td>{{ option.kind === 'GROUP' ? _('Per group') : _('Per person') }}</td>
                                          <td>{{ option.timetype === 'PERIOD' ? _('Whole day') : _('Start times') }}</td>
                                          <td>
                                            <template v-if="option.status === 'deactivated'">
                                              <span class="text-warning">{{ _('Deactivated by GetYourGuide') }}</span><template v-if="option.status_reason"><br /><small class="text-muted">{{ option.status_reason }}</small></template>
                                              <br /><button type="button" class="btn btn-warning btn-xs" v-on:click="activateGygOption(option)" :disabled="!!gygActivating[option.key]"><i class="fa fa-fw fa-rotate-right"></i> {{ _('Reactivate') }}</button>
                                            </template>
                                            <span v-else>{{ _('Active') }}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <p v-else class="text-muted">{{ _('The product has no options that can be sold through GetYourGuide.') }}</p>
                                </template>
                              </template>
                              <p v-else-if="parseInt(product.enable_gyg) && isNewProduct" class="help-block">{{ _('Save the product to see the product IDs for GetYourGuide.') }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="panel panel-default" v-if="isAvailabilitySyncAvailable">
                    <div class="panel-heading" role="tab" id="otherHeadingThree">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#otheraccordion" href="javascript:;" :aria-expanded="isPanelOpen('otherChannelThree')" aria-controls="otherCollapseThree" v-on:click="togglePanel('otherChannelThree')">
                          <span class="title-text">{{ _('Availability Synchronization') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="otherCollapseThree" class="panel-collapse" role="tabpanel" aria-labelledby="otherHeadingThree" v-if="isPanelOpen('otherChannelThree')">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-sm-12 panel-column reservablePanel hide-sellable hide-generic show-reservable">
                              <p>
                                {{ _('Changes to availability are automatically synchronized to external sales channels.') }}
                                {{ _('Reservation changes that are limited to a speficic date range trigger immediate sync operations.') }}
                                {{ _('Larger changes require a full sync, which are run in a background queue which updates every minute.') }}
                              </p>
                              <p>
                                <strong>{{ _('If there is an issue updating availability for whatever reason, you may manually schedule a full sync here.') }}</strong>
                              </p>
                              <button class="btn btn-warning" type="button" :disabled="isFullSyncScheduled && syncTries !== 3" v-on:click="scheduleFullSync"><i class="fa fa-fw fa-timer"></i> {{ _('Schedule a full sync') }}</button>
                              <i v-if="isFullSyncScheduled">
                                <span v-if="syncTries >= 3">
                                  {{ _('The synchronization has failed three times. You may try queueing again, or if the problem persists, contact support.') }}
                                </span>
                                <span v-else-if="syncTries > 0">
                                  {{ _('The synchronization has failed %s times and it will be retried a total of three times.').replace('%s', syncTries) }}
                                </span>
                                <span v-else>
                                  {{ _('There is a full sync scheduled for this product in queue position %s.').replace('%s', syncQueuePosition) }}
                                </span>
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
          <div class="button-col">
            <button class="btn btn-danger" v-on:click="remove(_('Are you sure you want to delete the product? Deletion can\'t be undone.'))" type="button" :disabled="!isDeleteButtonEnabled"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete') }}</span></button>
            <Dropdown buttonClass="btn-warning" v-if="parseInt(product.archived)" direction="up">
              <template #trigger>
                <i class="fa fa-fw fa-globe"></i><span class="hidden-xs"> {{ _('Restore from archive') }}</span><span class="caret hidden-xs"></span>
              </template>
              <li><a href="javascript:;" v-on:click="publish">{{ _('Now') }} <i></i></a></li>
              <li><a href="javascript:;" v-on:click="schedulePublish">{{ _('At a specific time') }} <i></i></a></li>
              <li v-if="scheduledArchiveTasks && scheduledArchiveTasks.length" role="separator" class="divider"></li>
              <li v-for="task in scheduledArchiveTasks"><a href="javascript:;" v-on:click="openScheduledTask(task.id)">{{ getTaskActionTitle(task.data.action) }} {{ DateTime.fromSeconds(Number(task.ts), { zone: timezone }).toFormat(dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(task.ts), { zone: timezone }).toFormat(timeFormat) }} <i></i></a></li>
            </Dropdown>
            <Dropdown buttonClass="btn-warning" v-else direction="up">
              <template #trigger>
                <i class="fa fa-fw fa-box-archive"></i><span class="hidden-xs"> {{ _('verb|Archive') }}</span><span class="caret hidden-xs"></span>
              </template>
              <li><a href="javascript:;" v-on:click="archive">{{ _('Now') }} <i></i></a></li>
              <li><a href="javascript:;" v-on:click="scheduleArchive">{{ _('At a specific time') }} <i></i></a></li>
              <li v-if="scheduledArchiveTasks && scheduledArchiveTasks.length" role="separator" class="divider"></li>
              <li v-for="task in scheduledArchiveTasks"><a href="javascript:;" v-on:click="openScheduledTask(task.id)">{{ getTaskActionTitle(task.data.action) }} {{ DateTime.fromSeconds(Number(task.ts), { zone: timezone }).toFormat(dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(task.ts), { zone: timezone }).toFormat(timeFormat) }} <i></i></a></li>
            </Dropdown>
            <button class="btn btn-default" v-on:click="copyDialog" type="button" :disabled="!isCopyButtonEnabled"><i class="fa fa-fw fa-copy"></i><span class="hidden-xs"> {{ _('Copy') }}</span></button>
            <button class="btn btn-info" v-on:click="translateDialog" type="button" v-if="isTranslateButtonVisible" :disabled="!isTranslateButtonEnabled"><i class="fa fa-fw fa-language"></i><span class="hidden-xs"> {{ _('Translate') }}</span></button>
            <button v-if="!isContent" type="button" v-on:click="downloadSalesReport" class="btn btn-default"><i class="fa fa-fw fa-download"></i><span class="hidden-xs"> {{ _('Sales report') }}</span></button>
          </div>
          <div class="button-col">
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
          </div>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from 'axios'
import striptags from 'striptags'
import changewatcher from '~/lib/changewatcher'
import channexhelpers from '~/lib/channexhelpers'
import components from '~/lib/components'
import currencies from '~/lib/currencies'
import dimensions from '~/lib/dimensions'
import formats from '~/lib/formats'
import notifications from '~/lib/notifications'
import permissions from '~/lib/permissions'
import rateplanhelpers from '~/lib/rateplanhelpers'
import pricetierrules from '~/lib/pricetierrules'
import settingseditors from '~/lib/settingseditors'
import settingshelpers from '~/lib/settingshelpers'
import slidetransition from '~/lib/slidetransition'
import tags from '~/lib/tags'
import uploadaware from '~/lib/uploadaware'
import { LinkedCategorySelector, ProductOptionSelector, FileCaption, CopyPricerows, ModifyPricerows, LocationSelector, PricerowDetails, StarttimeDetails, DraggableMultiSelector, RangeDetails, DistanceDetails, GoogleCalendarSelector, 
         TransportationRouteSelector, IglooLockSelector, FilmSearchDetails, ModalResourcepoolDetails as ResourcepoolDetails, ModalResourceDetails as ResourceDetails, ResourceTypeSelector, ShowtimesCalendar, TaskTypeSelector, PricingList, 
         FormsList, TagsList, TermsList, ModalVouchersList as VouchersList, ModalPaymentPlansList as PaymentPlansList, TranslationSelector, DeliverySettings, TransportationRouteList, ModalSettings as Settings, Editor } from '#components'
import { mapGetters } from 'vuex'
import { ModelListSelect, MultiListSelect } from 'vue-search-select'
import { DateTime } from 'luxon'
import { embeddedFileIds, stripEmbeddedImage } from '~/lib/tiptap/johkuEmbedImage'

export default {
  data () {
    return {
      controller: null,
      addChoiceMenuOpen: false,
      moveMenuGroup: null,
      transportRoutes: {}, // Activity pricing: outbound routes of transportation products offered as places, by product id
      gygOptions: null, // GetYourGuide: options of the product (GET gyg/options.json)
      gygOptionsLoading: false,
      bokunRates: null, // Bókun: the rates and prices the plugin reports on bokunRatesDate (GET products/{id}/bokunrates.json)
      bokunRatesLoading: false,
      bokunRatesDate: new Date(),
      bokunRatesTime: null,
      gygActivating: {},
      reloadSettingsOnVersionChange: false,
      // debugInterval: null,
      product: {
        channeldata: {},
        pricing_engine: 'pricerow'
      },
      savedPricingEngine: 'pricerow',
      activityDurations: [], // Activity calendar: [{ value, unit }], saved as product_units
      panelOpen: {
        two: undefined,
        twoB: undefined,
        twoC: undefined,
        three: undefined,
        four: undefined,
        five: undefined,
        six: undefined,
        seven: undefined,
        availability: undefined,
        availabilitySummary: undefined,
        channelOne: undefined,
        channelTwo: undefined,
        channelAccess: undefined,
        channelPrices: undefined,
        otherChannelOne: undefined,
        otherChannelTwo: undefined,
        otherChannelThree: undefined
      },
      panelGroups: {
        two: 'details', // Panels in the same group toggle each others' visibility
        twoB: 'details',
        twoC: 'details',
        three: 'details',
        four: 'details',
        five: 'details',
        six: 'details',
        seven: '*',
        channelOne: '*', // Panel group '*' doesn't affect other panels
        channelTwo: '*',
        channelAccess: '*',
        channelPrices: '*',
        otherChannelOne: '*',
        otherChannelTwo: '*',
        otherChannelThree: '*',
      },
      accessRules: {
        groups: [],
        duration_type: 'permanent',
        fixed_startdate: null,
        fixed_enddate: null,
        offset_value: 1,
        offset_unit: 'month'
      },
      accessOptions: [],
      collectionsWithCategories: [],
      publishingMode: 'none',
      deleted: false,
      origResourceCapacity: {},
      resourceCapacity: {},
      resourceUnits: {},
      resourcePoolUnits: {},
      saving: false,
      allTags: [],
      adminTagToAdd: '',
      adminTagSearchText: '',
      productTagToAdd: '',
      productTagSearchText: '',
      seoTagToAdd: '',
      seoTagSearchText: '',
      linkedProducts: [],
      linkedCategories: [],
      tagToAdd: null,
      map: null,
      allStops: {},
      allCommissions: [],
      pricingOptions: [],
      termsOptions: [],
      formOptions: [],
      selectedDeliveryMethods: [],
      selectedPricerows: [],
      pricerowToggle: false,
      pricerowRateplanFilter: '',
      notifications: [],
      ranges: [],
      distributors: [],
      allVouchers: [],
      customValidity: false,
      DateTime: DateTime,
      preselectedDate: null,
      localProducts: {},
      availabilityType: 'single',
      createResourceCount: 2,
      createSeatCount: 1,
      confirmingAvailability: false,
      linkExistingResources: false,
      resourcesTainted: false,
      deadlineOffsetOption: 'prior',
      initialMaccsChecksum: '',
      externalProducts: [],
      channexProperty: false,
      channexRoomType: false,
      channexToken: false,
      channexServer: 'https://staging.channex.io',
      channexProperties: [],
      installedChannexApplications: [],
      syncStatus: {},
      scheduledTasks: [],
      doShowAllFields: false,
      pricings: [],
      paymentplans: []
    }
  },
  mixins: [changewatcher, channexhelpers, components, currencies, dimensions, formats, notifications, permissions, pricetierrules, rateplanhelpers, settingshelpers, settingseditors, slidetransition, tags, uploadaware],
  computed: {
    ...mapGetters(['countries', 'numberFormat']),
    showAllFields: {
      get() {
        return parseInt(this.$store.state.userData.advanced)
      },
      set(newValue) {
        return this.$store.dispatch('storeShowAllFields', parseInt(newValue))
      }
    },
    embeddedDescriptionFileIds() {
      return embeddedFileIds(this.product?.channeldata?.description)
    },
    advancedCollections() {
      return parseInt(this.$store.state.userData?.advancedcollections) || 0
    },
    showDetailsTab() {
      return this.product && this.product.displayedtype == 'movie' || this.showAllFields
    },
    tabList() {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'details', label: this._('Details'), hidden: !this.showDetailsTab },
        { id: 'availability', label: this._('Availability'), hidden: this.isContent },
        { id: 'prices', label: this._('Prices'), hidden: this.isContent },
        { id: 'links', label: this._('Links'), hidden: !this.showAllFields },
        { id: 'images', label: this._('Images') },
        { id: 'messages', label: this._('Messages'), hidden: this.isContent },
        { id: 'johkuchannels', label: this._('Johku Sales Channels') },
        { id: 'otherchannels', label: this._('Other Sales Channels'), hidden: !this.isOtherChannelsAvailable }
      ])
    },
    scheduledArchiveTasks () {
      return this.scheduledTasks.filter(t => t.data.action === 'publish' || t.data.action === 'archive')
    },
    scheduledVisibilityTasks () {
      return this.scheduledTasks.filter(t => t.data.action === 'visibility')
    },
    isFullSyncScheduled () {
      return this.syncStatus && this.syncStatus.productid
    },
    syncTries () {
      return this.syncStatus.tried ? this.syncStatus.tried : 0
    },
    syncQueuePosition () {
      return this.syncStatus.pos ? this.syncStatus.pos : 0
    },
    isPackagingVisible () {
      return this.isFeatureEnabled('packaging') && this.product && parseInt(this.product.type) !== this.TYPE_SELLABLE
    },
    isProductOptionsVisible () {
      return this.product && parseInt(this.product.subtype) !== this.SUBTYPE_CONTENT
    },
    isOtherChannelsAvailable () {
      if (!this.product) {
        return false
      }
      if (this.isSellable || this.product.subtype === this.SUBTYPE_GENERIC) {
        return false
      }
      if (!this.isChannexEnabled && !this.isRetkipaikkaEnabled && !this.isGofinlandEnabled && !this.isMyAllocatorVisible && !((this.isBokunEnabled || this.isGygEnabled) && this.isActivity)) {
        return false
      }
      return true
    },
    isAvailabilitySyncAvailable () {
      if (!this.product) {
        return false
      }
      if (this.isSellable || this.product.subtype === this.SUBTYPE_GENERIC) {
        return false
      }
      if (!this.isChannexEnabled && !this.isMyAllocatorVisible) {
        return false
      }
      return true
    },
    isVoucherCountAvailable () {
      if (!this.product || !this.vouchers) {
        return false
      }
      const voucher = this.vouchers.find(v => v.id == this.product.voucher_id)
      if (!voucher || parseInt(voucher.open)) {
        return false
      }
      return true
    },
    isOpenValueCard () {
      if (!this.product || !this.product.voucher_id) {
        return false
      }
      return !this.isVoucherCountAvailable
    },
    isResourceLinkerVisible () {
      // This commented pile of shit used to be what determined if this was visible. Yeesh
      // (product.sharedResource && product.sharedResource.length) && parseInt(this.product.subtype, 10) !== this.SUBTYPE_CONTENT || (product.sharedResourcepool && product.sharedResourcepool.length) && parseInt(this.product.subtype, 10) !== this.SUBTYPE_CONTENT || (!confirmingAvailability && this.linkExistingResources) && parseInt(this.product.subtype, 10) !== this.SUBTYPE_CONTENT
      if (parseInt(this.product.subtype, 10) === this.SUBTYPE_CONTENT) {
        return false
      }
      if (this.isAvailabilityConfigurationVisible) {
        return false
      }
      return true
    },
    defaultStarttimeMode () {
      if (this.isCalendarPricing) {
        return 'daily'
      }
      if (this.isActivityCalendarPricing) { // The activity calendar prices start times at fixed times
        return 'hourly'
      }
      if (this.product && this.product.ownStarttime && this.product.ownStarttime.length > 0) {
        return this.product.ownStarttime[0].mode
      }
      if (this.product && this.product.ownPricerow && this.product.ownPricerow.length > 0) {
        return parseInt(this.product.ownPricerow[0].unittype) === this.UNIT_DAY ? 'daily' : 'hourly'
      }
      return 'hourly'
    },
    isDeleteButtonEnabled () {
      if (this.selectedPricerows && this.selectedPricerows.length) {
        return false
      }
      return true
    },
    isCopyButtonEnabled () {
      return this.isDeleteButtonEnabled
    },
    isTranslateButtonVisible () {
      return this.isFeatureEnabled('translation')
    },
    isTranslateButtonEnabled() {
      return this.locale !== this.version
    },
    groupedPackageOptions: {
      get() {
        let ret = []
        let prevGroup = null
        for (let i = 0; i < this.packageOptions.length; i++) {
          const lp = this.packageOptions[i]
          if (!lp.group) {
            ret.push({
              type: 'linkedproduct',
              product: lp
            })
          } else if (prevGroup !== lp.group) {
            ret.push({
              type: 'group', 
              products: [lp]
            })
          } else if (prevGroup === lp.group) {
            ret[ret.length - 1].products.push(lp)
          }
          prevGroup = lp.group
        }
        return ret
      },
      set(newValue) {
        let ret = []
        for (let i = 0; i < newValue.length; i++) {
          const item = newValue[i]
          if (item.type === 'linkedproduct') {
            ret.push(item.product)
          } else if (item.type === 'group') {
            ret = [...ret, ...item.products]
          }
        }
        this.packageOptions = ret
      }
    },
    packageOptions: {
      get() {
        return this.linkedProducts.filter(lp => Number(lp.type) === this.LINKEDPRODUCT_PACKAGED)
      },
      set(newValue) {
        this.linkedProducts = [...newValue, ...this.productOptions, ...this.separatelyLinkedProducts]
      }
    },
    existingPackageGroups() {
      return [...new Set(this.packageOptions.map(lp => lp.group).filter(g => !!g))]
    },
    productOptions: {
      get() {
        return this.linkedProducts.filter(lp => Number(lp.type) !== this.LINKEDPRODUCT_OFFER && Number(lp.type) !== this.LINKEDPRODUCT_PACKAGED)
      },
      set(newValue) {
        this.linkedProducts = [...this.packageOptions, ...newValue, ...this.separatelyLinkedProducts]
      }      
    },
    // Activity pricing: product options outside any choice (options in a choice are shown in its box)
    ungroupedOptionList: {
      get() {
        if (!this.isActivityPricingEnabled) {
          return this.productOptions
        }
        return this.productOptions.filter(lp => !this.findOptionGroup(lp))
      },
      set(newValue) {
        newValue.forEach(lp => {
          if (this.findOptionGroup(lp)) {
            this.setLinkedProductGroup(lp, '') // Dragged out of a choice
          }
        })
        this.productOptions = [...newValue, ...this.productOptions.filter(lp => newValue.indexOf(lp) === -1)]
      }
    },
    choiceDragGroup () { // Only optional options can be dropped into a choice
      return { name: 'productoptions', pull: true, put: (to, from, dragEl) => !!dragEl && dragEl.getAttribute('data-optional') === '1' }
    },
    ungroupedOptionalOptions () { // Options that can be moved into a choice
      return this.ungroupedOptionList.filter(lp => Number(lp.type) === this.LINKEDPRODUCT_OPTIONAL)
    },
    separatelyLinkedProducts: {
      get() {
        return this.linkedProducts.filter(lp => Number(lp.type) === this.LINKEDPRODUCT_OFFER)
      },
      set(newValue) {
        this.linkedProducts = [...this.packageOptions, ...this.productOptions, ...newValue]
      }
    },
    isNewProduct () {
      return !this.product || !this.product.id
    },
    isTemplate: {
      get () {
        return parseInt(this.product.istemplate) ? 1 : 0
      },
      set (newValue) {
        this.product.istemplate = newValue ? 1 : 0
      }
    },
    isGroupDeal() {
      if (!this.product) {
        return false
      }
      if (parseInt(this.product.min_count) > 0) {
        return true
      }
      return false
    },
    isSellable() {
      return this.product && parseInt(this.product.type) === this.TYPE_SELLABLE
    },
    isReservable() {
      return this.product && parseInt(this.product.type) === this.TYPE_RESERVABLE
    },
    selectablePaymentPlans () {
      const recurring = !this.isReservable
      return this.paymentplans.filter(plan => (plan.type === 'recurring') === recurring || plan.id == this.product.paymentplan_id)
    },
    showBuyablePaymentPlan () {
      if (!this.isFeatureEnabled('paymentplans') || !this.product || parseInt(this.product.type) !== this.TYPE_SELLABLE || parseInt(this.product.subtype) !== this.SUBTYPE_GENERIC) {
        return false
      }
      return !!this.product.paymentplan_id || this.paymentplans.some(plan => plan.type === 'recurring')
    },
    hasRecurringPlanOnReservable () {
      if (!this.isReservable || !this.product.paymentplan_id) {
        return false
      }
      const plan = this.paymentplans.find(p => p.id == this.product.paymentplan_id)
      return !!plan && plan.type === 'recurring'
    },
    canUseCalendarEngine() {
      return this.isFeatureEnabled('calendarpricing') &&
        this.isReservable &&
        !this.isEvent &&
        !this.isActivity &&
        !this.isTransportation &&
        parseInt(this.product.hide_pricing, 10) !== this.PRICING_TICKET
    },
    isCalendarPricing() {
      return this.product && this.product.pricing_engine === 'calendar'
    },
    calendarSellUnitNoun () {
      const type = this.product && this.product.displayedtype
      const subtype = this.product ? parseInt(this.product.subtype, 10) : 0
      if (type === 'hotelroom' || subtype === this.SUBTYPE_HOTELLINX) {
        return 'room'
      }
      if (type === 'cottage' || type === 'cabin' || type === 'villa' || (subtype === this.SUBTYPE_CABIN && type !== 'otheraccommodation')) {
        return 'cottage'
      }
      return 'unit'
    },
    calendarPricingIntro () {
      if (this.calendarSellUnitNoun === 'cottage') {
        return this._('Set nightly rates and stay restrictions on a calendar. Add multiple rate plans if you sell more than one price for the same cottage.')
      }
      if (this.calendarSellUnitNoun === 'unit') {
        return this._('Set nightly rates and stay restrictions on a calendar. Add multiple rate plans if you sell more than one price for the same unit.')
      }
      return this._('Set nightly rates and stay restrictions on a calendar. Add multiple rate plans if you sell more than one price for the same room.')
    },
    isSavedAsCalendar() {
      return this.savedPricingEngine === 'calendar'
    },
    isActivityPricingEnabled () {
      return this.isFeatureEnabled('activitypricing')
    },
    canUseActivityCalendarEngine () { // Activity pricing: activities can be priced on an activity calendar
      return this.isActivityPricingEnabled &&
        this.isReservable &&
        this.isActivity &&
        parseInt(this.product.hide_pricing, 10) !== this.PRICING_TICKET
    },
    isActivityCalendarPricing () {
      return this.isActivityPricingEnabled && !!this.product && this.product.pricing_engine === 'activitycalendar'
    },
    isSavedAsActivityCalendar () {
      return this.isActivityPricingEnabled && this.savedPricingEngine === 'activitycalendar'
    },
    activityStartMinutes () { // Start minutes of the hourly start time rows, which the activity calendar prices
      const minutes = new Set()
      ;(this.product && this.product.ownStarttime ? this.product.ownStarttime : []).forEach(t => {
        const minute = parseInt(t && t.timestart, 10)
        if (t && t.mode === 'hourly' && !isNaN(minute)) {
          minutes.add(minute)
        }
      })
      return Array.from(minutes).sort((a, b) => a - b)
    },
    hasPricerowRateplans () { // Activity pricing: rate plans of price row priced reservable products
      return this.isActivityPricingEnabled && this.isReservable && !this.isEvent && !this.isCalendarPricing && !this.isSavedAsCalendar &&
        !this.isActivityCalendarPricing && !this.isSavedAsActivityCalendar
    },
    pricerowRateplans () {
      if (!this.hasPricerowRateplans || !this.product.ownRateplan) {
        return []
      }
      return this.product.ownRateplan
    },
    showPricerowRateplans () {
      return this.pricerowRateplans.length > 0
    },
    isParticipantTicketsVisible () { // Activities and transportation: a booking takes a seat per participant (Johku ProductRules)
      return this.isActivityPricingEnabled && this.isReservable &&
        (this.isActivity || parseInt(this.product.subtype) === this.SUBTYPE_TRANSPORTATION)
    },
    optionGroups () {
      return this.product && this.product.ownOptiongroup ? this.product.ownOptiongroup : []
    },
    placeTransportIds () { // Activity pricing: transportation products offered as places in pick-up / drop-off choices
      const ids = []
      this.optionGroups.filter(group => this.isPlaceGroup(group)).forEach(group => {
        this.groupOptions(group).filter(lp => this.isTransportOption(lp)).forEach(lp => {
          if (ids.indexOf(String(lp.linkedproduct_id)) === -1) {
            ids.push(String(lp.linkedproduct_id))
          }
        })
      })
      return ids.join(',')
    },
    optionGroupList: {
      get () {
        return this.optionGroups
      },
      set (newValue) {
        this.product.ownOptiongroup = newValue
      }
    },
    isActivity() {
      return this.product && parseInt(this.product.subtype) === this.SUBTYPE_ACTIVITY
    },
    isEvent() {
      return this.product && parseInt(this.product.subtype) === this.SUBTYPE_EVENT
    },
    isGeneric() {
      return this.product && parseInt(this.product.subtype) === this.SUBTYPE_GENERIC
    },
    isExternal() {
      return this.product && parseInt(this.product.subtype, 10) >= this.SUBTYPE_EXTERNAL
    },
    isMovie() {
      return this.isEvent && this.product.displayedtype === 'movie'
    },
    isOpera() {
      return this.isEvent && this.product.displayedtype === 'opera'
    },
    isBallet() {
      return this.isEvent && this.product.displayedtype === 'ballet'
    },
    isConcert() {
      return this.isEvent && this.product.displayedtype === 'concert'
    },
    isTheater() {
      return this.isEvent && this.product.displayedtype === 'theater'
    },
    isContent() {
      return this.product && parseInt(this.product.subtype) === this.SUBTYPE_CONTENT
    },
    isValuecard() {
      return this.product && parseInt(this.product.subtype) === this.SUBTYPE_VALUECARD
    },
    isExchangedValuecard() {
      return this.product && parseInt(this.product.subtype) === this.SUBTYPE_EXCHANGED_VALUECARD
    },
    isGofinlandEnabled() {
      return this.product && parseInt(this.settings.channel_gofinland)
    },
    isRetkipaikkaEnabled() {
      return this.product && parseInt(this.settings.channel_retkipaikka)
    },
    isChannexEnabled() {
      return this.product && this.isFeatureEnabled('channex')
    },
    isChannexConnected() {
      return this.product && parseInt(this.settings.channel_channex) && this.settings.channex_group && this.isFeatureEnabled('channex')
    },
    isGofinlandSuccess() {
      return this.product && this.product.gofinlandstatus && this.product.gofinlandstatus.status === 'success'
    },
    isBillingInformationOk() {
      return this.settings && this.settings.companyname && this.settings.companyid && (this.settings.billingemail || (this.settings.companyevoice && this.settings.companyevoiceint))
    },
    gofinlandError() {
      return 'API Error' + (this.product && this.product.gofinlandstatus && this.product.gofinlandstatus.errorfield && this.product.gofinlandstatus.errormessage ? this.product.gofinlandstatus.errorfield + ': ' + this.product.gofinlandstatus.errormessage : '')
    },
    embedParams() {
      if (!this.product || !this.product.id) {
        return ''
      }
      let fieldArr = []
      if (parseInt(this.product.displayname)) {
        fieldArr.push('name')
      }
      if (parseInt(this.product.displaydescription)) {
        fieldArr.push('desc')
      }
      if (parseInt(this.product.displayimage)) {
        fieldArr.push('image')
      }
      if (parseInt(this.product.displayprice)) {
        fieldArr.push('price')
      }
      if (parseInt(this.product.displaystock)) {
        fieldArr.push('stock')
      }
      let buttonStr = ''
      if (this.product.buttontext) {
        buttonStr = '&buttonText=' + escape(this.product.buttontext)
      }
			let versionStr = '&locale=' + this.locale + '&version=' + this.version
      return '?shopId=' + this.shopId + '&productId=' + this.product.id + '&fields=' + fieldArr.join(',') + buttonStr + versionStr
    },
    embedCode() {
      if (!this.product || !this.product.id) {
        return ''
      }
      return '<script type="text/javascript" src="' + this.baseDomain + 'embed/' + this.embedParams + '"><\/script>'
    },
    basketEmbedCode() {
			let versionStr = '&locale=' + this.locale + '&version=' + this.version
      return '<script type="text/javascript" src="' + this.baseDomain + 'embed/basket/?shopId=' + this.shopId + versionStr + '"><\/script>'
    },
    availabilityEmbedCode() {
			let versionStr = '&locale=' + this.locale + '&version=' + this.version
      return '<script type="text/javascript" src="' + this.baseDomain + 'embed/availability/?shopId=' + this.shopId + versionStr + '"><\/script>'
    },
    embedPreviewUrl() {
      if (!this.product) {
        return ''
      }
      return this.baseDomain + 'preview/?url=' + escape(this.embedParams)
    },
    // Posted into a new tab by the click itself. window.open after the bridge
    // token request is dropped by Safari. GET would send the session cookie
    // from another site and could preview a shop the link chose.
    storePreviewRedirect () {
      if (!this.product || !this.product.id || !this.shopId || !this.version) {
        return ''
      }
      return '/' + this.version + '/products/' + this.product.id + '-' + this.shopId + '-preview'
    },
    storefrontversions () {
      if (!this.settings) {
        return []
      }
      return this.settings.storefrontversions ? this.settings.storefrontversions.split(';') : []
    },
    enabledStorefrontversions () {
      return this.storefrontversions.filter(v => this.enableInCatalog[v])
    },
    mobilePayQrCodes () {
      if (!this.product || !this.product.mobilepayqr) {
        return {}
      }
      // Try to parse as JSON (new format)
      try {
        const parsed = JSON.parse(this.product.mobilepayqr)
        if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
          return parsed
        }
      } catch (e) {
        // Not JSON, treat as old format (plain string)
      }
      // Old format: return as object with 'default' key for backwards compatibility
      return { 'default': this.product.mobilepayqr }
    },
    hasMobilePayQrCodes () {
      return this.product && this.product.mobilepayqr && Object.keys(this.mobilePayQrCodes).length > 0
    },
    currentLocaleQrCode () {
      const locale = this.version || 'default'
      return this.mobilePayQrCodes[locale] || this.mobilePayQrCodes['default'] || null
    },
    hasCurrentLocaleQrCode () {
      return this.currentLocaleQrCode !== null
    },
    enabledLocalSaleschannelCategories: {
      get () {
        return this.product &&  this.product.enable_category ? this.product.enable_category.split(';') : []
      },
      set (newValue) {
        this.product.enable_category = newValue.join(';')
      }
    },
    enabledPublishedCollections: {
      get () {
        if (!this.product || !this.product.sharedCollection) return []
        return this.product.sharedCollection.map(c => (typeof c === 'object' ? Number(c.id) : Number(c))).filter(id => id > 0)
      },
      set (newValue) {
        if (!this.product) return
        this.product.sharedCollection = (newValue || []).map(id => Number(id)).filter(id => id > 0)
      }
    },
    enabledJohkuSaleschannelCategories: {
      get () {
        return this.product ? this.product.enabledJohkuSaleschannelCategories : []
      },
      set (newValue) {
        this.product.enabledJohkuSaleschannelCategories = newValue
      }
    },
    hidePricing: {
      get () {
        if (this.product.hide_pricing === null) {
          return 0
        }
        return this.product.hide_pricing
      },
      set (newValue) {
        this.product.hide_pricing = newValue
        if (parseInt(newValue, 10) === this.PRICING_TICKET) {
          this.resetPricetiers()
        }
      }
    },
    loyaltyType: {
      get () {
        if (!this.product.loyalty) {
          return null
        }
        return this.product.loyalty
      },
      set (newValue) {
        this.product.loyalty = newValue
      }
    },
    epassiBenefit: {
      get () {
        if (!this.product.epassi_benefit) {
          return null
        }
        return this.product.epassi_benefit
      },
      set (newValue) {
        this.product.epassi_benefit = newValue
      }
    },
    edenredBenefit: {
      get () {
        if (!this.product.edenred_benefit) {
          return null
        }
        return this.product.edenred_benefit
      },
      set (newValue) {
        this.product.edenred_benefit = newValue
      }
    },
    isTransportation () {
      return this.type === '1-3-generic'
    },
    enableParticipantPricing () {
      if (!this.product) {
        return false
      }
      return parseInt(this.product.enable_participant_pricing)
    },
    type: {
      get () {
        if (!this.product) {
          return '0-0-generic'
        }
        return this.product.type + '-' + (this.product.subtype ? this.product.subtype : '0') + '-' + (this.product.displayedtype ? this.product.displayedtype : 'generic')
      },
      set (newValue) {
        const parts = newValue.split('-')
        const newSubtype = parts[1]
        if (parseInt(this.product.subtype, 10) !== this.SUBTYPE_TICKET && parseInt(newSubtype, 10) === this.SUBTYPE_TICKET) {
          // Tickets cannot be visible in the catalog or in collections, only through direct links/categories
          this.product.enable_catalog = '0'
          this.product.enable_collection = '0'
        }
        this.product.type = parts[0]
        this.product.subtype = newSubtype
        this.product.displayedtype = parts[2]
      }
    },
    typeTitles () {
      return [
        { 'title': this._('Buyable product'), 'subtypetitle': '', 'subtype': this.SUBTYPE_GENERIC, 'type': this.TYPE_SELLABLE, 'displayedtype': 'generic' },
        { 'title': this._('Rentable product'), 'subtypetitle': '', 'subtype': this.SUBTYPE_GENERIC, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'generic' },
        { 'title': this._('Activity'), 'subtypetitle': '', 'subtype': this.SUBTYPE_ACTIVITY, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'generic' },
        { 'title': this._('Event'), 'subtypetitle': '', 'subtype': this.SUBTYPE_EVENT, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'generic' },
        { 'title': this._('Transportation'), 'subtypetitle': '', 'subtype': this.SUBTYPE_TRANSPORTATION, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'generic' },
        { 'title': this._('Ticket'), 'subtypetitle': '', 'subtype': this.SUBTYPE_TICKET, 'type': this.TYPE_SELLABLE, 'displayedtype': 'generic' },
        { 'title': this._('Value card'), 'subtypetitle': '', 'subtype': this.SUBTYPE_VALUECARD, 'type': this.TYPE_SELLABLE, 'displayedtype': 'generic' },
        { 'title': this._('Exchanged value card'), 'subtypetitle': '', 'subtype': this.SUBTYPE_EXCHANGED_VALUECARD, 'type': this.TYPE_SELLABLE, 'displayedtype': 'generic' },
        { 'title': this._('Reservable cabin'), 'subtypetitle': '', 'subtype': this.SUBTYPE_CABIN, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'generic' },
        { 'title': this._('Hotel room'), 'subtypetitle': '', 'subtype': this.SUBTYPE_HOTELLINX, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'generic' },
        { 'title': this._('Hotel room'), 'subtypetitle': '', 'subtype': this.SUBTYPE_CABIN, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'hotelroom' },
        { 'title': this._('Cottage'), 'subtypetitle': '', 'subtype': this.SUBTYPE_CABIN, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'cottage' },
        { 'title': this._('Villa'), 'subtypetitle': '', 'subtype': this.SUBTYPE_CABIN, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'villa' },
        { 'title': this._('Other accommodation'), 'subtypetitle': '', 'subtype': this.SUBTYPE_CABIN, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'otheraccommodation' },
        { 'title': this._('Rental gear'), 'subtypetitle': '', 'subtype': this.SUBTYPE_GENERIC, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'rentalgear' },
        { 'title': this._('Rental equipment'), 'subtypetitle': '', 'subtype': this.SUBTYPE_GENERIC, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'rentalequipment' },
        { 'title': this._('Meeting venue'), 'subtypetitle': '', 'subtype': this.SUBTYPE_GENERIC, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'meetingvenue' },
        { 'title': this._('Party venue'), 'subtypetitle': '', 'subtype': this.SUBTYPE_GENERIC, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'partyvenue' },
        { 'title': this._('Other venue'), 'subtypetitle': '', 'subtype': this.SUBTYPE_GENERIC, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'othervenue' },
        { 'title': this._('Reservable service'), 'subtypetitle': '', 'subtype': this.SUBTYPE_ACTIVITY, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'reservableservice' },
        { 'title': this._('Events service'), 'subtypetitle': '', 'subtype': this.SUBTYPE_ACTIVITY, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'eventsservice' },
        { 'title': this._('Trip'), 'subtypetitle': '', 'subtype': this.SUBTYPE_ACTIVITY, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'trip' },
        { 'title': this._('Guided trip'), 'subtypetitle': '', 'subtype': this.SUBTYPE_ACTIVITY, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'guidedtrip' },
        { 'title': this._('Movie'), 'subtypetitle': '', 'subtype': this.SUBTYPE_EVENT, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'movie' },
        { 'title': this._('Theater'), 'subtypetitle': '', 'subtype': this.SUBTYPE_EVENT, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'theater' },
        { 'title': this._('Concert'), 'subtypetitle': '', 'subtype': this.SUBTYPE_EVENT, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'concert' },
        { 'title': this._('Opera'), 'subtypetitle': '', 'subtype': this.SUBTYPE_EVENT, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'opera' },
        { 'title': this._('Ballet'), 'subtypetitle': '', 'subtype': this.SUBTYPE_EVENT, 'type': this.TYPE_RESERVABLE, 'displayedtype': 'ballet' },
        { 'title': this._('Content'), 'subtypetitle': '', 'subtype': this.SUBTYPE_CONTENT, 'type': this.TYPE_SELLABLE, 'displayedtype': 'generic' }
      ]
    },
    availableTypes () {
      let options = this.typeTitles
      const subTypeTitles = {}
      subTypeTitles[this.SUBTYPE_GENERIC] = this._('Rentable product')
      subTypeTitles[this.SUBTYPE_CABIN] = this._('Rentable accommodation')
      subTypeTitles[this.SUBTYPE_ACTIVITY] = this._('Activity')
      subTypeTitles[this.SUBTYPE_TRANSPORTATION] = this._('Transportation')
      subTypeTitles[this.SUBTYPE_EVENT] = this._('Event')
      subTypeTitles[this.SUBTYPE_TICKET] = this._('Ticket')
      subTypeTitles[this.SUBTYPE_VALUECARD] = this._('Value card')
      subTypeTitles[this.SUBTYPE_EXCHANGED_VALUECARD] = this._('Exchanged value card')
      subTypeTitles[this.SUBTYPE_CONTENT] = this._('Content')
      subTypeTitles[this.SUBTYPE_EXTERNAL] = this._('External')
      subTypeTitles[this.SUBTYPE_HOTELLINX] = this._('Hotellinx')
      if (this.product && !isNaN(parseInt(this.product.subtype))) {
        options = options.filter(o => 
          parseInt(o.type) === parseInt(this.product.type) && // Disable switching between main types (TYPE_SELLABLE and TYPE_RESERVABLE)
          (parseInt(this.product.subtype) === this.SUBTYPE_EVENT && parseInt(o.subtype) === parseInt(this.product.subtype) ||
          parseInt(this.product.subtype) !== this.SUBTYPE_EVENT && parseInt(o.subtype) !== this.SUBTYPE_EVENT) && // Disable switching to and from this.SUBTYPE_EVENT
          (parseInt(this.product.subtype) === this.SUBTYPE_VALUECARD && parseInt(o.subtype) === parseInt(this.product.subtype) ||
          parseInt(this.product.subtype) !== this.SUBTYPE_VALUECARD && parseInt(o.subtype) !== this.SUBTYPE_VALUECARD) && // Disable switching to and from this.SUBTYPE_VALUECARD
          (parseInt(this.product.subtype) === this.SUBTYPE_EXCHANGED_VALUECARD && parseInt(o.subtype) === parseInt(this.product.subtype) ||
          parseInt(this.product.subtype) !== this.SUBTYPE_EXCHANGED_VALUECARD && parseInt(o.subtype) !== this.SUBTYPE_EXCHANGED_VALUECARD) && // Disable switching to and from this.SUBTYPE_EXCHANGED_VALUECARD
          (parseInt(this.product.subtype) === this.SUBTYPE_CONTENT && parseInt(o.subtype) === parseInt(this.product.subtype) ||
          parseInt(this.product.subtype) !== this.SUBTYPE_CONTENT && parseInt(o.subtype) !== this.SUBTYPE_CONTENT) // Disable switching to and from SUBTYPE_CONTENT
        )
      }
      if (this.product && parseInt(this.product.subtype) === this.SUBTYPE_ACTIVITY && parseInt(this.product.hide_pricing) === this.PRICING_TICKET) {
        options = options.filter(o => parseInt(o.subtype) === this.SUBTYPE_ACTIVITY)
        options.push({
          title: this._('Ticket pricing locks type to activity'),
          type: this.TYPE_SELLABLE,
          subtype: this.SUBTYPE_GENERIC,
          displayedtype: 'generic',
          disabled: true
        })
      }
      for (let i = 0; i < options.length; i++) {
        let option = options[i]
        if (subTypeTitles[parseInt(option.subtype)] && subTypeTitles[parseInt(option.subtype)] !== option.title) {
          if (option.type === this.TYPE_SELLABLE && option.subtype === this.SUBTYPE_GENERIC) {
            // No subtypetitle
          } else {
            options[i].subtypetitle = subTypeTitles[parseInt(option.subtype)]
          }
        }
      }
      return options
    },
    isMobilePayEnabled () {
      return this.settings && this.settings.pay_option18_msn && this.settings.pay_option18_msn !== 'pending'
    },
    isLoyaltyEnabled () {
      return this.settings && this.settings.pay_option17_loyalty && !this.isContent
    },
    isPaymentMethodBenefitEnabled () {
      return this.settings && this.settings.pay_option17_loyalty === 'both' && !this.isContent
    },
    isEpassiEnabled () {
      return this.settings && parseInt(this.settings.pay_option15) === 1 && this.settings.pay_option15_siteid !== '' && this.settings.pay_option15_mac !== '' && !this.isContent
    },
    isEdenredEnabled () {
      return this.settings && parseInt(this.settings.pay_option16) === 1 && this.settings.pay_option9_privatekey !== '' && this.settings.pay_option9_apikey !== '' && !this.isContent
    },
    johkuSalesChannelTags () {
      return this.product && this.product.johkuSaleschannelTags ? this.product.johkuSaleschannelTags : []
    },
    selectedVoucher () {
      if (!this.product || !this.product.voucher_id || !this.allVouchers || !this.allVouchers.length) {
        return null
      }
      const voucher = this.allVouchers.find(v => v.id === this.product.voucher_id)
      if (!voucher) {
        return null
      }
      return voucher
    },
    showVoucherPriceWarning () {
      if (parseInt(this.product.subtype) == this.SUBTYPE_VALUECARD) {
        const voucher = this.selectedVoucher
        if (voucher && !parseFloat(voucher.open) && parseFloat(this.product.price) !== parseFloat(voucher.value) * parseInt(this.product.vouchers)) {
          return true
        }
      }
      return false
    },
    showVoucherVatWarning () {
      if (parseInt(this.product.subtype) == this.SUBTYPE_VALUECARD) {
        const voucher = this.selectedVoucher
        if (voucher && parseInt(voucher.shared) && parseFloat(this.product.vat) !== 0) {
          return true
        }
      }
      return false
    },
    vats () {
      return this.settings && this.settings.vats ? [...new Set([...this.settings.vats.split(';').sort((a, b) => b - a).map(v => parseFloat(v)), 0])] : [0]
    },
    totalStockBalance () {
      return this.product.warehouse_count
    },
    resourceOrPoolCount () {
      return this.resourceCount + this.resourcepoolCount
    },
    resourceOrPoolCountExcludingOpeningHours () {
      return this.resourceCount + this.resourcepoolCount - this.product.sharedResource.filter(r => r.displayedtype === 'openinghours').length
    },
    resourceCount () {
      if (!this.product || !this.product.sharedResource) {
        return 0
      }
      return this.product.sharedResource.length
    },
    resourcepoolCount () {
      if (!this.product || !this.product.sharedResourcepool) {
        return 0
      }
      return this.product.sharedResourcepool.length
    },
    selectedPricetiers: {
      get () {
        if (!this.product || !this.product.sharedPricetier) {
          return []
        }
        return this.product.sharedPricetier.map(pt => pt.id)
      },
      set (newValue) {
        this.product.sharedPricetier = this.allPricetiers.filter(pt => newValue.includes(pt.id))
        // Whenever we select/unselect price tiers, make sure that we don't have any price tier values
        // in the price rows that are no longer selected
        const pricetierIds = this.product.sharedPricetier.map(pt => pt.id)
        if (this.product.ownPricerow) {
          for (let i = 0; i < this.product.ownPricerow.length; i++) {
            if (this.product.ownPricerow[i].pricetiers) {
              let pricetiers = this.product.ownPricerow[i].pricetiers.split(';')
              let finalPricetiers = []
              for (let j = 0; j < pricetiers.length; j++) {
                let data = pricetiers[j].split(':')
                if (pricetierIds.includes(data[0])) {
                  finalPricetiers.push(pricetiers[j])
                } 
              }
              this.product.ownPricerow[i].pricetiers = finalPricetiers.join(';')
            }
          }
        }
      }
    },
    allPricetiers () {
      if (!this.settings || !this.settings.ownPricetier || !this.product) {
        return []
      }
      return this.settings.ownPricetier.map(p => { // We call the map function to create an object that matches the one in product.sharedPricetier (without sharedText[] found in settings.ownPricetier)
        const { sharedText, ...pt } = p // This creates a clone of the p object as pt without the sharedText property
        const ppt = this.product.sharedPricetier.find(spt => spt.id === pt.id)
        if (ppt) {
          pt.default_count = ppt.default_count
        } else  {
          pt.default_count = null
        }
        if (this.isActivityPricingEnabled) { // Ticket type rules can be switched off per product
          pt.rules_disabled = ppt && parseInt(ppt.rules_disabled) ? 1 : 0
        }
        return pt
      })
    },
    allRoutes () {
      let ret = []
      if (!this.product || !this.product.sharedResource) {
        return ret
      }
      for (let i = 0; i < this.product.sharedResource.length; i++) {
        if (!this.product.sharedResource[i].sharedRoute) {
          continue
        }
        for (let j = 0; j < this.product.sharedResource[i].sharedRoute.length; j++) {
          let r = this.product.sharedResource[i].sharedRoute[j]
          ret.push(r)
        }
      }
      return ret
    },
    allZones () {
      let zones = []
      let doneIds = []
      for (let routeId in this.allStops) {
        if(Object.prototype.hasOwnProperty.call(this.allStops, routeId)) {
          for (let i = 0; i < this.allStops[routeId].length; i++) {
            let stop = this.allStops[routeId][i]
            for (let j = 0; j < stop.sharedZone.length; j++) {
              let zone = stop.sharedZone[j]
              if (!doneIds[zone.id]) {
                doneIds[zone.id] = true
                zones.push(zone)
              }
            }
          }
        }
      }
      return zones
    },
    sortedActivityCategories () {
      const categories = [
        { value: 'activity', title: this._('Activity') },
        { value: 'iceswimming', title: this._('Ice swimming') },
        { value: 'carting', title: this._('Carting') },
        { value: 'movies', title: this._('Movies') },
        { value: 'animalpark', title: this._('Animal park') },
        { value: 'experience', title: this._('Experience') },
        { value: 'geocaching', title: this._('Geocaching') },
        { value: 'golf', title: this._('Golf') },
        { value: 'crosscountryskiing', title: this._('Cross-country skiing') },
        { value: 'slowingdown', title: this._('Slowing down') },
        { value: 'amusementpark', title: this._('Amusement park') },
        { value: 'wellbeing', title: this._('Well-being') },
        { value: 'yoga', title: this._('Yoga') },
        { value: 'fishing', title: this._('Fishing') },
        { value: 'nationalpark', title: this._('National park') },
        { value: 'city', title: this._('City attraction') },
        { value: 'rockclimbing', title: this._('Rock climbing') },
        { value: 'churches', title: this._('Churches') },
        { value: 'rafting', title: this._('White water rafting') },
        { value: 'culture', title: this._('Cultural attraction') },
        { value: 'gym', title: this._('Gym') },
        { value: 'spa', title: this._('Spa') },
        { value: 'handicraft', title: this._('Handicraft') },
        { value: 'walking', title: this._('Walking') },
        { value: 'forchildren', title: this._('For children') },
        { value: 'downhillskiing', title: this._('Downhill skiing') },
        { value: 'jogging', title: this._('Jogging') },
        { value: 'sports', title: this._('Sports') },
        { value: 'castle', title: this._('Castle') },
        { value: 'skating', title: this._('Skating') },
        { value: 'snowshoeing', title: this._('Snowshoeing') },
        { value: 'snowboarding', title: this._('Snowboarding') },
        { value: 'nature', title: this._('Natural attraction') },
        { value: 'naturereserve', title: this._('Nature reserve') },
        { value: 'naturecenter', title: this._('Nature center') },
        { value: 'monastery', title: this._('Monastery') },
        { value: 'mountainbiking', title: this._('Mountain biking') },
        { value: 'canoeing', title: this._('Canoeing') },
        { value: 'hunting', title: this._('Hunting') },
        { value: 'motorsledging', title: this._('Motor sledging') },
        { value: 'museum', title: this._('Museum') },
        { value: 'atvride', title: this._('ATV ride') },
        { value: 'sightseeing', title: this._('Sightseeing') },
        { value: 'exhibitions', title: this._('Exhibitions') },
        { value: 'shopping', title: this._('Shopping') },
        { value: 'localdelicacy', title: this._('Local delicacy') },
        { value: 'sleddinghill', title: this._('Sledding hill') },
        { value: 'cycling', title: this._('Cycling') },
        { value: 'horsebackriding', title: this._('Horseback riding') },
        { value: 'restaurant', title: this._('Restaurant') },
        { value: 'camping', title: this._('Camping') },
        { value: 'tourskating', title: this._('Tour skating') },
        { value: 'cruise', title: this._('Cruise') },
        { value: 'rollerskating', title: this._('Roller skating') },
        { value: 'food', title: this._('Food') },
        { value: 'groupexercise', title: this._('Group exercise') },
        { value: 'sauna', title: this._('Sauna') },
        { value: 'adventure', title: this._('Adventure') },
        { value: 'wallclimbing', title: this._('Wall climbing') },
        { value: 'berryandmushroompicking', title: this._('Berry and mushroom picking') },
        { value: 'diving', title: this._('Diving') },
        { value: 'sup', title: this._('Stand up paddling') },
        { value: 'orienteering', title: this._('Orienteering') },
        { value: 'winteroutdooractivities', title: this._('Winter outdoor activities') },
        { value: 'dancing', title: this._('Dancing') },
        { value: 'events', title: this._('Events') },
        { value: 'tennis', title: this._('Tennis') },
        { value: 'swimming', title: this._('Swimming') },
        { value: 'hiking', title: this._('Hiking') },
        { value: 'hikingtrail', title: this._('Hiking trail') },
        { value: 'boating', title: this._('Boating') },
        { value: 'waterskiing', title: this._('Water skiing') }
      ]
      return categories.sort((a, b) => a.title > b.title ? 1 : -1)
    },
    channelActivityCategories: {
      get () {
        if (this.product.channeldata && this.channelCategories) {
          return this.sortedActivityCategories.filter(c => this.channelCategories.includes(c.value))
        }
        return []
      },
      set (newValue) {
        // Convert an array of objects into a single object with the values as keys of value true
        this.product.channeldata.categories = newValue.reduce((obj, item) => { 
          const v = item.value
          return { ...obj, [v]: true }
        }, {})
      }
    },
    isMyAllocatorVisible () {
      return this.isMyAllocatorEnabled && parseInt(this.product.ma_propertyid)
    },
    isMyAllocatorEnabled () {
      if (this.settings.channel_myallocator && this.settings.myallocator_userid && this.settings.myallocator_token) {
        return true
      }
      return false
    },
    isBokunEnabled () {
      if (parseInt(this.settings.channel_bokun)) {
        return true
      }
      return false
    },
    isGygEnabled () {
      return this.isFeatureEnabled('gyg') && this.isFeatureEnabled('activitypricing') && !!parseInt(this.settings.channel_gyg)
    },
    // The GetYourGuide options are shown for a saved activity that is included in GetYourGuide
    gygOptionsProductId () {
      if (this.isGygEnabled && this.isActivity && this.product.id && parseInt(this.product.enable_gyg)) {
        return this.product.id
      }
      return null
    },
    // The Bókun rate preview is shown for a saved activity that is included in Bókun (activity pricing)
    bokunRatesProductId () {
      if (this.isBokunEnabled && this.isActivity && this.isActivityPricingEnabled && this.product.id && parseInt(this.product.enable_bokun)) {
        return this.product.id
      }
      return null
    },
    // Start times of an activity calendar product's preview; price row rates are the same at every time
    bokunRateTimes () {
      return this.bokunRates && this.bokunRates.slots ? this.bokunRates.slots.map(slot => slot.time).filter(time => time) : []
    },
    bokunRateSlot () {
      const slots = this.bokunRates && this.bokunRates.slots ? this.bokunRates.slots : []
      return slots.find(slot => slot.time === this.bokunRatesTime) || slots[0] || null
    },
    myAllocatorUrl () {
      return `https://inbox.myallocator.com/callbacks/plogin.xt?Vendor=johku&UserId=${this.settings.myallocator_userid}&UserToken=${this.settings.myallocator_token}&PropertyId=${this.product.ma_propertyid}&Destination=channel_direct`
    },
    enableInCatalog () {
      let ret = {}
      let enabled = []
      if (this.product.enable_catalog) {
        if (parseInt(this.product.enable_catalog) === 0) {
          enabled = []
        } else if (parseInt(this.product.enable_catalog) === 1) {
          enabled = this.storefrontversions
        } else if (this.product.enable_catalog.split) {
          enabled = this.product.enable_catalog.split(';')
        }
      }
      ret['global'] = enabled.length === this.storefrontversions.length ? 1 : 0
      for (let i = 0; i < this.allVersions.length; i++) {
        ret[this.allVersions[i].identifier] = enabled.includes(this.allVersions[i].identifier) ? 1 : (ret['global'] ? 1 : 0)
      }
      return ret
    },
    publishingStatus () {
      const catalogEmpty = !this.product?.enable_catalog || this.product.enable_catalog === '0'
      const collectionEmpty = !this.product?.enable_collection || this.product.enable_collection === '0'
      if (catalogEmpty && collectionEmpty) return 'none'
      if (!catalogEmpty) return 'all'
      return 'selected'
    },
    publishingModeIsValid () {
      return this.publishingMode === 'none' || this.enabledVersionsList.length > 0
    },
    isSaveButtonEnabled () {
      if (this.saving || this.saved || this.loading || this.locked || this.waitingForUploads) return false
      return this.publishingModeIsValid
    },
    uploadOwner () {
      if (!this.product) {
        return null
      }
      const id = this.product.id
      const label = this._('Product') + (id ? ' ' + id : '') + (this.product.name ? ': ' + this.product.name : '')
      return {
        type: 'product',
        id,
        label,
        open: {
          component: 'ProductDetails',
          title: label,
          width: 6,
          data: {
            productId: id,
            activeTab: 'images'
          }
        }
      }
    },
    enabledVersionsList () {
      const raw = (this.product?.enable_catalog && this.product.enable_catalog !== '0')
        ? this.product.enable_catalog
        : this.product?.enable_collection
      if (!raw || raw === '0') return []
      if (raw === '1') return [...this.storefrontversions]
      return raw.split ? raw.split(';') : []
    },
    versions () {
      const enabledVersions = this.settings.versions.split(';')
      let ret = []
      for (let i = 0; i < this.allVersions.length; i++) {
        if (enabledVersions.includes(this.allVersions[i].identifier)) {
          ret.push(this.allVersions[i])
        }
      }
      return ret
    },
    validatedActiveTab() {
      if (this.showAllFields) {
        return this.activeTab
      }
      switch(this.activeTab) {
        case 'details':
          if (this.showDetailsTab) {
            return 'details'
          }
          return 'general'
        case 'prices':
        case 'links':
        if (this.isContent) {
          return 'general'
        }
      }
      return this.activeTab
    },
    adminTags () {
      return this.product && this.product.sharedTag ? this.product.sharedTag.filter(t => t.title && t.title.match && t.title.match(/^admin:::/)) : []
    },
    productTags () {
      return this.product && this.product.sharedTag ? this.product.sharedTag.filter(t => t.title && t.title.match && t.title.match(/^product:::/)) : []
    },
    versionlessProductTags () {
      return this.productTags.filter(t => !t.title.match(/:::[a-z]{2}_[A-Z]{2}:::/))
    },
    currentVersionProductTags () {
      return this.productTags.filter(t => t.title.match(new RegExp(':::' + this.version +  ':::')))
    },
    otherVersionProductTags () {
      return this.productTags.filter(t => t.title.match(/:::[a-z]{2}_[A-Z]{2}:::/) && !t.title.match(new RegExp(':::' + this.version +  ':::')))
    },
    seoTags () {
      return this.product && this.product.sharedTag ? this.product.sharedTag.filter(t => t.title && t.title.match && t.title.match(/^seo:::/)) : []
    },
    versionlessSeoTags () {
      return this.seoTags.filter(t => !t.title.match(/:::[a-z]{2}_[A-Z]{2}:::/))
    },
    currentVersionSeoTags () {
      return this.seoTags.filter(t => t.title.match(new RegExp(':::' + this.version +  ':::')))
    },
    otherVersionSeoTags () {
      return this.seoTags.filter(t => t.title.match(/:::[a-z]{2}_[A-Z]{2}:::/) && !t.title.match(new RegExp(':::' + this.version +  ':::')))
    },
    allAdminTags () {
      return this.allTags.filter(t => t.category === 'admin').sort((a, b) => a.title > b.title ? 1 : -1)
    },
    allProductTags () {
      return this.allTags.filter(t => t.category === 'product').sort((a, b) => a.title > b.title ? 1 : -1)
    },
    allSeoTags () {
      return this.allTags.filter(t => t.category === 'seo').sort((a, b) => a.title > b.title ? 1 : -1)
    },
    allSelectableAdminTags () {
      const ids = this.adminTags.map(t => t.id)
      return this.allAdminTags.filter(t => !ids.includes(t.id))
    },
    allSelectableProductTags () {
      const ids = this.productTags.map(t => t.id)
      return [...this.allProductTags.filter(t => t.locale === this.version), ...this.allProductTags.filter(t => t.locale == 'default')].filter(t => !ids.includes(t.id))
    },
    allSelectableSeoTags () {
      const ids = this.seoTags.map(t => t.id)
      return [...this.allSeoTags.filter(t => t.locale === this.version), ...this.allSeoTags.filter(t => t.locale === 'default')].filter(t => !ids.includes(t.id))
    },
    channelAttributes: {
      get() {
        if (!this.product || !this.product.channeldata || !this.product.channeldata.attributes) {
          return []
        }
        return Object.keys(this.product.channeldata.attributes)
      },
      set(newValue) {
        if (!this.product.channeldata) {
          this.product.channeldata = {}
        }
        this.product.channeldata.attributes = (newValue || []).reduce((o, v) => { o[v] = true; return o }, {})
      }
    },
    activityCategories() {
      let categories = []
      if (!this.product || !this.product.channeldata || !this.product.channeldata.categories) {
        return ''
      }
      for (let attr in this.product.channeldata.categories) {
        if (Object.prototype.hasOwnProperty.call(this.product.channeldata.categories, attr)) {
          switch (attr) {
            case 'activity':
              categories.push(this._('Activity'))
              break
            case 'iceswimming':
              categories.push(this._('Ice swimming'))
              break
            case 'carting':
              categories.push(this._('Carting'))
              break
            case 'movies':
              categories.push(this._('Movies'))
              break
            case 'animalpark':
              categories.push(this._('Animal park'))
              break
            case 'experience':
              categories.push(this._('Experience'))
              break
            case 'geocaching':
              categories.push(this._('Geocaching'))
              break
            case 'golf':
              categories.push(this._('Golf'))
              break
            case 'crosscountryskiing':
              categories.push(this._('Cross-country skiing'))
              break
            case 'slowingdown':
              categories.push(this._('Slowing down'))
              break
            case 'amusementpark':
              categories.push(this._('Amusement park'))
              break
            case 'wellbeing':
              categories.push(this._('Well-being'))
              break
            case 'yoga':
              categories.push(this._('Yoga'))
              break
            case 'fishing':
              categories.push(this._('Fishing'))
              break
            case 'nationalpark':
              categories.push(this._('National park'))
              break
            case 'city':
              categories.push(this._('City attraction'))
              break
            case 'rockclimbing':
              categories.push(this._('Rock climbing'))
              break
            case 'churches':
              categories.push(this._('Churches'))
              break
            case 'rafting':
              categories.push(this._('White water rafting'))
              break
            case 'culture':
              categories.push(this._('Cultural attraction'))
              break
            case 'gym':
              categories.push(this._('Gym'))
              break
            case 'spa':
              categories.push(this._('Spa'))
              break
            case 'handicraft':
              categories.push(this._('Handicraft'))
              break
            case 'walking':
              categories.push(this._('Walking'))
              break
            case 'forchildren':
              categories.push(this._('For children'))
              break
            case 'downhillskiing':
              categories.push(this._('Downhill skiing'))
              break
            case 'jogging':
              categories.push(this._('Jogging'))
              break
            case 'sports':
              categories.push(this._('Sports'))
              break
            case 'castle':
              categories.push(this._('Castle'))
              break
            case 'skating':
              categories.push(this._('Skating'))
              break
            case 'snowshoeing':
              categories.push(this._('Snowshoeing'))
              break
            case 'snowboarding':
              categories.push(this._('Snowboarding'))
              break
            case 'nature':
              categories.push(this._('Natural attraction'))
              break
            case 'naturereserve':
              categories.push(this._('Nature reserve'))
              break
            case 'naturecenter':
              categories.push(this._('Nature center'))
              break
            case 'monastery':
              categories.push(this._('Monastery'))
              break
            case 'mountainbiking':
              categories.push(this._('Mountain biking'))
              break
            case 'canoeing':
              categories.push(this._('Canoeing'))
              break
            case 'hunting':
              categories.push(this._('Hunting'))
              break
            case 'motorsledging':
              categories.push(this._('Motor sledging'))
              break
            case 'museum':
              categories.push(this._('Museum'))
              break
            case 'atvride':
              categories.push(this._('ATV ride'))
              break
            case 'sightseeing':
              categories.push(this._('Sightseeing'))
              break
            case 'exhibitions':
              categories.push(this._('Exhibitions'))
              break
            case 'shopping':
              categories.push(this._('Shopping'))
              break
            case 'localdelicacy':
              categories.push(this._('Local delicacy'))
              break
            case 'sleddinghill':
              categories.push(this._('Sledding hill'))
              break
            case 'cycling':
              categories.push(this._('Cycling'))
              break
            case 'horsebackriding':
              categories.push(this._('Horseback riding'))
              break
            case 'restaurant':
              categories.push(this._('Restaurant'))
              break
            case 'camping':
              categories.push(this._('Camping'))
              break
            case 'tourskating':
              categories.push(this._('Tour skating'))
              break
            case 'cruise':
              categories.push(this._('Cruise'))
              break
            case 'rollerskating':
              categories.push(this._('Roller skating'))
              break
            case 'food':
              categories.push(this._('Food'))
              break
            case 'groupexercise':
              categories.push(this._('Group exercise'))
              break
            case 'sauna':
              categories.push(this._('Sauna'))
              break
            case 'adventure':
              categories.push(this._('Adventure'))
              break
            case 'wallclimbing':
              categories.push(this._('Wall climbing'))
              break
            case 'berryandmushroompicking':
              categories.push(this._('Berry and mushroom picking'))
              break
            case 'diving':
              categories.push(this._('Diving'))
              break
            case 'sup':
              categories.push(this._('Stand up paddling'))
              break
            case 'orienteering':
              categories.push(this._('Orienteering'))
              break
            case 'winteroutdooractivities':
              categories.push(this._('Winter outdoor activities'))
              break
            case 'dancing':
              categories.push(this._('Dancing'))
              break
            case 'events':
              categories.push(this._('Events'))
              break
            case 'tennis':
              categories.push(this._('Tennis'))
              break
            case 'swimming':
              categories.push(this._('Swimming'))
              break
            case 'hiking':
              categories.push(this._('Hiking'))
              break
            case 'hikingtrail':
              categories.push(this._('Hiking trail'))
              break
            case 'boating':
              categories.push(this._('Boating'))
              break
            case 'waterskiing':
              categories.push(this._('Water skiing'))
              break
            case 'animation':
              categories.push(this._('animation'))
              break
            case 'anime':
              categories.push(this._('anime'))
              break
            case 'documentary':
              categories.push(this._('documentary'))
              break
            case 'drama':
              categories.push(this._('drama'))
              break
            case 'dubbed':
              categories.push(this._('dubbed'))
              break
            case 'fantasy':
              categories.push(this._('fantasy'))
              break
            case 'suspense':
              categories.push(this._('suspense'))
              break
            case 'horror':
              categories.push(this._('horror'))
              break
            case 'family':
              categories.push(this._('family'))
              break
            case 'comedy':
              categories.push(this._('comedy'))
              break
            case 'domestic':
              categories.push(this._('domestic'))
              break
            case 'music':
              categories.push(this._('music'))
              break
            case 'musical':
              categories.push(this._('musical'))
              break
            case 'original':
              categories.push(this._('original'))
              break
            case 'romanticdrama':
              categories.push(this._('romantic drama'))
              break
            case 'romanticcomedy':
              categories.push(this._('romantic comedy'))
              break
            case 'scifi':
              categories.push(this._('scifi'))
              break
            case 'war':
              categories.push(this._('war'))
              break
            case 'action':
              categories.push(this._('action'))
              break
            case 'western':
              categories.push(this._('western'))
              break
          }
        }
      }
      return categories.join(', ')
    },
    channelCategories: {
      get() {
        if (!this.product || !this.product.channeldata || !this.product.channeldata.categories) {
          return []
        }
        return Object.keys(this.product.channeldata.categories)
      },
      set(newValue) {
        // Convert an array of objects into a single object with the values as keys of value true
        this.product.channeldata.categories = newValue.reduce((obj, item) => { 
          return { ...obj, [item]: true }
        }, {})
      }
    },
    vouchers () {
      return this.allVouchers.filter(v => parseInt(v.unit) === 1)
    },
    voucherValidity: {
      get () {
        if (!this.product) {
          return ''
        }
        if (this.customValidity) {
          return this.customValidity
        }
        if (!this.product.voucher_start && !this.product.voucher_end) {
          return 'unlimited'
        }
        if (!this.product.voucher_start && this.product.voucher_end) {
          return 'duration'
        }
        return 'range'
      },
      set (newValue) {
        this.customValidity = newValue
        this.product.voucher_start = null
        if (newValue === 'duration') {
          this.product.voucher_end = '+1 days'
        } else {
          this.product.voucher_end = null
        }
      }
    },
    voucherDurationStart: {
      get () {
        if (!this.product || !this.product.voucher_end) {
          return '+1'
        }
        const parts = this.product.voucher_end.split(' ')
        if (!parts[0] || !parts[0].match || !parts[0].match(/^\+/)) {
          return '+1'
        }
        return parts[0]
      },
      set (newValue) {
        this.product.voucher_start = ''
        this.product.voucher_end = newValue + ' ' + this.voucherDurationEnd
      }
    },
    voucherDurationEnd: {
      get () {
        if (!this.product || !this.product.voucher_end) {
          return 'days'
        }
        const parts = this.product.voucher_end.split(' ')
        if (!parts[1] || !parts[1].match || !parts[1].match(/^[a-z]+$/)) {
          return 'days'
        }
        return parts[1]
      },
      set (newValue) {
        this.product.voucher_start = ''
        this.product.voucher_end = this.voucherDurationStart + ' ' + newValue
      }
    },
    voucherStart: {
      get () {
        if (!this.product || !this.product.voucher_start) {
          return null
        }
        return DateTime.fromFormat(this.product.voucher_start, 'd.M.yyyy').toJSDate()
      },
      set (newValue) {
        this.product.voucher_start = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat('d.M.yyyy')
      }
    },
    voucherEnd: {
      get () {
        if (!this.product || !this.product.voucher_end) {
          return null
        }
        return DateTime.fromFormat(this.product.voucher_end, 'd.M.yyyy').toJSDate()
      },
      set (newValue) {
        this.product.voucher_end = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat('d.M.yyyy')
      }
    },
    accessStartDate: {
      get () {
        if (!this.accessRules.fixed_startdate) {
          return null
        }
        return DateTime.fromISO(this.accessRules.fixed_startdate).toJSDate()
      },
      set (newValue) {
        this.accessRules.fixed_startdate = newValue ? DateTime.fromJSDate(newValue).toISODate() : null
      }
    },
    accessEndDate: {
      get () {
        if (!this.accessRules.fixed_enddate) {
          return null
        }
        return DateTime.fromISO(this.accessRules.fixed_enddate).toJSDate()
      },
      set (newValue) {
        this.accessRules.fixed_enddate = newValue ? DateTime.fromJSDate(newValue).toISODate() : null
      }
    },
    seoDatePublished: {
      get () {
        return this.sqlDatetimeToDate(this.product && this.product.datepublished)
      },
      set (newValue) {
        if (!this.product) {
          return
        }
        this.product.datepublished = this.dateToSqlDatetime(newValue)
      }
    },
    seoDateModified: {
      get () {
        return this.sqlDatetimeToDate(this.product && this.product.datemodified)
      },
      set (newValue) {
        if (!this.product) {
          return
        }
        this.product.datemodified = this.dateToSqlDatetime(newValue)
      }
    },
    seoDateDisplay: {
      get () {
        const value = this.product && this.product.datedisplay
        if (value === 'published' || value === 'modified' || value === 'both') {
          return value
        }
        return ''
      },
      set (newValue) {
        if (!this.product) {
          return
        }
        this.product.datedisplay = newValue || ''
      }
    },
    deadlineOffsetDays: {
      get () {
        if (!this.product || !this.product.deadlineoffset) {
          return ''
        }
        return Math.floor(this.product.deadlineoffset / 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.product.deadlineoffset = Math.abs(v) * 24 + this.deadlineOffsetHours / 1 + this.deadlineOffsetMinutes / 60 // Note the / 1 is required so that the hours is cast as number
      }
    },
    deadlineOffsetHours: {
      get () {
        if (!this.product || !this.product.deadlineoffset) {
          return ''
        }
        return Math.floor(this.product.deadlineoffset - this.deadlineOffsetDays * 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.product.deadlineoffset = this.deadlineOffsetDays * 24 + Math.abs(v) + this.deadlineOffsetMinutes / 60
      }
    },
    deadlineOffsetMinutes: {
      get () {
        if (!this.product || !this.product.deadlineoffset) {
          return ''
        }
        return Math.round((this.product.deadlineoffset - this.deadlineOffsetDays * 24 - this.deadlineOffsetHours) * 60)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.product.deadlineoffset = this.deadlineOffsetDays * 24 + this.deadlineOffsetHours + Math.abs(v) / 60
      }
    },
    preselectedDates: {
      get () {
        if (!this.product || !this.product.preselecteddates || !this.product.preselecteddates.split) {
          return []
        }
        return this.product.preselecteddates.split(';').sort((a, b) => {
          const da = DateTime.fromFormat(a, 'd.M.yyyy')
          const db = DateTime.fromFormat(b, 'd.M.yyyy')
          if (da.toMillis() < db.toMillis()) {
            return -1
          }
          return 1
        })
      },
      set (newValue) {
        if (newValue && newValue.join) {
          this.product.preselecteddates = newValue.join(';')
        } else {
          this.product.preselecteddates = ''
        }
      }
    },
    preselectedDateStr: {
      get () {
        if (this.preselectedDate) {
          return DateTime.fromJSDate(this.preselectedDate, { zone: this.timezone }).toFormat('d.M.yyyy')
        }
        return null
      },
      set (newValue) {
        const validFormats = ['d.M.yyyy', 'dd.MM.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']
        if (newValue && validFormats.some(format => DateTime.fromFormat(newValue, format).isValid)) {
          this.preselectedDate = DateTime.fromFormat(newValue, 'd.M.yyyy').toJSDate()
        }
      }
    },
    isAvailabilityConfigurationVisible () {
      return parseInt(this.product.type) === this.TYPE_RESERVABLE && !this.resourceOrPoolCountExcludingOpeningHours && !this.linkExistingResources
    },
    confirmText () {
      switch (this.availabilityType) {
        case 'single':
          return this._('Confirm and create resource')
        case 'multi':
          return this._('Confirm and create resource pool')
        case 'existing':
        default:
          return this._('Confirm')
      }
    },
    productVat: {
      get () {
        if (!this.product.vat && this.product.vat !== 0) {
          return this.vats && this.vats.length ? this.vats[0] : '0'
        }
        return this.product.vat
      },
      set (newValue) {
        this.product.vat = newValue
      }
    },
    ratnaApartments: {
      get () {
        return this.settings && this.settings.ratna_apartments ? JSON.parse(this.settings.ratna_apartments) : []
      },
      set () {}
    },
    enabledDeliveryMethods () {
      if (!this.shopDeliveryMethods || !this.shopDeliveryMethods[this.shopId] || !this.shopDeliveryMethods[this.shopId].length) {
        return []
      }
      return this.shopDeliveryMethods[this.shopId].filter(d => !!parseInt(d.settings_id))
    },
    externalDeliveryMethods () {
      return this.product && this.product.sharedDeliverymethod ? this.product.sharedDeliverymethod.filter(d => !parseInt(d.internal)) : []
    },
    internalDeliveryMethods () {
      return this.product && this.product.sharedDeliverymethod ? this.product.sharedDeliverymethod.filter(d => parseInt(d.internal)) : []
    },
    productStarttimes () {
      const times = this.isCalendarPricing
        ? this.starttimesForCalendar(this.product.ownStarttime)
        : (this.product.ownStarttime || [])
      return times.slice().sort((a, b) => {
        return a.timestart - b.timestart
      })
    },
    hasAccommodationFields () {
      return this.product && 
             parseInt(this.product.type) === this.TYPE_RESERVABLE && 
              (parseInt(this.product.subtype) === this.SUBTYPE_CABIN ||
              parseInt(this.product.subtype) === this.SUBTYPE_HOTELLINX ||
              ['hotelroom', 'cottage', 'villa', 'otheraccommodation'].includes(this.product.displayedtype))
    }
  },
  methods: {
    sqlDatetimeToDate (value) {
      if (!value) {
        return null
      }
      const raw = String(value).trim()
      let dt = DateTime.fromSQL(raw, { zone: this.timezone })
      if (!dt.isValid) {
        dt = DateTime.fromISO(raw, { setZone: true })
      }
      return dt.isValid ? dt.toJSDate() : null
    },
    dateToSqlDatetime (value) {
      if (!value) {
        return ''
      }
      const date = value instanceof Date ? value : new Date(value)
      if (Number.isNaN(date.getTime())) {
        return ''
      }
      const dt = DateTime.fromJSDate(date).setZone(this.timezone)
      return dt.isValid ? dt.toFormat('yyyy-MM-dd HH:mm:ss') : ''
    },
    isEmbeddedExtraImage(image) {
      return this.embeddedDescriptionFileIds.has(String(image.id))
    },
    addPastedExtraImage(file) {
      if (!file || file.id == null) {
        return
      }
      if (!Array.isArray(this.product.sharedFile)) {
        this.product.sharedFile = []
      }
      if (this.product.sharedFile.findIndex(i => String(i.id) === String(file.id)) === -1) {
        this.product.sharedFile.push({ id: file.id })
      }
    },
    setExclusiveChannelAttribute (value, opposite, checked) {
      const next = this.channelAttributes.filter(v => v !== value && v !== opposite)
      if (checked) {
        next.push(value)
      }
      this.channelAttributes = next
    },
    isPanelOpen(panel, index) {
      return this.overrideIsPanelOpen(panel, index)
    },
    overrideIsPanelOpen(panel, index) {
      if (this.panelOpen[panel] === undefined) {
        switch(panel) {
          case 'two':
          case 'channelOne':
          case 'channelTwo':
          case 'otherChannelOne':
          case 'otherChannelTwo':
          case 'otherChannelThree':
            return true
          case 'six':
            return this.isSellable
          case 'seven':
            return !this.isContent
          case 'availabilitySummary':
            return this.resourceCount > 1 || this.isSellable
        }
        if (panel.startsWith('availability') && panel.endsWith('pool')) {
          return this.product.sharedResource && this.product.sharedResource.length < 2 && !index
        }
        if (panel.startsWith('availability')) {
          return this.resourceCount < 2
        }
      }
      return this.panelOpen[panel]
    },
    async generateMobilePayQrCode() {
      // Use current locale automatically
      const locale = this.version || 'default'
      
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, {
          method: 'GenerateProductQrCode',
          productId: this.product.id,
          locale: locale
        })
      } catch (e) {
        this.showError(e)
        return
      }
      
      // Update the mobilepayqr property with the new structure
      if (response.data && response.data.url) {
        const currentQrCodes = this.mobilePayQrCodes
        currentQrCodes[locale] = response.data.url
        this.product.mobilepayqr = JSON.stringify(currentQrCodes)
      }
    },
    async deactivateMobilePayQrCode() {
      // Always use current locale for deletion
      let locale = this.version
      
      if (!this.mobilePayQrCodes[locale] && this.mobilePayQrCodes['default']) {
        locale = 'default' // If qr code is not found, use default
      }

      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, {
          method: 'DeactivateProductQrCode',
          productId: this.product.id,
          locale: locale
        })
      } catch (e) {
        this.showError(e)
        return
      }
      
      // Update the mobilepayqr property - remove current locale's QR code
      const currentQrCodes = this.mobilePayQrCodes
      delete currentQrCodes[locale]
      if (Object.keys(currentQrCodes).length === 0) {
        this.product.mobilepayqr = null
      } else {
        this.product.mobilepayqr = JSON.stringify(currentQrCodes)
      }
    },
    applyPackagedProductsOrder (groupedOptions) {
      const packageOrder = []
      for (let i = 0; i < groupedOptions.length; i++) {
        const item = groupedOptions[i]
        if (item.type === 'linkedproduct') {
          packageOrder.push(item.product)
        } else if (item.type === 'group') {
          packageOrder.push(...item.products)
        }
      }
      this.linkedProducts = [...packageOrder, ...this.productOptions, ...this.separatelyLinkedProducts]
    },
    updatePackageOptionsOrder (newData) {
      this.applyPackagedProductsOrder(newData)
    },
    updateGroupOrder (index, newData) {
      const newOrder = []
      for (let i = 0; i < this.groupedPackageOptions.length; i++) {
        if (i === index) {
          newOrder.push({
            type: 'group',
            products: newData
          })
        } else {
          newOrder.push(this.groupedPackageOptions[i])
        }
      }
      this.applyPackagedProductsOrder(newOrder)
    },
    resetPricetiers () {
      this.product.sharedPricetier = []
      this.product.enable_participant_pricing = 0
      this.selectedPricetiers = []
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.version] || {} // Note: here we have to use version
    },
    async scheduleFullSync () {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/products/' + this.product.id + '.json?apikey=' + this.apiKey, { id: this.product.id, availabilitysync: true })
      } catch(e) {
        this.showError(e)
        return
      }
      this.loadSyncStatus()
    },
    clearMovieReference() {
      this.product.channeldata.maccsboxref = ''
      this.initialMaccsChecksum = ''
    },
    tabOpened (el) {
      if (el.id === 'otherchannels') {
        if (this.product.channex_roomtype) {
          this.loadChannexToken()
        }
      }
    },
    tabClosed (el) {
      if (el.id === 'otherchannels') {
        if (this.product.channex_roomtype) {
          this.clearChannexToken()
        }
      }
    },
    async enableChannex() {
      const settings = {
        id: 1,
        channel_channex: 1
      }
      try {
        await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, settings)
      } catch(e) {
        this.showError(e)
        return
      }
      await this.loadProduct(this.product.id)
      this.linkChannexPropertyDialog()
    },
    activityCategoriesSelected(items, lastItem) {
      this.channelActivityCategories = items
    },
    qrUrl (version) {
      if (!this.product || !this.product.id) {
        return ''
      }
      if (!version) {
        version = this.version
      }
      return 'https://qrcode.johku.com/?code=' + this.baseDomain + this.shopId + '/qr/P' + this.product.id + '?version=' + version
    },
    openSalesChannelSettings (property) {
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'SalesChannelSettings',
        title: this._('Sales Channels'),
        initData: {
          activateTab: 'othersaleschannels',
          activateProperty: property
        }
      })
    },
    openCompanyProfile () {
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'CompanyProfile',
        title: this._('Company profile'),
        initData: {
          activateTab: 'billing'
        }
      })
    },
    openCollectionSettings () {
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'CollectionSettings',
        title: this._('Collections'),
        initData: {
          activateTab: 'collections'
        }
      })
    },
    isPricetierSelected (pt) {
      return !!this.product.sharedPricetier.find(spt => spt.id === pt.id)
    },
    subtract (pt) {
      const pricetier = this.product.sharedPricetier.find(spt => spt.id === pt.id)
      if (pricetier) {
        if (parseInt(pricetier.default_count) > 1) {
          pricetier.default_count--
        } else { // 0 and no preselection work the same in the storefront
          pricetier.default_count = null
        }
      }
    },
    add (pt) {
      const pricetier = this.product.sharedPricetier.find(spt => spt.id === pt.id)
      if (pricetier) {
        if (!pricetier.default_count) {
          pricetier.default_count = 1
        } else {
          pricetier.default_count++
        }
      }
    },
    arePricetierRulesApplied (pt) {
      const pricetier = this.product.sharedPricetier.find(spt => spt.id === pt.id)
      return !pricetier || !parseInt(pricetier.rules_disabled)
    },
    setPricetierRulesApplied (pt, applied) {
      const pricetier = this.product.sharedPricetier.find(spt => spt.id === pt.id)
      if (pricetier) {
        pricetier.rules_disabled = applied ? 0 : 1
      }
    },
    isSalesChannelTagChecked(tagStr) {
      return this.product && this.product.sharedTag && this.product.sharedTag.find(t => t.title === 'product:::' + tagStr)
    },
    productTagChanged (tagStr, value) {
      const [version, tag] = tagStr.split(':::')
      if (value) {
        this.addProductTag(tag, version)
      } else {
        this.removeTag({ title: 'product:::' + tagStr })
      }
    },
    isPriorityCountry (id) {
      return ['SE', 'NO', 'DK', 'EE', 'RU'].indexOf(id) !== -1
    },
    toggleDefaultPricerow (pricerow) {
      if (parseInt(pricerow.isdefault)) {
        pricerow.isdefault = 0
      } else {
        for (let i = 0; i < this.product.ownPricerow.length; i++) {
          this.product.ownPricerow[i].isdefault = 0
        }
        pricerow.isdefault = 1
      }
    },
    pricesTabClicked() {
      if (this.isEvent) {
        this.EventBus.$emit('calendarUpdate')
      }
    },
    manageTermsDialog () {
      this.showModal('termslist', TermsList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    manageFormsDialog () {
      this.showModal('formslist', FormsList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    manageDeliverymethodsDialog () {
      this.showModal('deliverysettings', DeliverySettings, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true,
              activeTab: 'deliverymethods'
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    manageRoutesDialog () {
      this.showModal('transportationroutelist', TransportationRouteList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    managePricingDialog () {
      this.showModal('pricinglist', PricingList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {
          'closed': () => {
            this.loadLinkedPricings()
          }
        },
        width: 1000
      })
      /*
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'PricingList',
        initData: {
        }
      })
      */
    },
    manageVouchersDialog () {
      this.showModal('voucherslist', VouchersList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    managePaymentplansDialog () {
      this.showModal('paymentplanslist', PaymentPlansList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true,
              planType: this.isReservable ? 'advance' : 'recurring'
            }
          }
        },
        events: {},
        handlers: {
          closed: () => {
            this.loadPaymentPlans()
          }
        },
        width: 1000
      })
    },
    loadDeliverymethod (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/deliverymethods/' + id + '.json?details=true&shipit=true&apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          reject()
          return
        }

        let methodId = this.product.sharedDeliverymethod.findIndex(m => m.id === response.data.id)
        if (methodId && this.product.sharedDeliverymethod[methodId]) {
          Object.keys(this.product.sharedDeliverymethod[methodId]).forEach(key => {
            if (this.product.sharedDeliverymethod[methodId][key]) {
              this.product.sharedDeliverymethod[methodId][key] = response.data[key]
            }
          })
        }
        resolve(response.data)
      })
    },
    async reloadOnVersionChange () {
      if (!this.product || !this.product.id) {
        return
      }
      await this.loadProduct(this.product.id)
    },
    loadProduct (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        this.pricings = []
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + id + '.json?basketitemcount=true&actualunits=true&cmsdata=true&commissions=true&dimensions=true&deliverymethods=true&channels=true&apikey=' + this.apiKey + this.versionStr, {
            signal: this.controller.signal
          })
        } catch (e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
            this.loadingFailed = true
          }
          this.loading = false
          reject(e)
          return
        }
        this.loadingFailed = false
        if (!response.data.channeldata) {
          response.data.channeldata = {
            description: ''
          }
        }
        this.product = response.data
        for (const list of ['ownOptiongroup', 'ownRateplan', 'pickupplaces']) { // Activity pricing lists may come in as id-keyed objects
          if (this.product[list] && !Array.isArray(this.product[list]) && typeof this.product[list] === 'object') {
            this.product[list] = Object.values(this.product[list])
          }
        }
        if (!this.product.pricing_engine) {
          this.product.pricing_engine = 'pricerow'
        }
        this.savedPricingEngine = ['calendar', 'activitycalendar'].includes(this.product.pricing_engine) ? this.product.pricing_engine : 'pricerow'
        this.activityDurations = this.product.pricing_engine === 'activitycalendar' ? this.parseActivityDurations(this.product) : []
        if (!this.product.sharedCollection) {
          this.product.sharedCollection = []
        }
        if (parseInt(this.product.type) === this.TYPE_SELLABLE) {
          for (let i = 0; i < this.product.sharedResource.length; i++) {
            const resource = this.product.sharedResource[i]
            this.origResourceCapacity[resource.id] = this.resourceCapacity[resource.id] = this.getCapacity(resource)
          }
          for (let i = 0; i < this.product.ownProduct_resource.length; i++) {
            const link = this.product.ownProduct_resource[i]
            this.resourceUnits[link.resource_id] = parseInt(link.units, 10)
          }
          for (let i = 0; i < this.product.ownProduct_resourcepool.length; i++) {
            const link = this.product.ownProduct_resourcepool[i]
            this.resourcePoolUnits[link.resourcepool_id] = parseInt(link.units, 10)
          }
          if (!this.product.price) {
            this.product.price = 0
          }
        }
        if (!this.product.vat) {
          this.product.vat = (this.vats && this.vats.length ? this.vats[0] : '0')
        }
        if (this.product.deadlineoffset < 0) {
          this.deadlineOffsetOption = 'after'
          this.product.deadlineoffset = Math.abs(this.product.deadlineoffset)
        } else {
          this.deadlineOffsetOption = 'prior'
        }
        // We should reset some objects and arrays that are conditionally loaded
        this.allStops = {}
        this.distributors = []
        this.ranges = []
        this.allVouchers = []
        this.localProducts = {}
        this.externalProducts = []
        this.scheduledTasks = []
        this.channexProperty = false
        this.channexRoomType = false
        this.channexToken = false
        this.channexProperties = []
        this.initialMaccsChecksum = ''
        // Parse access rules and prepare group IDs for lookup after accessOptions loads
        let accessGroupIds = []
        if (this.product.access_rules) {
          try {
            const parsed = JSON.parse(this.product.access_rules)
            this.accessRules = {
              groups: [],
              duration_type: parsed.duration_type || 'permanent',
              fixed_startdate: parsed.fixed_startdate || null,
              fixed_enddate: parsed.fixed_enddate || null,
              offset_value: parsed.offset_value || 1,
              offset_unit: parsed.offset_unit || 'month'
            }
            accessGroupIds = parsed.groups || []
          } catch (e) {
            this.accessRules = this.defaultAccessRules()
          }
        } else {
          this.accessRules = this.defaultAccessRules()
        }
        const loaders = []
        loaders.push(this.loadAccessOptions(accessGroupIds))
        if (this.isTransportation) {
          loaders.push(this.loadStops())
        }
        if (this.isMovie || this.isOpera || this.isBallet || this.isConcert) {
          loaders.push(this.loadDistributors())
        }
        if (this.resourceCount > 1 && !this.isSellable) {
          loaders.push(this.loadRangeSummaries())
        }
        if (this.isValuecard || this.isExchangedValuecard) {
          loaders.push(this.loadVouchers())
        }
        if (this.isReservable) {
          loaders.push(this.loadLocalProducts())
        }
        loaders.push(this.loadPricingOptions())
        loaders.push(this.loadTermsOptions())
        loaders.push(this.loadFormOptions())
        loaders.push(this.loadAllCommissions())
        loaders.push(this.loadNotifications('product', this.product.id))
        loaders.push(this.loadLinkedProducts())
        loaders.push(this.loadLinkedCategories())
        loaders.push(this.loadTags())
        loaders.push(this.loadPaymentPlans())
        if (parseInt(this.product.subtype, 10) === this.SUBTYPE_TICKET) {
          loaders.push(this.loadLinkedPricings())
        }
        if (parseInt(this.product.subtype, 10) === this.SUBTYPE_HOTELLINX) {
          loaders.push(this.loadExternalProducts())
        } 
        if (this.product.channex_property) {
          loaders.push(this.loadChannexProperty())
          if (this.product.channex_roomtype) {
            loaders.push(this.loadChannexRoomType())
            loaders.push(this.loadChannexToken())
            if (this.settings && parseInt(this.settings.channex_messaging) && this.isFeatureEnabled('channexmessaging')) {
              loaders.push(this.loadChannexApplications(this.product.channex_property))
            }
          }
        }
        loaders.push(this.loadSyncStatus())
        if (this.product.scheduledtasks) {
          loaders.push(this.loadScheduledTasks())
        }
        await Promise.allSettled(loaders)
        if (this.product.displayedtype === 'movie') {
          this.initialMaccsChecksum = this.getMaccsChecksum()
        } 
        this.storeState()
        this.resourcesTainted = false
        this.loading = false
        this.applyPendingUploads()
        resolve(this.product)
      })
    },
    loadLocalProducts () {
      return new Promise(async (resolve, reject) => {
        let response
        for (let i = 0; i < this.product.sharedResource.length; i++) {
          let resource = this.product.sharedResource[i]
          let response
          try {
            response = await axios.get(this.baseDomain + this.shopId + '/resources/' + resource.id + '/products.json?apikey=' + this.apiKey, {
              signal: this.controller.signal
            })
          } catch(e) {
            continue
          }
          this.localProducts[resource.id] = response.data
        }
        resolve(this.localProducts)
      })
    },
    loadVouchers () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/vouchers.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.allVouchers = response.data
        resolve(response.data)
      })
    },
    loadLinkedProducts () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + this.product.id + '/linkedproducts.json?apikey=' + this.apiKey + this.versionStr, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.linkedProducts = response.data
        resolve(response.data)
      })
    },
    loadLinkedCategories () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + this.product.id + '/linkedcategories.json?apikey=' + this.apiKey + this.versionStr, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.linkedCategories = response.data
        resolve(response.data)
      })
    },
    loadTags () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/tags.json?type=producteditor&apikey=' + this.apiKey + this.versionStr, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.allTags = response.data
        resolve(response.data)
      })
    },
    loadPaymentPlans () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/paymentplans.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.paymentplans = response.data
        resolve(response.data)
      })
    },
    loadDistributors() {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/moviedistributors.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          return
        }
        this.distributors = response.data
        resolve(response.data)
      })
    },
    loadStops () {
      return new Promise((resolve, reject) => {
        if (!this.product || !this.product.sharedResource) {
          return
        }
        let requests = []
        for (let i = 0; i < this.allRoutes.length; i++) {
          let routeId = this.allRoutes[i].id
          requests.push(axios.get(this.baseDomain + this.shopId + '/routes/' + routeId + '/stops.json'))
        }
        axios.all(requests)
        .then(axios.spread((...res) => {
          for (let i = 0; i < res.length; i++) {
            let s = res[i].data
            if (s) {
              this.allStops[this.allRoutes[i].id] = s
            }
          }
          resolve()
        }))
      })
    },
    loadRangeSummaries () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + this.product.id + '/ranges.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.ranges = response.data
        resolve(response.data)
      })
    },
    defaultAccessRules () {
      return {
        groups: [],
        duration_type: 'permanent',
        fixed_startdate: null,
        fixed_enddate: null,
        offset_value: 1,
        offset_unit: 'month'
      }
    },
    async loadAccessOptions (groupIds = []) {
      if (!this.accessOptions.length) {
        try {
          const response = await axios.get(this.baseDomain + this.shopId + '/usergroups.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
          this.accessOptions = (response.data || []).filter(g => !parseInt(g.allusers))
        } catch (e) {
          return
        }
      }
      if (groupIds.length) {
        this.accessRules.groups = this.accessOptions.filter(g => groupIds.map(Number).includes(Number(g.id)))
      }
    },
    loadPricingOptions () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/pricing.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.pricingOptions = response.data
        resolve(response.data)
      })
    },
    loadTermsOptions () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/terms.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.termsOptions = response.data
        resolve(response.data)
      })
    },
    loadFormOptions () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/forms.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.formOptions = response.data
        resolve(response.data)
      })
    },
    loadAllCommissions () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/commissions.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.allCommissions = response.data
        resolve(response.data)
      })
    },
    loadLinkedPricings () {
      if (parseInt(this.product.subtype, 10) !== this.SUBTYPE_TICKET) {
        return
      }
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + this.product.id + '.json?pricings=true&apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.pricings = response.data
        this.pricings.sort((a, b) => a.name.localeCompare(b.name, this.shortLocale))
        resolve(response.data)
      })
    },
    loadExternalProducts () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/externalproducts.json?apikey=' + this.apiKey, {
            signal: this.controller.signal
          })
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.externalProducts = response.data
        resolve(response.data)
      })
    },
    loadChannexProperty () {
      return new Promise(async (resolve, reject) => {
        let response
        let id = this.product.channex_property
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/channexproperties/' + id + '.json?apikey=' + this.apiKey)
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            if (e && e.response && e.response.status === 404) {
              // Property has been deleted, fail silently
            } else {
              this.showError(e)
            }
          }
          reject(e)
          return
        }
        this.channexProperty = response.data
        resolve(response.data)
      })
    },
    loadChannexRoomType () {
      return new Promise(async (resolve, reject) => {
        let response
        let id = this.product.channex_roomtype
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/channexroomtypes/' + id + '.json?apikey=' + this.apiKey)
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            if (e && e.response && e.response.status === 404) {
              // Room type has been deleted, fail silently
            } else {
              this.showError(e)
            }
          }
          reject(e)
          return
        }
        this.channexRoomType = response.data
        resolve(response.data)
      })
    },
    loadChannexToken () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.post(this.baseDomain + this.shopId + '/channextokens.json?apikey=' + this.apiKey + '&property_id=' + this.product.channex_property)
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            if (e && e.response && e.response.status === 404) {
              // Channex token has been deleted, fail silently
            } else {
              this.showError(e)
            }
          }
          reject(e)
          return
        }
        this.channexToken = response.data
        resolve(response.data)
      })
    },
    loadSyncStatus () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + this.product.id + '.json?syncstatus=true&apikey=' + this.apiKey)
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            this.showError(e)
          }
          reject(e)
          return
        }
        this.syncStatus = response.data
        resolve(response.data)
      })
    },
    loadScheduledTasks () {
      return new Promise(async (resolve, reject) => {
        let response
        const taskIds = this.product.scheduledtasks.split(',')
        this.scheduledTasks = []
        for (let i = 0; i < taskIds.length; i++) {
          try {
            response = await axios.get(this.baseDomain + this.shopId + '/scheduledtasks/' + taskIds[i] + '.json?apikey=' + this.apiKey)
            this.scheduledTasks.push(this.parseScheduledTask(response.data))
          } catch(e) {
          }
        }
        resolve(this.scheduledTasks)
      })
    },
    parseScheduledTask(data) {
      if (data.data) {
        data.data = JSON.parse(data.data)
      }
      return data
    },
    clearChannexToken () {
      this.channexToken = false
    },
    makeDayRangeStr(dayNumbers) {
      const _ = this._
      const allDays = [_('mo'), _('tu'), _('we'), _('th'), _('fr'), _('sa'), _('su')]
      let rangeStr = this.getRangeStr(allDays, dayNumbers)
      return new String(rangeStr).toLowerCase()
    },
    getRangeStr(allElements, selectedNumbers) {
      let rangeStr = ''
      for (let i in selectedNumbers) {
        const n = parseInt(i, 10) - 1
        let already = false
        if (!selectedNumbers[n]) {
          rangeStr += allElements[n]
          already = true
        }
        if (!selectedNumbers[parseInt(i, 10) + 1]) {
          if (already) {
            rangeStr += ', '
          } else {
            rangeStr += '-' + allElements[n] + ', '
          }
        }
      }
      if (rangeStr.length) {
        rangeStr = rangeStr.substring(0, rangeStr.length - 2)
      }
      return rangeStr
    },
    getRouteName(id) {
      let name = false
      if (!this.product || !this.product.sharedResource) {
        return name
      }
      for (let i = 0; i < this.product.sharedResource.length; i++) {
        if (!this.product.sharedResource[i].sharedRoute) {
          continue
        }
        for (let j = 0; j < this.product.sharedResource[i].sharedRoute.length; j++) {
          let r = this.product.sharedResource[i].sharedRoute[j]
          if (parseInt(r.id, 10) === parseInt(id, 10)) {
            return r.name + ' (' + r.type + ')'
          }
        }
      }
      return name
    },
    getZoneName(id) {
      for (let routeId in this.allStops) {
        if (Object.prototype.hasOwnProperty.call(this.allStops, routeId)) {
          for (let i = 0; i < this.allStops[routeId].length; i++) {
            let stop = this.allStops[routeId][i]
            for (let j = 0; j < stop.sharedZone.length; j++) {
              let zone = stop.sharedZone[j]
              if (parseInt(zone.id, 10) === parseInt(id, 10)) {
                return zone.name
              }
            }
          }
        }
      }
      return false
    },
    makePricerowDesc (pricerow) {
      let desc = '';
      let _ = this._
      if (pricerow.dateend || pricerow.datestart) {
        desc += DateTime.fromFormat(pricerow.datestart, 'd.M.yyyy').toFormat(this.dateFormat) + ' - ' + DateTime.fromFormat(pricerow.dateend, 'd.M.yyyy').toFormat(this.dateFormat) + '; '
      } else {
        desc += _('all year') + '; '
      }
      if (pricerow.timestart || pricerow.timeend) {
        desc += DateTime.fromFormat((pricerow.timestart ? pricerow.timestart : '0.00'), 'H.mm').toFormat(this.timeFormat) + ' - ' + DateTime.fromFormat(pricerow.timeend, 'H.mm').toFormat(this.timeFormat) + '; '
      }
      let weekdays = pricerow.weekdays.split(',')
      if (weekdays.length == 7) {
        desc += _('every day') + ' '
      } else {
        let dayNumbers = []
        for (let i = 0; i < weekdays.length; i++) {
          dayNumbers[weekdays[i]] = true
        }
        desc += this.makeDayRangeStr(dayNumbers) + ' '
      }
      desc = desc.trim()
      let startweekdays = pricerow.startweekdays.split(',')
      if (startweekdays.length < 7) {
        desc += '; ' + _('starting on') + ' '
        let startDayNumbers = []
        for (let i = 0; i < startweekdays.length; i++) {
          startDayNumbers[startweekdays[i]] = true
        }
        desc += this.makeDayRangeStr(startDayNumbers) + ' '
      }
      desc = desc.trim()
      let endweekdays = pricerow.endweekdays.split(',')
      if(endweekdays.length < 7) {
        desc += '; ' + _('ending on') + ' '
        let endDayNumbers = []
        for (let i = 0; i < endweekdays.length; i++) {
          endDayNumbers[endweekdays[i]] = true
        }
        desc += this.makeDayRangeStr(endDayNumbers) + ' '
      }
      if(pricerow.route) {
        let route = this.getRouteName(pricerow.route)
        desc += route ? '; ' + route : ''
      }
      if(pricerow.origin) {
        let origin = this.getZoneName(pricerow.origin)
        desc += origin ? '; ' + origin : ''
      }
      if(pricerow.destination) {
        let dest = this.getZoneName(pricerow.destination)
        desc += dest ? (pricerow.origin ? ' -' : ';') + ' ' + dest : ''
      }
      return desc
    },
    makePricerowPriceDesc(pricerow) {
      let desc = ''
      let unitTypeStr = ''
      switch(parseInt(pricerow.unittype)) {
        case 1:
          unitTypeStr = this._('min')
          break
        case 2:
          unitTypeStr = this._('h')
          break
        case 3:
          unitTypeStr = this._('d')
          break
      }
      const curr = this.$filters.currency
      desc += curr(pricerow.price)
      if (!this.isTransportation) {
        if (pricerow.pricetiers) {
          let ptArr = pricerow.pricetiers.split(';')
          // let firstPrice = ptArr[0].split(':')[1]
          // Improved this that instead of taking the first price tier found in ptArr, we check the actual order of price tiers
          // Seems like a lot of code though
          let ptIdArr = ptArr.map(pt => pt.split(':')[0])
          let firstTier = this.allPricetiers.find(tier => ptIdArr.includes(tier.id))
          let firstPrice = null
          if (firstTier) {
            const matchingTier = ptArr.find(pt => pt.split(':')[0] === firstTier.id)
            if (matchingTier) {
              firstPrice = matchingTier.split(':')[1]
            }
          }
          if (firstPrice) {
            desc += ' + <i class="fa fa-fw fa-male text-muted"></i>' + curr(firstPrice)
          }
        }
        desc += ' / ' + (pricerow.unit > 1 ? pricerow.unit  + ' ' : '') + unitTypeStr
      } else {
        if (parseFloat(pricerow.returnprice)) {
          desc += ' / ' + curr(pricerow.returnprice)
        }
      }
      return desc
    },
    setSuggestedPrice () {
      const voucher = this.selectedVoucher
      if (voucher) {
        this.product.price = parseFloat(voucher.value) * parseInt(this.product.vouchers)
      }
    },
    setSuggestedVat () {
      this.productVat = 0
    },
    async confirmResourceAvailability () {
      if (this.confirmingAvailability) {
        return
      }
      this.confirmingAvailability = true
      if (this.availabilityType === 'existing') {
        this.linkExistingResources = true
      } else if (this.availabilityType === 'multi') {
        await this.confirmMultiResourceAvailability()
      } else {
        await this.confirmSingleResourceAvailability()
      }
      this.confirmingAvailability = false
    },
    async confirmMultiResourceAvailability() {
      return new Promise(async (resolve, reject) => {
        let newIds = []
        for (let i = 0; i < this.createResourceCount; i++) {
          let data = {
            name: this.product.name + ': ' + this.getResourceText() + ' ' + (i + 1),
            displayedtype: this.getResourceType(),
            quantity: 1,
            count: this.createSeatCount,
            mincount: 1,
            range_mode_new: 'allow',
            range_datestart_new: false,
            range_dateend_new: false,
            range_weekdays_new: '1,2,3,4,5,6,7',
            range_timestart_new: 0,
            range_timeend_new: 1440,
            range_allowedstarttimes_new: ''
          }
          let response
          try {
            response = await axios.post(this.baseDomain + this.shopId + '/resources.json?apikey=' + this.apiKey, data)
          } catch(e) {
            // Do nothing? Or reject?
            continue
          }
          newIds.push(response.data)
        }
        newIds.sort((a, b) => a > b ? 1 : -1)
        let data = {
          name: this.product.name,
          resources: newIds.join(':::Resource;;;') + ':::Resource',
          allocation: 'random',
          seatallocation: 'fill'
        }
        let response
        try {
          response = await axios.post(this.baseDomain + this.shopId + '/resourcepools.json?apikey=' + this.apiKey, data)
        } catch(e) {
          resolve()
          return
        }
        const resourcePoolId = response.data
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/resourcepools/' + resourcePoolId + '.json?apikey=' + this.apiKey)
        } catch(e) {
          resolve()
          return
        }
        this.product.sharedResourcepool.push(response.data)
        resolve()
      })
    },
    confirmSingleResourceAvailability() {
      return new Promise(async (resolve, reject) => {
        const data = {
          name: this.product.name,
          displayedtype: this.getResourceType(),
          quantity: 1,
          count: this.createSeatCount,
          mincount: 1,
          range_mode_new: 'allow',
          range_datestart_new: false,
          range_dateend_new: false,
          range_weekdays_new: '1,2,3,4,5,6,7',
          range_timestart_new: 0,
          range_timeend_new: 1440,
          range_allowedstarttimes_new: ''
        }
        let response
        try {
          response = await axios.post(this.baseDomain + this.shopId + '/resources.json?apikey=' + this.apiKey, data)
        } catch(e) {
          // Do nothing? Or reject?
          resolve()
          return
        }
        const resourceId = response.data
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/resources/' + resourceId + '.json?basketitemcount=true&capacity=true&ranges=true&apikey=' + this.apiKey)
        } catch(e) {
          resolve()
          return
        }
        this.product.sharedResource.push(response.data)
        resolve()
      })
    },
    getCapacity(resource) {
      return resource.warehouse_count
    },
    getBasketItemCount(resource) {
      if (!isNaN(resource.basketitemcount)) {
        return resource.basketitemcount
      }
      return 0
      // This yielded crap results
      // return resource.count - resource.warehouse_count
    },
    getRangeClass(range) {
      let cls = 'range'
      if (range.mode === 'deny' || range.mode === 'denyswitch') {
        cls += ' bg-primary'
      }
      if (range.ext_id) {
        cls += ' external'
      }
      return cls
    },
    convertToTime(minutes) {
      let minStr = (minutes % 60)
      if (minStr < 10) {
        minStr = '0' + minStr
      }
      return Math.floor(minutes / 60) + '.' + minStr
    },
    makeRangeDesc(range) {
      const _ = this._
      let desc = '<i class="fa fa-fw fa-check-circle"></i> '
      if (range.ext_id) {
        desc += '<i class="fa fa-fw fa-google"></i> '
      }
      desc += _('Allowed') + ' '
      if (range.mode === 'deny') {
        desc = '<i class="fa fa-fw fa-ban"></i> '
        if (range.ext_id) {
          desc += '<i class="fa fa-fw fa-google"></i> '
        }
        desc += _('Prevented') + ' '
      } else if (range.mode === 'denyswitch') {
        desc = '<i class="fa fa-fw fa-ban"></i> '
        if (range.ext_id) {
          desc += '<i class="fa fa-fw fa-google"></i> '
        }
        desc += _('Starting and ending prevented') + ' '
      }
      let hasModifiers = false
      if (range.dateend || range.datestart) {
        desc += (range.datestart ? DateTime.fromFormat(range.datestart, 'd.M.yyyy').toFormat(this.dateFormat) : '') + 
        (range.datestart !== range.dateend && range.dateend ? ' - ' + DateTime.fromFormat(range.dateend, 'd.M.yyyy').toFormat(this.dateFormat) + '; ' : ' ')
        hasModifiers = true
      }
      let weekdays = range.weekdays.split(',')
      if(weekdays.length !== 7) {
        let dayNumbers = []
        for (let i = 0; i < weekdays.length; i++) {
          dayNumbers[weekdays[i]] = true
        }
        desc += this.makeDayRangeStr(dayNumbers) + ' '
        hasModifiers = true
      }
      if (parseInt(range.timestart, 10) !== 0 || parseInt(range.timeend) !== 1440) {
        desc += _('from') + ' ' + DateTime.fromFormat(this.convertToTime(range.timestart), 'H.mm').toFormat(this.timeFormat) + ' ' + _('to') + ' ' + DateTime.fromFormat(this.convertToTime(range.timeend), 'H.mm').toFormat(this.timeFormat)
        hasModifiers = true
      }
      if (!hasModifiers) {
        desc += _('always')
      }
      desc = desc.replace(/[ ,;]+$/, '')
      return desc
    },
    addRange(resource) {
      this.editRange({ id: 'new-' + new Date().getTime(), mode: 'allow', weekdays: '1,2,3,4,5,6,7', timestart: 0, timeend: 1440, resource_id: resource.id })
    },
    editRange(range) {
      this.showModal('rangedetails', RangeDetails, {
        props: {
          selectedRange: range
        },
        events: {
          save: this.saveRange,
          remove: this.deleteRange
        },
        handlers: {},
        width: 900
      })
    },
    saveRange(range) {
      const rIndex = this.product.sharedResource.findIndex(r => r.id === range.resource_id)
      if (rIndex !== -1) {
        if (!this.product.sharedResource[rIndex].ownRange) {
          this.product.sharedResource[rIndex].ownRange = []
        }
        let ranges = this.product.sharedResource[rIndex].ownRange
        const index = ranges.findIndex(r => r.id === range.id)
        if (index !== -1) {
          this.product.sharedResource[rIndex].ownRange[index] = range
        } else {
          const order = ['allow', 'denyswitch', 'deny']
          ranges.push(range)
          this.product.sharedResource[rIndex].ownRange = ranges.sort((a, b) => order.indexOf(a.mode) > order.indexOf(b.mode) ? 1 : -1)
        }
      }
    },
    deleteRange(range) {
      const rIndex = this.product.sharedResource.findIndex(r => r.id === range.resource_id)
      if (rIndex !== -1) {
        this.product.sharedResource[rIndex].ownRange = this.product.sharedResource[rIndex].ownRange.filter(r => r.id !== range.id)
      }
    },
    selectCalendar(resource) {
      this.showModal('googlecalendarselector', GoogleCalendarSelector, {
        props: {
          settings: this.settings,
          locale: this.shortLocale,
          resource: resource
        },
        events: {
          selectCalendar: this.calendarSelected
        },
        handlers: {},
        width: 800
      })
    },
    detachCalendar(resource) {
      resource.google_calendar_id = ''
      resource.google_calendar_title = ''
    },
    calendarSelected (obj) {
      let resource = obj.resource
      resource.google_calendar_id = obj.calendar.id
      resource.google_calendar_title = obj.calendar.summary
      resource.google_calendar_mode = obj.mode
    },
    selectIglooLock(resource) {
      this.showModal('igloolockselector', IglooLockSelector, {
        props: {
          settings: this.settings,
          locale: this.shortLocale
        },
        events: {
          selectLock: this.iglooLockSelected(resource)
        },
        handlers: {},
        width: 800
      })
    },
    detachIglooLock(resource) {
      resource.igloohome_lockcode = null
      resource.igloohome_lockname = null
    },
    iglooLockSelected (resource) {
      return (lock) => {
        resource.igloohome_lockcode = lock._id
        resource.igloohome_lockname = lock.name
      }
    },
    selectRatnaApartment(resource) {
      this.showDialog({
        title: this._('Select apartment'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Select'),
            class: 'success',
            icon: 'check',
            requiredFields: ['id'],
            handler: this.ratnaApartmentSelected(resource)
          }
        ],
        fields: [
          {
            title: this._('Apartment'),
            type: 'select',
            name: 'id',
            options: this.ratnaApartments.map(a => { return { value: a.id, name: a.name } })
          },
        ]
      })
    },
    detachRatnaApartment(resource) {
      resource.ratna_lockcode = null
      resource.ratna_lockname = null
    },
    ratnaApartmentSelected(resource) {
      return (data) => {
        if (!data.id) {
          return
        }
        const apartment = this.ratnaApartments.find(a => a.id === data.id)
        if (apartment) {
          resource.ratna_lockcode = apartment.id
          resource.ratna_lockname = apartment.name
        }
      }
    },
    addPricerow () {
      let pricerow = {
        id: 'new' + new Date().getTime(),
        isdefault: 0,
				name: '',
        price: 0,
        pricing_id: 0,
        returnprice: 0,
				unit: '',
				unittype: this.isTransportation ? 2 : 3,
				min: '',
				max: '',
        minparticipants: '',
        maxparticipants: '',
        minresources: '',
        maxresources: '',
				internalduration: 0, 
				datestart: false,
				dateend: false,
        timestart: false,
        timeend: false, 
        weekdays: '1,2,3,4,5,6,7',
        startweekdays: '1,2,3,4,5,6,7',
        endweekdays: '1,2,3,4,5,6,7',
				includes: 1,
				pricetiers: '',
        route: '',
        origin: '',
        destination: ''
      }
      this.editPricerow(pricerow)
    },
    editPricerow (pricerow) {
      this.showModal('pricerowdetails', PricerowDetails, {
        props: {
          origPricerow: pricerow,
          product: this.product,
          settings: this.settings,
          locale: this.shortLocale,
          routes: this.allRoutes,
          zones: this.allZones,
          pricingOptions: this.pricingOptions,
          rateplans: this.pricerowRateplans
        },
        events: {
          save: this.savePricerow,
          remove: this.removePricerow
        },
        handlers: {},
        width: 800
      })
    },
    isPricerowVisible (pricerow) {
      if (!this.pricerowRateplanFilter || !this.showPricerowRateplans) {
        return true
      }
      if (this.pricerowRateplanFilter === 'none') {
        return !pricerow.rateplan_id
      }
      return String(pricerow.rateplan_id) === this.pricerowRateplanFilter
    },
    pricerowRateplanName (pricerow) {
      if (!pricerow.rateplan_id) {
        return this._('All rates')
      }
      const rateplan = this.pricerowRateplans.find(r => String(r.id) === String(pricerow.rateplan_id))
      return rateplan ? rateplan.title : '#' + pricerow.rateplan_id
    },
    rateplanUrl (id) {
      return this.baseDomain + this.shopId + '/products/' + this.product.id + '/rateplans' + (id ? '/' + id : '') + '.json?apikey=' + this.apiKey + this.versionStr
    },
    async loadRateplans () {
      let response
      try {
        response = await axios.get(this.rateplanUrl() + '&_=' + Date.now())
      } catch (e) {
        this.showError(e, undefined, true)
        return
      }
      const data = response.data
      this.product.ownRateplan = Array.isArray(data) ? data : Object.values(data || {}).filter(r => r && r.id)
    },
    rateplanTermsName (rateplan) {
      return this.rateplanTermsLabel(rateplan, this.termsOptions)
    },
    rateplanCancellationLabel (rateplan) {
      return this.rateplanCancellationText(rateplan)
    },
    rateplanFields (rateplan) {
      return this.rateplanBaseFields(rateplan, this.termsOptions, !this.pricerowRateplans.length)
    },
    rateplanPayload (data) {
      return this.rateplanBasePayload(data)
    },
    addRateplanDialog () {
      this.showDialog({
        title: this._('Add rate'),
        buttons: [
          { title: this._('Close'), icon: 'close', handler: () => {} },
          {
            title: this._('Save'),
            class: 'success',
            icon: 'check',
            requiredFields: ['title'],
            handler: async (data) => {
              const payload = this.rateplanPayload(data)
              payload.sort = this.pricerowRateplans.length
              try {
                await axios.post(this.rateplanUrl(), payload)
              } catch (e) {
                this.showError(e, undefined, true)
              }
              await this.loadRateplans()
            }
          }
        ],
        fields: this.rateplanFields()
      })
    },
    editRateplanDialog (rateplan) {
      this.showDialog({
        title: this._('Edit rate'),
        buttons: [
          { title: this._('Close'), icon: 'close', handler: () => {} },
          {
            title: this._('Save'),
            class: 'success',
            icon: 'check',
            requiredFields: ['title'],
            handler: async (data) => {
              const payload = this.rateplanPayload(data)
              if (!payload.is_default && parseInt(rateplan.is_default)) { // One default is always kept, so it moves by setting another plan as the default
                delete payload.is_default
              }
              try {
                await axios.put(this.rateplanUrl(rateplan.id), payload)
              } catch (e) {
                this.showError(e, undefined, true)
              }
              await this.loadRateplans()
            }
          }
        ],
        fields: this.rateplanFields(rateplan)
      })
    },
    async setDefaultRateplan (rateplan) {
      if (parseInt(rateplan.is_default)) {
        return
      }
      try {
        await axios.put(this.rateplanUrl(rateplan.id), { is_default: 1 })
      } catch (e) {
        this.showError(e, undefined, true)
      }
      await this.loadRateplans()
    },
    async deleteRateplan (rateplan) {
      if (!confirm(this._('Delete the rate %s?').replace('%s', rateplan.title))) {
        return
      }
      try {
        await axios.delete(this.rateplanUrl(rateplan.id))
      } catch (e) {
        this.showError(e, undefined, true)
        return
      }
      if (String(this.pricerowRateplanFilter) === String(rateplan.id)) {
        this.pricerowRateplanFilter = ''
      }
      await this.loadRateplans()
    },
    savePricerow (pricerow) {
      var found = false
      if (parseInt(pricerow.unit, 10) === 0 || isNaN(parseInt(pricerow.unit, 10))) {
        pricerow.unit = 1
      }
      for (var i = 0; i < this.product.ownPricerow.length; i++) {
        if (this.product.ownPricerow[i].id === pricerow.id) {
          this.product.ownPricerow[i] = pricerow
          found = true
          break
        }
      }
      if (!found) {
        this.product.ownPricerow.push(pricerow)
      }
      if (!this.product.ownStarttime || !this.product.ownStarttime.length) {
        this.addStarttime()
      }
    },
    removePricerow (pricerow) {
      for (var i = 0; i < this.product.ownPricerow.length; i++) {
        if (this.product.ownPricerow[i].id === pricerow.id) {
          this.product.ownPricerow.splice(i, 1)
          return
        }
      }
    },
    copyPricerows () {
      this.showModal('copypricerows', CopyPricerows, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey
        },
        events: {
          selectProduct: this.copyPricerowProductSelected
        },
        handlers: {},
        width: 800
      })
    },
    async copyPricerowProductSelected (params) {
      let response
      if (params.product) {
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + params.product.id + '.json')
        } catch(e) {
          return
        }
        let data = response.data
        let replace = params.copyOrReplace
        let pricetiersEnabled = false
        if (data && data.ownPricerow && data.ownPricerow.length) {
          if (replace) {
            this.product.ownPricerow = []
          }
          let alreadyHasDefault = !!this.product.ownPricerow.find(p => parseInt(p.isdefault))
          for (let i = 0; i < data.ownPricerow.length; i++) {
            var pr = data.ownPricerow[i]
            pr.id = 'new' + i + new Date().getTime()
            pr.product_id = this.product.id
            pr.pricing_id = null
            pr.route = ''
            if (alreadyHasDefault) {
              pr.isdefault = 0
            }
            if (pr.pricetiers) { // Check if we need to enable some price tiers
              let ptArr = pr.pricetiers.split(';')
              for (let j = 0; j < ptArr.length; j++) {
                let tArr = ptArr[j].split(':')
                let ptId = parseInt(tArr[0], 10)
                let found = false
                for (let k = 0; k < this.product.sharedPricetier.length; k++) {
                  if (parseInt(this.product.sharedPricetier[k].id, 10) === ptId) {
                    found = true
                    break
                  }
                }
                if (!found) {
                  let newPt = this.allPricetiers.find(p => parseInt(p.id, 10) === ptId)
                  this.product.sharedPricetier.push(newPt)
                  pricetiersEnabled = true
                }
              }
            }
            this.product.ownPricerow.push(pr)
          }
          if (pricetiersEnabled) {
            this.showNotification(this._('Price rows were copied successfully, but some price tiers had to be enabled.'))
          }
        }
      }
    },
    modifyPricerows () {
      this.showModal('modifypricerows', ModifyPricerows, {
        props: {
          enableParticipantPricing: this.enableParticipantPricing,
          selectedPricerows: this.selectedPricerows,
          pricerows: this.product.ownPricerow,
          rateplans: this.pricerowRateplans
        },
        events: {
          done: this.pricerowsModified
        },
        handlers: {},
        width: 800
      })
    },
    pricerowsModified (data) {
      let pricerows = this.product.ownPricerow.filter(p => this.selectedPricerows.includes(p.id))
      if (data.params && data.params.rateplanFilter) { // Activity pricing: only modify the selected rows of one rate
        const filter = data.params.rateplanFilter
        pricerows = pricerows.filter(p => filter === 'none' ? !p.rateplan_id : String(p.rateplan_id) === filter)
      }
      let operation = data.operation
      let type = data.params.operator
      let val = data.params.value
      switch (operation) {
        case 'copyfromproduct':
          this.copyPricerows()
          break;
        case 'delete':
          pricerows.forEach(p => this.removePricerow(p))
          this.selectedPricerows = this.selectedPricerows.filter(id => this.product.ownPricerow.find(p => p.id === id))
          break
        case 'duplicate':
          let i = 0
          pricerows.forEach(p => {
            let np = Object.assign({}, p)
            np.id = ++i + new Date().getTime()
            this.product.ownPricerow.push(np)
          })
          break
        case 'alldates':
        case 'startdates':
        case 'enddates':
          if (!data.params) {
            return
          }
          let d = data.params.day
          let m = data.params.month
          let y = data.params.year
          pricerows.forEach(p => {
            if ((type === 'set' || p.datestart) && (operation === 'alldates' || operation === 'startdates')) {
              p.datestart = this.modifyDate(p.datestart, type, d, m, y)
            }
            if ((type === 'set' || p.dateend) && (operation === 'alldates' || operation === 'enddates')) {
              p.dateend = this.modifyDate(p.dateend, type, d, m, y)
            }
          })
          break
        case 'weekdays':
        case 'startweekdays':
        case 'endweekdays':
          let weekdays = data.params && data.params.weekdays && data.params.weekdays.split ? data.params.weekdays.split(',').map(d => parseInt(d)) : []
          pricerows.forEach(p => {
            let base = p[operation] && p[operation].split ? p[operation].split(',').map(d => parseInt(d)) : []
            if (type == 'set') {
              base = []
            }
            if (type == 'sub') {
              p[operation] = base.filter(item => !weekdays.includes(parseInt(item))).sort()
              if (!p[operation].length) {
                p[operation] = [1,2,3,4,5,6,7]
              }
            } else {
              p[operation] = [...(new Set(base.concat(weekdays)))].sort()
            }
            p[operation] = p[operation].join(',')
          })
          break
        case 'allprices':
          pricerows.forEach(p => {
            p.price = this.modifyPrice(p.price, type, val)
            if (this.isTransportation) {
              p.returnprice = this.modifyPrice(p.returnprice, type, val)
            }
          })
          break
        case 'unittypes':
          let unittype = parseInt(data.params.unittype)
          if (isNaN(unittype)) {
            return
          }
          pricerows.forEach(p => {
            p.unittype = unittype
          })
          break
        case 'units':
          let units = parseInt(data.params.unit)
          if (!isNaN(units)) {
            pricerows.forEach(p => {
              p.unit = String(units)
            })
          }
          break
        case 'includes':
          let includes = parseInt(data.params.includes)
          if (!isNaN(includes)) {
            pricerows.forEach(p => {
              p.includes = String(includes)
            })
          }
          break
        case 'mindurations':
        case 'maxdurations':
          let duration = parseInt(data.params.duration)
          if (!isNaN(duration)) {
            pricerows.forEach(p => {
              if (operation == 'mindurations') {
                p.min = duration
              } else {
                p.max = duration
              }
              p.internalduration = data.params.internalduration
            })
          }
          break
        case 'minparticipants':
        case 'maxparticipants':
          let participants = parseInt(data.params.participants)
          if (!isNaN(participants)) {
            pricerows.forEach(p => {
              if (operation == 'minparticipants') {
                p.minparticipants = participants
              } else {
                p.maxparticipants = participants
              }
            })
          }
          break
        case 'rateplan':
          pricerows.forEach(p => {
            p.rateplan_id = data.params.rateplan_id ? data.params.rateplan_id : null
          })
          break
        case 'minresources':
        case 'maxresources':
          let resources = parseInt(data.params.resources)
          if (!isNaN(resources)) {
            pricerows.forEach(p => {
              if (operation == 'minresources') {
                p.minresources = resources
              } else {
                p.maxresources = resources
              }
            })
          }
          break
      }
    },
    deletePricerows () {
      let pricerows = this.product.ownPricerow.filter(p => this.selectedPricerows.includes(p.id))
      pricerows.forEach(p => this.removePricerow(p))
      this.selectedPricerows = []
    },
    modifyDate(date, type, d, m, y) {
      let md = DateTime.fromFormat(date, 'd.M.yyyy')
      if (type == 'add') {
        if (d) {
          md = md.plus({ days: Number(d) })
        }
        if (m) {
          md = md.plus({ months: Number(m) })
        }
        if (y) {
          md = md.plus({ years: Number(y) })
        }
      }
      if (type == 'sub') {
        if (d) {
          md = md.minus({ days: Number(d) })
        }
        if (m) {
          md = md.minus({ months: Number(m) })
        }
        if (y) {
          md = md.minus({ years: Number(y) })
        }
      }
      if (type == 'set') {
        if(y && y < 100) {
          let ymd = DateTime.fromFormat(y + '-1-1', 'yy-M-d')
          y = ymd.year
        }
        if (d && m && y) {
          md = DateTime.fromFormat(y + '-' + m + '-' +d, 'yyyy-M-d')
        } else if (d && m) {
          md = DateTime.fromFormat(md.year + '-' + m + '-' +d, 'yyyy-M-d')
        } else if (m && y) {
          md = DateTime.fromFormat(y + '-' + m + '-' + md.day, 'yyyy-M-d')
        } else if (d && y) {
          md = DateTime.fromFormat(y + '-' + md.month + '-' + d, 'yyyy-M-d')
        } else {
          if (d) {
            md = md.set({ day: Number(d) })
          }
          if (m) {
            md = md.set({ month: Number(m) })
          }
          if (y) {
            md = md.set({ year: Number(y) })
          }
        }
      }
      return md.toFormat('d.M.yyyy')
    },
    modifyPrice(price, type, val) {
      var ret = 0
      switch (type) {
        case 'set':
          ret = val
          break
        case 'add':
          ret = parseFloat(price) + parseFloat(val.replace(',', '.'))
          break
        case 'sub':
          ret = parseFloat(price) - parseFloat(val.replace(',', '.'))
          break
        case 'addperc':
          ret = parseFloat(price) * ((100 + parseFloat(val.replace(',', '.'))) / 100)
          break
        case 'subperc':
          ret = parseFloat(price) * ((100 - parseFloat(val.replace(',', '.'))) / 100)
          break
      }
      if (isNaN(ret)) {
        return price
      }
      ret = Math.round(ret * 100) / 100
      return ret + ''
    },
    pickLocation () {
      this.showModal('locationselector', LocationSelector, {
        props: {
          defaultLat: this.product.channeldata.latitude,
          defaultLng: this.product.channeldata.longitude,
          defaultAddress: this.product.channeldata.streetaddress + ' ' + this.product.channeldata.postarea,
          settings: this.settings,
          locale: this.shortLocale
        },
        events: {
          selectLocation: this.locationSelected
        },
        handlers: {},
        width: 800
      })
    },
    locationSelected (data) {
      this.product.channeldata.latitude = data.lat
      this.product.channeldata.longitude = data.lng
    },
    getMaccsChecksum() {
      let attr = this.product.channeldata.maccsboxid + '-' + this.product.channeldata.maccsboxlanguage + '-' + this.product.channeldata.maccsboxsubtitles + '-' 
      return attr + this.channelAttributes.join('-')
    },
    getSaveData () {
      const exportFields = [
        'id',
        'name',
        'type',
        'subtype',
        'displayedtype',
        'loyalty',
        'smartum_benefit',
        'epassi_benefit',
        'edenred_benefit',
        'externalid',
        'externalrate',
        'marketingname',
        'usemarketingname',
        'canonical',
        'description',
        'allow_sale_under_warehouse',
        'hide_pricing',
        'price',
        'minprice',
        'maxprice',
        'pricing_id',
        'vat',
        'file_id',
        'file_ext',
        'file_title',
        'file_description',
        'file_video',
        'file_smartcrop',
        'mobileimage_id',
        'mobileimage_ext',
        'mobileimage_title',
        'mobileimage_description',
        'mobileimage_video',
        'mobileimage_smartcrop',
        'image_id', 
        'image_ext',
        'mainimagelayout',
        'voucher_id',
        'vouchers',
        'voucher_start',
        'voucher_end',
        'ean',
        'deadlineoffset',
        'reservableuntil',
        'maintenancewindow',
        'maxallowedseats',
        'allow_multiday',
        'hide_times',
        'hide_units',
        'hide_capacity',
        'hide_checkin',
        'enable_calendar',
        'enable_availability',
        'preselecteddates',
        'margin_travel_agent',
        'enable_participant_pricing',
        'enable_gofinland',
        'enable_bokun',
        'enable_gyg',
        'enable_retkipaikka',
        'enable_catalog',
        'enable_collection',
        'enable_category',
        'displayname',
        'displayimage',
        'displaydescription',
        'displayprice',
        'displaystock',
        'buttontext',
        'quantitytitle',
        'packagingtitle',
        'optionstitle',
        'channeldata',
        'sharedDeliverymethod',
        'sharedSaleschannel',
        'sharedCollection',
        'sharedCommission',
        'sharedDimension',
        'sharedFile',
        'sharedPricetier',
        'sharedTag',
        'sharedResource',
        'sharedResourcepool',
        'ownPricerow',
        'pricing_engine',
        'ownDistance',
        'ownStarttime',
        'enable_deliverymethods_storefront',
        'display_name_in_workflow',
        'limit_availability',
        'relaxmincount',
        'display_optionprice',
        'accommodationtype',
        'requiredinfo',
        'terms_id',
        'disable_orderrequest_cancellation',
        'disable_orderrequest_move',
        'form_id',
        'paymentplan_id',
        'pagetitle',
        'datepublished',
        'datemodified',
        'datedisplay'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.product[e], a), {})
      if (data.pricing_engine === 'calendar') {
        data.ownStarttime = this.starttimesForCalendar(data.ownStarttime)
      }
      data.source = 'editor'
      data.sharedCollection = this.enabledPublishedCollections
      data.sharedNotification = this.notifications
      data.ownRange = this.ranges
      data.linkedProducts = this.linkedProducts
      data.linkedCategories = this.linkedCategories
      data.version = this.version
      if (this.deadlineOffsetOption === 'after') {
        data.deadlineoffset = -data.deadlineoffset;
      }
      if (this.isOpenValueCard) {
        data.vouchers = '1'
      } else {
        data.minprice = data.maxprice = null
      }
      if (parseInt(this.product.type) === this.TYPE_SELLABLE) {
        for (let i = 0; i < data.sharedResource.length; i++) {
          const resource = data.sharedResource[i]
          if (this.resourceCapacity[resource.id] !== this.origResourceCapacity[resource.id]) {
            resource.count = this.resourceCapacity[resource.id]
            resource.originalcount = this.origResourceCapacity[resource.id]
          }
          resource.units = this.resourceUnits[resource.id]
        }
        for (let i = 0; i < data.sharedResourcepool.length; i++) {
          const resourcePool = data.sharedResourcepool[i]
          resourcePool.units = this.resourcePoolUnits[resourcePool.id]
        }
      }
      if (this.initialMaccsChecksum != this.getMaccsChecksum()) {
        data.maccsdirty = 1
      }
      if (data.description === undefined || data.description === null) {
        data.description = ''
      }
      if (data.channeldata && (data.channeldata.description === undefined || data.channeldata.description === null)) {
        data.channeldata.description = ''
      }
      data.access_rules = this.accessRules.groups.length
        ? JSON.stringify({
            groups: this.accessRules.groups.map(g => g.id),
            duration_type: this.accessRules.duration_type,
            fixed_startdate: this.accessRules.fixed_startdate || null,
            fixed_enddate: this.accessRules.fixed_enddate || null,
            offset_value: this.accessRules.offset_value || null,
            offset_unit: this.accessRules.offset_unit || null
          })
        : null
      if (this.isActivityPricingEnabled) { // Activity pricing fields are only sent when the shop has the feature
        if (data.pricing_engine === 'activitycalendar') { // The durations of the activity are the merchant's input only for the activity calendar
          const units = this.activityDurationUnits()
          data.product_units = units.map(u => u.unit + (u.unitType === this.UNIT_HOUR ? 'h' : 'm')).join(';')
          data.product_unit = units.length ? units[0].unit : null
          data.unit_type = units.length ? units[0].unitType : this.UNIT_MINUTE
        }
        if (this.isReservable && !this.isEvent) {
          data.participant_tickets = parseInt(this.product.participant_tickets) ? 1 : 0
        }
        if (this.isActivity) {
          data.bokun_id = this.product.bokun_id ? String(this.product.bokun_id).trim() : null
        }
        if (Array.isArray(this.product.ownOptiongroup)) { // Sending the groups replaces the product's set of choice groups
          // A choice without options is left out, so saving removes it
          const usedGroups = this.product.ownOptiongroup.filter(group => this.groupOptions(group).some(lp => Number(lp.type) === this.LINKEDPRODUCT_OPTIONAL))
          data.ownOptiongroup = usedGroups.map(group => {
            const ret = {
              name: group.name || '',
              required: parseInt(group.required) ? 1 : 0,
              role: group.role || null
            }
            if (group.id) {
              ret.id = group.id
            } else {
              ret.key = group.key
            }
            return ret
          })
          data.linkedProducts = this.linkedProducts.map(lp => {
            const group = Number(lp.type) === this.LINKEDPRODUCT_OPTIONAL ? this.findOptionGroup(lp) : null // Only optional options can be in a group
            const transportStop = this.isPlaceGroup(group) && this.isTransportOption(lp) && lp.stop_id ? lp.stop_id : null // Only a transport in a place choice has a stop
            return Object.assign({}, lp, {
              optiongroup_id: group && group.id ? group.id : null,
              optiongroup_key: group && !group.id ? group.key : null,
              stop_id: transportStop,
              stoptiming: transportStop ? (lp.stoptiming === 'timetable' ? 'timetable' : 'activity') : null
            })
          })
        }
      }
      return data
    },
    copyDialog () {
      this.showDialog({
        title: this._('Enter a name for the new product'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['name'],
            handler: (data) => {
              this.copy(data.name, data.availability)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter a name for the new product')
          },
          {
            title: this._('Availability'),
            type: 'select',
            name: 'availability',
            defaultValue: 'link',
            options: [{
              value: 'link',
              name: this._('Link to the availability and capacity of the original product')
            }, 
            {
              value: 'new',
              name: this._('Setup new availability and capacity')
            }]
          }
        ]
      })
    },
    translateDialog () {
      const $this = this
      this.showModal('translationselector', TranslationSelector, {
        props: {
          title: this._('Select texts to be translated'),
          settings: this.settings,
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          parent: this.product,
          parentType: 'products',
          className: 'modal-content'
        },
        events: {
          result (data) {
            for (let i = 0; i < data.length; i++) {
              const d = data[i]
              if (d.field.includes('.')) {
                let [type, field] = d.field.split('.')
                if (type === 'channeldata') {
                  $this.product.channeldata[field] = d.text
                }
                if (type.match(/^notification\-/)) {
                  let [, nId] = type.split('-')
                  for (let i = 0; i < $this.notifications.length; i++) {
                    if ($this.notifications[i].id == nId) {
                      $this.notifications[i][field] = d.text
                      break
                    }
                  }
                }
                if (type.match(/^distance\-/)) {
                  let [, nId] = type.split('-')
                  if ($this.product.ownDistance) {
                    for (let i = 0; i < $this.product.ownDistance.length; i++) {
                      if ($this.product.ownDistance[i].id == nId) {
                        $this.product.ownDistance[i][field] = d.text
                        break
                      }
                    }
                  }
                }
                if (type.match(/^file\-/)) {
                  let [, nId] = type.split('-')
                  if ($this.product.file_id == nId) {
                    $this.product['file_' + field] = d.text
                  } else {
                    for (let i = 0; i < $this.product.sharedFile.length; i++) {
                      if ($this.product.sharedFile[i].id == nId) {
                        $this.product.sharedFile[i][field] = d.text
                        break
                      }
                    }
                  }
                }
              } else {
                $this.product[d.field] = d.text
              }
            }
          }
        },
        handlers: {},
        width: 1000
      })
    },
    async copy (name, availability) {
      let response
      const data = {
        name,
        availability
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/products/' + this.product.id + '/copy.json?apikey=' + this.apiKey, data)
      } catch(e) {
        return this.showError(this._('Copying the product failed!'))
      }
      this.showNotification(this._('Product copied.'))
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ProductDetails',
        title: this._('Product') + ' ' + response.data + ': ' + name,
        width: 6,
        data: {
          productId: response.data,
          trail: this.componentTrail
        }
      })
    },
    publish () {
      this.setArchiveStatus('0')
    },
    archive () {
      this.setArchiveStatus('1')
    },
    schedulePublish () {
      return this.schedule('publish')
    },
    scheduleArchive () {
      return this.schedule('archive')
    },
    scheduleVisibility () {
      return this.schedule('visibility')
    },
    schedule (action) {
      this.showModal('tasktypeselector', TaskTypeSelector, {
        props: {
          preselectedType: 'productAction',
          preselectedAction: action,
          preselectedProduct: { id: this.product.id, name: this.product.name },
          publishingMode: this.publishingMode,
          currentEnableCatalog: this.product.enable_catalog || '0',
          currentEnableCollection: this.product.enable_collection || '0'
        },
        events: {
          selected: this.doSchedule
        },
        handlers: {},
        width: 800
      })
    },
    async doSchedule (data) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/scheduledtasks.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
    },
    async setArchiveStatus (archived) {
      let response
      const data = {
        id: this.product.id,
        archived
      }
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/products/' + this.product.id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        return this.showError(e)
      }
    },
    downloadSalesReport () {
  		window.open(this.baseDomain + this.shopId + '/products/' + this.product.id + '/sales.xlsx?apikey=' + this.apiKey)
    },
    async doRemove () {
      let response
      this.storeState()
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/products/' + this.product.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deleting the product failed!'))
      }
      this.showNotification(this._('Product deleted!'))
      this.close()
    },
    async save () {
      await this.awaitUploadsBeforeSave()
      this.saving = true
      const data = this.getSaveData()
      this.storeState()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/products/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/products.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        this.applyPendingUploads()
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        try {
          await this.loadProduct(response.data.id)
        } catch(e) {}
      }
      if (this.gygOptionsProductId) {
        this.loadGygOptions()
      }
      if (this.bokunRatesProductId) {
        this.loadBokunRates()
      }
      this.saving = false
      this.applyPendingUploads()
      this.saved = true
      this.resourcesTainted = false
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.product)
      this.EventBus.$emit('widgetVisibilityUpdate', { shopId: this.shopId })
      if (this.saveShouldClose) {
        this.close()
      }
    },
    isConditionalTab(tab) {
      if (tab === 'prices' || tab === 'messages') {
        if (this.product && parseInt(this.product.subtype, 10) === this.SUBTYPE_CONTENT) {
          return true
        }
      } 
      if (tab === 'links') {
        if (this.product && parseInt(this.product.min_count)) {
          return true
        }
      } 
      if (tab !== 'general') {
        if (!this.product || !this.product.id) {
          return true
        }
      }
      if (tab === 'johkuchannels') {
        if (this.product && parseInt(this.product.subtype) === this.SUBTYPE_TICKET) {
          return true
        }
      } 
      return false
    },
    close () {
      // Commented this out because this won't work with the unsaved changes watcher
      // this.product = {}
      if (this.isModal) {
        this.$emit('close')
      } else {
        this.EventBus.$emit('hideDetailsColumn', {
          shopId: this.shopId,
          data: {
            trail: this.componentTrail
          }
        })
      }
    },
    // Puts a file uploaded through the upload queue in its place (lib/uploadaware.js)
    applyUploadResult (slot, file) {
      if (!this.product || !file) {
        return
      }
      if (slot === 'main') {
        this.product.file_ext = file.ext
        this.product.file_id = this.product.image_id = file.id
      } else if (slot === 'mobile') {
        this.product.mobileimage_ext = file.ext
        this.product.mobileimage_id = file.id
      } else {
        // 'gallery', and 'embed' for images pasted into the description
        this.addPastedExtraImage(file)
      }
    },
    queueDescriptionImage (file, name) {
      return this.queueUpload(file, 'embed', { name })
    },
    editCaption(source) {
      let data = {}
      if (source === 'main') {
        data.defaultTitle = this.product.file_title
        data.defaultDescription = this.product.file_description
        data.defaultVideo = this.product.file_video
        data.defaultSmartCrop = this.product.file_smartcrop
        data.source = 'main'
      } else if (source === 'mobile') {
        data.defaultTitle = this.product.mobileimage_title
        data.defaultDescription = this.product.mobileimage_description
        data.defaultVideo = this.product.mobileimage_video
        data.defaultSmartCrop = this.product.mobilefile_smartcrop
        data.source = 'mobile'
      } else {
        data.defaultTitle = source.title
        data.defaultDescription = source.description
        data.defaultVideo = source.video
        data.defaultSmartCrop = source.smartcrop
        data.source = source
      }
      data.settings = this.settings
      this.showModal('filecaption', FileCaption, {
        props: data,
        events: {
          save: this.saveCaption
        },
        handlers: {},
        width: 800
      })
    },
    saveCaption (data) {
      if (data.source === 'main') {
        this.product.file_title = data.title
        this.product.file_description = data.description
        this.product.file_video = data.video
        this.product.file_smartcrop = data.smartcrop
      } else if (data.source === 'mobile') {
        this.product.mobileimage_title = data.title
        this.product.mobileimage_description = data.description
        this.product.mobileimage_video = data.video
        this.product.mobileimage_smartcrop = data.smartcrop
      } else {
        for (let i = 0; i < this.product.sharedFile.length; i++) {
          if (this.product.sharedFile[i].id === data.source.id) {
            this.product.sharedFile[i].title = data.title
            this.product.sharedFile[i].description = data.description
            this.product.sharedFile[i].video = data.video
            this.product.sharedFile[i].smartcrop = data.smartcrop
            break
          }
        }
      }
    },
    makeNotificationDesc (notification) {
      if (!notification) {
        return ''
      }
      return notification.name
    },
    makeNotificationType (notification) {
      switch (parseInt(notification.type, 10)) {
        case 1:
          return this._('SMS')
        case 2:
          return this._('Email')
        case 4:
          return this._('Zapier')
      }
      return ''
    },
    async copyToClipboard(data) {
      try {
        let status = await this.$copyText(data)
        this.showNotification(this._('Code copied to clipboard!'))
      } catch(e) {
        this.showError(e)
      }
    },
    async copyGygProductId (key) {
      try {
        await this.$copyText(key)
        this.showNotification(this._('Product ID copied to clipboard!'))
      } catch(e) {
        this.showError(e)
      }
    },
    async loadGygOptions () {
      const productId = this.gygOptionsProductId
      if (!productId) {
        this.gygOptions = null
        return
      }
      this.gygOptionsLoading = true
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/gyg/options.json?product=' + productId + '&apikey=' + this.apiKey)
      } catch (e) {
        this.gygOptionsLoading = false
        this.gygOptions = null
        this.showError(e)
        return
      }
      this.gygOptionsLoading = false
      if (parseInt(productId) === parseInt(this.gygOptionsProductId)) { // Another product may have been opened meanwhile
        this.gygOptions = response.data
      }
    },
    async loadBokunRates () {
      const productId = this.bokunRatesProductId
      if (!productId || !this.bokunRatesDate) {
        this.bokunRates = null
        return
      }
      this.bokunRatesLoading = true
      let response
      try {
        const date = DateTime.fromJSDate(this.bokunRatesDate, { zone: this.timezone }).toISODate()
        response = await axios.get(this.baseDomain + this.shopId + '/products/' + productId + '/bokunrates.json?date=' + date + '&apikey=' + this.apiKey)
      } catch (e) {
        this.bokunRatesLoading = false
        this.bokunRates = null
        this.showError(e)
        return
      }
      this.bokunRatesLoading = false
      if (parseInt(productId) === parseInt(this.bokunRatesProductId)) { // Another product may have been opened meanwhile
        this.bokunRates = response.data
        const times = this.bokunRateTimes
        if (!times.includes(this.bokunRatesTime)) {
          this.bokunRatesTime = times.length ? times[0] : null
        }
      }
    },
    // "Private · 2 h · 3 participants" from the parts of a preview rate; Bókun's own label is "Private · 2h (3–3)"
    bokunRateText (rate) {
      const parts = rate.plan ? [rate.plan] : []
      const m = /^(\d+)([mhd])$/.exec(String(rate.duration || ''))
      if (m) {
        const n = parseInt(m[1])
        if (m[2] === 'm') {
          parts.push(this._('%s min').replace('%s', n))
        } else if (m[2] === 'h') {
          parts.push(n + ' ' + this._('h'))
        } else {
          parts.push(n === 1 ? this._('1 day') : this._('%s days').replace('%s', n))
        }
      }
      const min = parseInt(rate.min) || 0
      const max = parseInt(rate.max) || 0
      if (min && min === max) {
        parts.push((min === 1 ? this._('%s participant') : this._('%s participants')).replace('%s', min))
      } else if (min && !max) {
        parts.push(this._('%s+ participants').replace('%s', min))
      } else if (max) {
        parts.push(this._('%s participants').replace('%s', (min || 1) + '–' + max))
      }
      return parts.join(' · ')
    },
    bokunMoney (amount) {
      return this.formatNumber(amount, this.settings.numberformat || 'fi-FI') + ' ' + this.currencySymbol(this.bokunRates && this.bokunRates.currency ? this.bokunRates.currency : this.settings.currency)
    },
    // Unticking warns when GetYourGuide has options of the product to deactivate
    toggleGyg (event) {
      const checked = event.target.checked
      if (checked || !this.gygOptions || !this.gygOptions.options || !this.gygOptions.options.length) {
        this.product.enable_gyg = checked ? '1' : '0'
        return
      }
      event.target.checked = true
      this.showDialog({
        title: this._('GetYourGuide will deactivate the connected options of this product.'),
        clickToClose: false,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Remove from GetYourGuide'),
            class: 'warning',
            icon: 'check',
            handler: () => {
              this.product.enable_gyg = '0'
            }
          }
        ]
      })
    },
    async activateGygOption (option) {
      this.gygActivating[option.key] = true
      try {
        await axios.post(this.baseDomain + this.shopId + '/gyg.json?apikey=' + this.apiKey, { action: 'activate', key: option.key })
      } catch (e) {
        this.gygActivating[option.key] = false
        this.showError(e)
        return
      }
      this.gygActivating[option.key] = false
      this.showNotification(this._('Reactivation requested. GetYourGuide updates the status shortly.'))
      this.loadGygOptions()
    },
    linkedProductType(product) {
      if (!product) {
        return ''
      }
      switch (parseInt(product.type)) {
        case this.LINKEDPRODUCT_PACKAGED:
          return this._('Packaged')
        case this.LINKEDPRODUCT_MANDATORY:
          return this._('Mandatory')
        case this.LINKEDPRODUCT_OFFER:
          return this._('Linked product')
        case this.LINKEDPRODUCT_OPTIONAL:
          return this._('Optional')
        case this.LINKEDPRODUCT_HIDDEN:
          return this._('Hidden')
      }
    },
    selectLinkedProductDialog (forceType, optiongroupRef) {
      const props = {
        selectedProducts: [{ id: this.product.id }, ...this.linkedProducts.map(p => { return { id: p.linkedproduct_id } })],
        parentType: this.product.type,
        forceType: forceType,
        existingGroups: this.existingPackageGroups
      }
      if (this.isActivityPricingEnabled) {
        props.optionGroups = this.optionGroupChoices()
        if (optiongroupRef) {
          props.optiongroupRef = optiongroupRef
        }
      }
      this.showModal('productoptionselector', ProductOptionSelector, {
        props,
        events: {
          selectProduct: this.addLinkedProduct
        },
        handlers: {},
        width: 800
      })
    },
    editLinkedProductDialog(product) {
      const props = {
        selectedProducts: [{ id: this.product.id }, ...this.linkedProducts.filter(p => p.id !== product.id).map(p => { return { id: p.linkedproduct_id } })],
        parentType: this.product.type,
        linkedProduct: product,
        existingGroups: this.existingPackageGroups
      }
      if (this.isActivityPricingEnabled) {
        props.optionGroups = this.optionGroupChoices()
        props.optiongroupRef = this.linkedProductGroupRef(product)
      }
      this.showModal('productoptionselector', ProductOptionSelector, {
        props,
        events: {
          selectProduct: this.saveLinkedProduct
        },
        handlers: {},
        width: 800
      })
    },
    saveLinkedProduct(linkedProduct) {
      const id = linkedProduct.id
      if (!id) {
        return this.addLinkedProduct(linkedProduct)
      }
      const product = linkedProduct.product
      if (product) {
        let existingIndex = this.linkedProducts.findIndex(lp => lp.id == id)
        if (existingIndex === -1) {
          return this.addLinkedProduct(linkedProduct)
        }
        const existing = this.linkedProducts[existingIndex]
        const sameProduct = String(existing.linkedproduct_id) === String(product.id) // The transport's stop is kept unless the product changed
        this.linkedProducts[existingIndex] = {
          id: linkedProduct.id,
          linkedproduct_id: product.id,
          linkedproduct: product,
          type: linkedProduct.type,
          multiply: linkedProduct.multiply,
          timerange: linkedProduct.timerange,
          startoffset: linkedProduct.startOffset,
          startoffsetmode: linkedProduct.startOffsetMode,
          endoffset: linkedProduct.endOffset,
          endoffsetmode: linkedProduct.endOffsetMode,
          includeinprice: linkedProduct.includeinprice,
          repeat: linkedProduct.repeat,
          group: linkedProduct.group,
          requireparticipant: linkedProduct.requireparticipant,
          multiplyparticipant: linkedProduct.multiplyparticipant,
          stop_id: sameProduct ? existing.stop_id : null,
          stoptiming: sameProduct ? existing.stoptiming : null
        }
        if (linkedProduct.optiongroup !== undefined) {
          this.setLinkedProductGroup(this.linkedProducts[existingIndex], linkedProduct.optiongroup)
        }
        this.syncRequireParticipant(linkedProduct)
        this.reorderLinkedProductGroups()
      }
    },
    addLinkedProduct (linkedProduct) {
      const product = linkedProduct.product
      if (product) {
        const newLinkedProduct = {
          id: 'new-' + (new Date().getTime()),
          linkedproduct_id: product.id,
          linkedproduct: product,
          type: linkedProduct.type,
          multiply: linkedProduct.multiply,
          timerange: linkedProduct.timerange,
          startoffset: linkedProduct.startOffset,
          startoffsetmode: linkedProduct.startOffsetMode,
          endoffset: linkedProduct.endOffset,
          endoffsetmode: linkedProduct.endOffsetMode,
          includeinprice: linkedProduct.includeinprice,
          repeat: linkedProduct.repeat,
          group: linkedProduct.group,
          requireparticipant: linkedProduct.requireparticipant,
          multiplyparticipant: linkedProduct.multiplyparticipant,
          stop_id: null,
          stoptiming: null
        }
        if (linkedProduct.optiongroup !== undefined) {
          this.setLinkedProductGroup(newLinkedProduct, linkedProduct.optiongroup)
        }
        this.linkedProducts.push(newLinkedProduct)
        this.syncRequireParticipant(linkedProduct)
        this.reorderLinkedProductGroups()
      }
    },
    optionGroupRef (group) { // Activity pricing: saved choice groups are referred to by id, unsaved ones by a client-side key
      return group.id ? 'id:' + group.id : 'key:' + group.key
    },
    optionGroupChoices () {
      return this.optionGroups.map(group => ({ ref: this.optionGroupRef(group), name: group.name }))
    },
    findOptionGroup (linkedProduct) {
      if (!linkedProduct) {
        return null
      }
      if (linkedProduct.optiongroup_key) {
        return this.optionGroups.find(g => !g.id && g.key === linkedProduct.optiongroup_key) || null
      }
      if (linkedProduct.optiongroup_id) {
        return this.optionGroups.find(g => g.id && String(g.id) === String(linkedProduct.optiongroup_id)) || null
      }
      return null
    },
    linkedProductGroupRef (linkedProduct) {
      const group = this.findOptionGroup(linkedProduct)
      return group ? this.optionGroupRef(group) : ''
    },
    setLinkedProductGroup (linkedProduct, ref) {
      const [kind, value] = ref ? ref.split(/:(.*)/) : ['', '']
      linkedProduct.optiongroup_id = kind === 'id' ? value : null
      linkedProduct.optiongroup_key = kind === 'key' ? value : null
      if (linkedProduct.stop_id && !this.isPlaceGroup(this.findOptionGroup(linkedProduct))) { // A transport's stop only applies in a place choice
        linkedProduct.stop_id = null
        linkedProduct.stoptiming = null
      }
    },
    addOptionGroup (role) { // Activity pricing: a choice the customer picks one option of; pick-up / drop-off places are named for them
      this.addChoiceMenuOpen = false
      const group = {
        key: 'new' + new Date().getTime(),
        name: role === 'pickup' ? this._('Pick-up place') : (role === 'dropoff' ? this._('Drop-off place') : ''),
        required: '0',
        role: role || null
      }
      this.product.ownOptiongroup = [...this.optionGroups, group]
    },
    closeAddChoiceMenu () {
      setTimeout(() => { this.addChoiceMenuOpen = false }, 150)
    },
    isPlaceGroup (group) {
      return !!group && (group.role === 'pickup' || group.role === 'dropoff')
    },
    choiceGroupPlaceholder (group) {
      if (group.role === 'pickup') {
        return this._('Pick-up place')
      }
      if (group.role === 'dropoff') {
        return this._('Drop-off place')
      }
      return this._('e.g. Guide language')
    },
    groupOptions (group) {
      const ref = this.optionGroupRef(group)
      return this.productOptions.filter(lp => this.linkedProductGroupRef(lp) === ref)
    },
    setGroupOptions (group, options) { // Reordered inside the box or dragged in: keep the rest of the options where they are
      const ref = this.optionGroupRef(group)
      const accepted = options.filter(lp => Number(lp.type) === this.LINKEDPRODUCT_OPTIONAL)
      accepted.forEach(lp => {
        if (this.linkedProductGroupRef(lp) !== ref) {
          this.setLinkedProductGroup(lp, ref)
        }
      })
      const rest = this.productOptions.filter(lp => accepted.indexOf(lp) === -1)
      this.productOptions = [...rest, ...accepted]
    },
    isOnlyChoice (group) { // A required choice with one option: the storefront chooses it for the customer
      return !!parseInt(group.required) && this.groupOptions(group).length === 1
    },
    addOptionToGroup (group) {
      this.selectLinkedProductDialog(this.LINKEDPRODUCT_OPTIONAL, this.optionGroupRef(group))
    },
    moveOptionToGroup (group, linkedProduct) {
      this.moveMenuGroup = null
      if (linkedProduct) {
        this.setLinkedProductGroup(linkedProduct, this.optionGroupRef(group))
      }
    },
    toggleMoveMenu (group) {
      const ref = this.optionGroupRef(group)
      this.moveMenuGroup = this.moveMenuGroup === ref ? null : ref
    },
    closeMoveMenu () {
      setTimeout(() => { this.moveMenuGroup = null }, 150)
    },
    placeTimeText (linkedProduct, group) { // The place's time as set on the link (its time offset), if any
      if (!this.isPlaceGroup(group) || linkedProduct.timerange !== 'offset') {
        return ''
      }
      const minutes = (hours) => Math.round(Math.abs(Number(hours) || 0) * 60)
      if (group.role === 'dropoff') {
        const after = minutes(linkedProduct.endoffset)
        return linkedProduct.endoffsetmode === 'afterend' && after ? this._('%s min after the end').replace('%s', after) : ''
      }
      const before = minutes(linkedProduct.startoffset)
      if (!before) {
        return ''
      }
      if (linkedProduct.startoffsetmode === 'beforestart') {
        return this._('%s min before the start').replace('%s', before)
      }
      return linkedProduct.startoffsetmode === 'afterstart' ? this._('%s min after the start').replace('%s', before) : ''
    },
    removeOptionGroup (group) {
      const ref = this.optionGroupRef(group)
      this.linkedProducts.forEach(lp => {
        if (this.linkedProductGroupRef(lp) === ref) {
          this.setLinkedProductGroup(lp, '')
        }
      })
      this.product.ownOptiongroup = this.optionGroups.filter(g => g !== group)
    },
    pickupPlaceAddress (linkedProduct) {
      const place = (this.product.pickupplaces || []).find(p => String(p.id) === String(linkedProduct.linkedproduct_id))
      if (!place) {
        return this._('The address is shown after the product has been saved.')
      }
      const address = [place.streetaddress, [place.postcode, place.postarea].filter(v => v).join(' ')].filter(v => v).join(', ')
      let desc = address ? address : this._('No address set')
      if (place.latitude === null || place.latitude === undefined || place.longitude === null || place.longitude === undefined) {
        desc += ' · ' + this._('No map point set')
      }
      return desc
    },
    isTransportOption (linkedProduct) { // Activity pricing: a transportation product in a place choice offers its route stops as places
      return !!linkedProduct && !!linkedProduct.linkedproduct && Number(linkedProduct.linkedproduct.subtype) === this.SUBTYPE_TRANSPORTATION
    },
    async loadTransportRoutes (productId) {
      if (!productId || this.transportRoutes[productId] !== undefined) {
        return
      }
      this.transportRoutes[productId] = null // Loading
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/products/' + productId + '.json?apikey=' + this.apiKey)
      } catch(e) {
        delete this.transportRoutes[productId]
        this.showError(e)
        return
      }
      const routes = []
      ;(response.data && response.data.sharedResource ? response.data.sharedResource : []).forEach(resource => {
        ;(resource.sharedRoute || []).filter(route => route.type === 'M').forEach(route => { // Outbound routes only
          routes.push((route.sharedStop || [])
            .map(stop => ({ id: String(stop.id), name: stop.name, offset: Number(stop.offset) || 0 }))
            .sort((a, b) => a.offset - b.offset))
        })
      })
      this.transportRoutes[productId] = routes
    },
    transportStops (linkedProduct) { // All stops on the transport's outbound routes
      const stops = []
      ;(this.transportRoutes[linkedProduct.linkedproduct_id] || []).forEach(route => {
        route.forEach(stop => {
          if (!stops.some(s => s.id === stop.id)) {
            stops.push(stop)
          }
        })
      })
      return stops
    },
    transportOfferedStops (linkedProduct, group) { // The stops before (pick-up) or after (drop-off) the activity's stop, with the shortest travel time
      const stopId = linkedProduct.stop_id ? String(linkedProduct.stop_id) : ''
      const dropoff = group.role === 'dropoff'
      const offered = []
      ;(this.transportRoutes[linkedProduct.linkedproduct_id] || []).forEach(route => {
        const own = route.find(stop => stop.id === stopId)
        if (!own) {
          return
        }
        route.forEach(stop => {
          const travel = dropoff ? stop.offset - own.offset : own.offset - stop.offset
          if (stop.id === stopId || travel <= 0) {
            return
          }
          const existing = offered.find(s => s.id === stop.id)
          if (!existing) {
            offered.push({ id: stop.id, name: stop.name, travel })
          } else if (travel < existing.travel) {
            existing.travel = travel
          }
        })
      })
      return offered.sort((a, b) => dropoff ? a.travel - b.travel : b.travel - a.travel)
    },
    transportPlacesText (linkedProduct, group) {
      if (!this.transportRoutes[linkedProduct.linkedproduct_id]) {
        return this._('Loading...')
      }
      const offered = this.transportOfferedStops(linkedProduct, group)
      if (!offered.length) {
        return this._('No places offered')
      }
      if (linkedProduct.stoptiming === 'timetable') {
        return offered.map(stop => stop.name).join(', ')
      }
      const margin = linkedProduct.timerange === 'offset' ? Math.round(Math.abs(Number(linkedProduct.startoffset) || 0) * 60) : 0
      const text = group.role === 'dropoff' ? this._('%s min after the end') : this._('%s min before the start')
      return offered.map(stop => stop.name + ' · ' + text.replace('%s', margin + stop.travel)).join(', ')
    },
    setTransportStop (linkedProduct, stopId) {
      linkedProduct.stop_id = stopId ? stopId : null
      if (stopId && !linkedProduct.stoptiming) {
        linkedProduct.stoptiming = 'activity'
      }
    },
    openLinkedProduct (linkedProduct) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ProductDetails',
        title: this._('Product') + ' ' + linkedProduct.linkedproduct_id + (linkedProduct.linkedproduct && linkedProduct.linkedproduct.name ? ': ' + linkedProduct.linkedproduct.name : ''),
        width: 6,
        data: {
          productId: linkedProduct.linkedproduct_id,
          activeTab: 'details',
          trail: this.componentTrail
        }
      })
    },
    syncRequireParticipant(linkedProduct) {
      if (!linkedProduct.group) {
        return
      }
      for (let i = 0; i < this.linkedProducts.length; i++) {
        if (this.linkedProducts[i].group === linkedProduct.group) {
          this.linkedProducts[i].requireparticipant = linkedProduct.requireparticipant
        }
      }
    },
    reorderLinkedProductGroups () {
      let groups = {}
      this.linkedProducts.forEach((item, index) => {
        let groupKey = item.group || `ungrouped-${index}`
        if (!groups[groupKey]) {
          groups[groupKey] = []
        }
        groups[groupKey].push(item)
      });
      let orderedGroups = Object.values(groups)
      this.linkedProducts = [].concat(...orderedGroups)
    },
    removeLinkedProduct(product) {
      this.linkedProducts = this.linkedProducts.filter(p => p.linkedproduct_id !== product.linkedproduct_id)
    },
    selectLinkedCategoryDialog () {
      this.showModal('linkedcategoryselector', LinkedCategorySelector, {
        props: {
          selectedCategories: this.linkedCategories.map(p => { return { id: p.linkedcategory_id } })
        },
        events: {
          selectCategory: this.addLinkedCategory
        },
        handlers: {},
        width: 800
      })
    },
    editLinkedCategoryDialog (linkedcategory) {
      this.showModal('linkedcategoryselector', LinkedCategorySelector, {
        props: {
          selectedCategories: this.linkedCategories.filter(c => c.id !== linkedcategory.id).map(c => { return { id: c.linkedcategory_id } }),
          linkedCategory: linkedcategory
        },
        events: {
          selectCategory: this.saveLinkedCategory
        },
        handlers: {},
        width: 800
      })
    },
    saveLinkedCategory(linkedCategory) {
      const id = linkedCategory.id
      if (!id) {
        return this.addLinkedCategory(linkedCategory)
      }
      const category = linkedCategory.category
      if (category) {
        let existingIndex = this.linkedCategories.findIndex(lp => lp.id == id)
        if (existingIndex === -1) {
          return this.addLinkedCategory(linkedCategory)
        }
        this.linkedCategories[existingIndex] = {
          id: linkedCategory.id,
          linkedcategory_id: category.id,
          linkedcategory: category,
          title: linkedCategory.title,
          hidetitle: linkedCategory.hidetitle,
          showdescription: linkedCategory.showdescription,
          view: (linkedCategory.view && linkedCategory.view !== '0') ? linkedCategory.view : '',
          searchplaceholder: linkedCategory.searchplaceholder,
          showtimeresourcepool_id: linkedCategory.showtimeresourcepool_id,
          productlistcolumncount: [2, 3, 4].indexOf(parseInt(linkedCategory.productlistcolumncount, 10)) !== -1
            ? parseInt(linkedCategory.productlistcolumncount, 10)
            : null
        }
      }
    },
    addLinkedCategory (linkedCategory) {
      const category = linkedCategory.category
      if (category) {
        this.linkedCategories.push({
          id: 'new-' + (new Date().getTime()),
          linkedcategory_id: linkedCategory.category.id,
          linkedcategory: linkedCategory.category,
          title: linkedCategory.title,
          hidetitle: linkedCategory.hidetitle,
          showdescription: linkedCategory.showdescription,
          view: (linkedCategory.view && linkedCategory.view !== '0') ? linkedCategory.view : '',
          searchplaceholder: linkedCategory.searchplaceholder,
          showtimeresourcepool_id: linkedCategory.showtimeresourcepool_id,
          productlistcolumncount: [2, 3, 4].indexOf(parseInt(linkedCategory.productlistcolumncount, 10)) !== -1
            ? parseInt(linkedCategory.productlistcolumncount, 10)
            : null
        })
      }
    },
    removeLinkedCategory(category) {
      this.linkedCategories = this.linkedCategories.filter(c => c.linkedcategory_id !== category.linkedcategory_id)
    },
    getTagTitle(tag) {
      if (!tag || !tag.title) {
        return ''
      }
      const parts = tag.title.split(':::')
      return parts.pop()
    },
    adminTagSearchChanged (value) {
      if (value) {
        this.adminTagSearchText = value
      }
    },
    addAdminTagWithId(id) {
      const tag = this.allSelectableAdminTags.find(t => parseInt(t.id) === parseInt(id))
      if (tag) {
        this.addAdminTag(tag)
      }
    },
    addAdminTag(tag) {
      const type = 'admin'
      const value = type + ':::' + tag
      const existing = this.allSelectableAdminTags.find(t => t.value === value)
      if (existing) {
        this.addTag(existing)
        this.showNotification(this._('Added existing tag:') + ' ' + tag + '.')
      } else {
        this.addTag(tag, type)
      }
    },
    /*
    addAdminTagDialog(tag) {
      this.showDialog({
        title: this._('Add tag'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {
              this.adminTagToAdd = ''
              this.adminTagSearchText = ''
            }
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['tag'],
            handler: (data) => {
              this.addAdminTag(data.tag)
            }
          }
        ],
        fields: [
          {
            title: this._('Tag'),
            type: 'text',
            name: 'tag',
            defaultValue: this.adminTagSearchText
          }
        ]
      })
    },
    */
    productTagSearchChanged (value) {
      if (value) {
        this.productTagSearchText = value
      }
    },
    /*
    addProductTagDialog(tag) {
      this.showDialog({
        title: this._('Add tag'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {
              this.productTagToAdd = ''
              this.productTagSearchText = ''
            }
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['tag', 'type'],
            handler: (data) => {
              if (data.type === 'versionless') {
                this.addProductTag(data.tag)
              } else {
                this.addProductTag(data.tag, this.version)
              }
            }
          }
        ],
        fields: [
          {
            title: this._('Tag'),
            type: 'text',
            name: 'tag',
            defaultValue: this.productTagSearchText
          },
          {
            title: this._('Type'),
            type: 'select',
            name: 'type',
            defaultValue: 'versionless',
            options: [{
              value: 'versionless',
              name: this._('Use in any language version')
            },
            {
              value: 'current',
              name: this._('Use only in the current language version')
            }]
          }
        ]
      })
    },
    */
    seoTagSearchChanged (value) {
      if (value) {
        this.seoTagSearchText = value
      }
    },
    /*
    addSeoTagDialog(tag) {
      this.showDialog({
        title: this._('Add tag'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {
              this.seoTagToAdd = ''
              this.seoTagSearchText = ''
            }
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['tag', 'type'],
            handler: (data) => {
              if (data.type === 'versionless') {
                this.addSeoTag(data.tag)
              } else {
                this.addSeoTag(data.tag, this.version)
              }
            }
          }
        ],
        fields: [
          {
            title: this._('Tag'),
            type: 'text',
            name: 'tag',
            defaultValue: this.seoTagSearchText
          },
          {
            title: this._('Type'),
            type: 'select',
            name: 'type',
            defaultValue: 'versionless',
            options: [{
              value: 'versionless',
              name: this._('Use in any language version')
            },
            {
              value: 'current',
              name: this._('Use only in the current language version')
            }]
          }
        ]
      })
    },
    */
    manageTagsDialog (category) {
      this.showModal('tagslist', TagsList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              category: category,
              modal: true
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    formatProductTag(option) {
      let ret = ''
      if (option.locale !== 'default') {
        ret += '(' + this.getVersionName(option.locale) + ') '
      }
      ret += option.title
      return ret
    },
    addCategory(id) {
      const tag = this.allSelectableProductTags.find(t => parseInt(t.id) === parseInt(id))
      if (tag) {
        this.addProductTag(tag)
      }
    },
    addProductTagWithId(id) {
      const tag = this.allSelectableProductTags.find(t => parseInt(t.id) === parseInt(id))
      if (tag) {
        this.addProductTag(tag)
      }
    },
    addProductTag(tag, version) {
      const type = 'product'
      const value = version ? type + ':::' + version + ':::' + tag : type + ':::' + tag
      const existing = this.allSelectableProductTags.find(t => t.value === value)
      if (existing) {
        this.addTag(existing)
        this.showNotification(this._('Added existing tag:') + ' ' + tag + '.')
      } else {
        this.addTag(tag, type, version)
      }
    },
    addSeoTagWithId(id) {
      const tag = this.allSelectableSeoTags.find(t => parseInt(t.id) === parseInt(id))
      if (tag) {
        this.addSeoTag(tag)
      }
    },
    addSeoTag(tag, version) {
      const type = 'seo'
      const value = version ? type + ':::' + version + ':::' + tag : type + ':::' + tag
      const existing = this.allSelectableSeoTags.find(t => t.value === value)
      if (existing) {
        this.addTag(existing)
        this.showNotification(this._('Added existing tag:') + ' ' + tag + '.')
      } else {
        this.addTag(tag, type, version)
      }
    },
    async addTag(tag, type, version) {
      if (!tag) {
        return
      }
      if (typeof tag === 'object') {
        const exists = this.product.sharedTag.filter(t => t.id === tag.id)
        if (!exists.length) {
          this.product.sharedTag.push({ id: tag.id, title: tag.value })
        } else {
          this.showError(this._('The tag has already been added.'))
        }
      } else {
        const title = version ? type + ':::' + version + ':::' + tag : type + ':::' + tag
        const exists = this.product.sharedTag.filter(t => t.title === title)
        if (!exists.length) {
          this.product.sharedTag.push({
            title
          })
        } else {
          this.showError(this._('The tag has already been added.'))
        }
      }
      await nextTick()
      this.adminTagToAdd = ''
      this.adminTagSearchText = ''
      this.productTagToAdd = ''
      this.productTagSearchText = ''
      this.seoTagToAdd = ''
      this.seoTagSearchText = ''
    },
    removeTag(tag) {
      this.product.sharedTag = this.product.sharedTag.filter(t => t.title !== tag.title)
    },
    addDistance() {
      this.editDistance({ id: 'new-' + new Date().getTime(), unit: 'km' })
    },
    editDistance(distance) {
      this.showModal('distancedetails', DistanceDetails, {
        props: {
          selectedDistance: distance
        },
        events: {
          save: this.saveDistance,
          remove: this.deleteDistance
        },
        handlers: {},
        width: 800
      })
    },
    saveDistance(distance) {
      if (!this.product.ownDistance) {
        this.product.ownDistance = []
      }
      const index = this.product.ownDistance.findIndex(d => d.id === distance.id)
      if (index !== -1) {
        this.product.ownDistance[index] = distance
      } else {
        this.product.ownDistance.push(distance)
      }
    },
    deleteDistance(distance) {
      this.product.ownDistance = this.product.ownDistance.filter(d => d.id !== distance.id)
    },
    findMovie(service, title) {
      let search = this.product.channeldata && this.product.channeldata.originaltitle ? this.product.channeldata.originaltitle : this.product.name
      this.showModal('filmsearchdetails', FilmSearchDetails, {
        props: {
          baseDomain: this.baseDomain,
          service: service,
          title: title,
          origSearch: search
        },
        events: {
          selectMovie: this.updateMovie(service)
        },
        handlers: {},
        width: 800
      })
    },
    updateMovie(service) {
      return (data) => {
        const propTrans = {
          'name': 'originaltitle',
          'movie_id': 'filmikamari',
          'imdbid': 'imdb',
          'runtime': 'duration',
          'agelimit': 'agelimit',
          'director': 'director',
          'script': 'script',
          'actors': 'actors',
          'movie_url': 'website',
          'movie_trailer_url': 'trailerurl',
          'movie_extrainfo': 'furtherinformation',
          'material_notes': 'materialnotes',
          'credits_misc': 'creditsmisc',
          'maccsboxid': 'maccsboxid'
        }
        if (service === 'maccsbox' && data.name) {
          this.product.channeldata.maccsboxtitle = data.name
          delete data.name
        }
        for (let prop in data) {
          if (Object.prototype.hasOwnProperty.call(data, prop)) {
            const value = data[prop]
            if (propTrans[prop]) {
              const cProp = propTrans[prop]
              if (this.product.channeldata[cProp] && this.product.channeldata[cProp].constructor === Array) {
                for (let i = 0; i < value.length; i++) {
                  this.product.channeldata[cProp].push(value[i])
                }
              } else {
                this.product.channeldata[cProp] = value
              }
            }
            if (prop === 'distributor') {
              const dist = this.distributors.find(d => d.name.substring(0, value.length) === value)
              if (dist && dist.id) {
                this.product.channeldata.distributor = dist.id
              }
            }
            if (prop === 'genres') {
              this.channelCategories = value
            }
            if (prop === 'classifications') {
              this.channelAttributes = value
            }
            if (prop === 'movie_content') {
              this.product.channeldata.description = value
            }
            if (value && (prop === 'movie_trailer_url' || prop === 'movie_url')) {
              const url = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.exec(striptags(value))
              if (url && url[0]) {
                this.product.channeldata[propTrans[prop]] = url[0]
              }
            }
            if (prop === 'images') {
              this.downloadAndUploadImages(value)
            }
          }
        }
        // this.validateMaccsReporting()
      }
    },
    // Film images from Filmikamari: the first one becomes the main image and the
    // others additional images. The server fetches each one in the upload queue,
    // so editing can go on while they are processed.
    downloadAndUploadImages(images) {
      if (!images || !Array.isArray(images) || images.length === 0) {
        return []
      }
      return images.map((image, index) => {
        const name = `${image.image_url}`
        return this.queueUpload({ import: { filmikamari: image.asset_id, filename: name } }, index === 0 ? 'main' : 'gallery', { name })
      })
    },
    selectRoute(resource, resourceIndex) {
      this.showModal('transportationrouteselector', TransportationRouteSelector, {
        props: {
          settings: this.settings,
          locale: this.shortLocale
        },
        events: {
          selectRoute: this.addRouteToResource(resource, resourceIndex)
        },
        handlers: {},
        width: 800
      })
    },
    addRouteToResource(resource, resourceIndex) {
      return (route) => {
        if(!resource.sharedRoute) {
          resource.sharedRoute = [route]
          this.$set(this.product.sharedResource, resourceIndex, resource)
        } else {
          resource.sharedRoute.push(route)
        }
        this.$set(this.product.sharedResource, resourceIndex, resource)
        this.loadStops()
      }
    },
    removeRouteFromResource(resource, route) {
      resource.sharedRoute = resource.sharedRoute.filter(r => r.id !== route.id || r.type !== route.type)
      this.loadStops()
    },
    async addResourceDialog() {
      let response
      const type = parseInt(this.product.type) === this.TYPE_SELLABLE ? 'buyable' : 'allreservable'
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/resources.json?iSortingCols=1&iSortCol_0=1&sSortDir=asc&sSearch_2=' + type + '&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      const allResources = response.data
      this.showDialog({
        title: this._('Attach resource'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('New resource'),
            class: 'success',
            icon: 'plus',
            handler: () => {
              this.showModal('resourcetypeselector', ResourceTypeSelector, {
                props: {
                  openResourcepools: [],
                  forceType: 'resource',
                  context: parseInt(this.product.type) === this.TYPE_SELLABLE ? 'product-buyable' : 'product-reservable'
                },
                events: {
                  selected: this.createNewResourceOrResourcepool
                },
                handlers: {},
                width: 800
              })
            }
          },
          {
            title: this._('OK'),
            class: 'success',
            icon: 'check',
            requiredFields: ['resource'],
            handler: (data) => {
              const resource = allResources.find(r => parseInt(r.id, 10) === parseInt(data.resource.value, 10))
              if (resource) {
                this.addResource(resource)
              }
            }
          }
        ],
        fields: [
          {
            title: this._('Resource'),
            type: 'selectize',
            name: 'resource',
            options: allResources.map(res => { return { value: res.id, name: res.id + ': ' + res.name }})
          }
        ]
      })
    },
    async createNewResourceOrResourcepool (data) {
      let response
      let d = {
        name: data.name,
        description: ''
      }
      try {
        if (data.selectedType === 'resourcepool') {
          response = await axios.post(this.baseDomain + this.shopId + '/resourcepools.json?apikey=' + this.apiKey, d)
          if (response.data) {
            this.addResourcepool({ id: response.data })
          }
        } else {
          if (data.selectedType !== 'openinghours') {
            d.count = 1
            d.mincount = 1
          }
          if (data.selectedType === 'resource') {
            d.displayedtype = 'generic'
          } else {
            d.displayedtype = data.selectedType
          }
          response = await axios.post(this.baseDomain + this.shopId + '/resources.json?apikey=' + this.apiKey, d)
          if (response.data) {
            this.addResource({ id: response.data })
          }
        }
      } catch(e) {}
    },
    async addResourcepoolDialog() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/resourcepools.json?iSortingCols=1&iSortCol_0=1&sSortDir=asc&level=0&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      const allResourcepools = response.data
      this.showDialog({
        title: this._('Attach resource pool'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('New resource pool'),
            class: 'success',
            icon: 'plus',
            handler: () => {
              this.showModal('resourcetypeselector', ResourceTypeSelector, {
                props: {
                  openResourcepools: [],
                  forceType: 'resourcepool'
                },
                events: {
                  selected: this.createNewResourceOrResourcepool
                },
                handlers: {},
                width: 800
              })
            }
          },
          {
            title: this._('OK'),
            class: 'success',
            icon: 'check',
            requiredFields: ['resourcepool'],
            handler: (data) => {
              const resourcepool = allResourcepools.find(r => parseInt(r.id, 10) === parseInt(data.resourcepool.value, 10))
              if (resourcepool) {
                this.addResourcepool(resourcepool)
              }
            }
          }
        ],
        fields: [
          {
            title: this._('Resource pool'),
            type: 'selectize',
            name: 'resourcepool',
            options: allResourcepools.map(res => { return { value: res.id, name: res.id + ': ' + res.name }})
          }
        ]
      })
    },
    async addResource (resource) {
      // We need to actually load the resource by itself so we get the capacity and all that shit
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/resources/' + resource.id + '.json?basketitemcount=true&capacity=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      const resourceData = response.data
      this.origResourceCapacity[resource.id] = this.resourceCapacity[resource.id] = resourceData.capacity
      this.resourceUnits[resource.id] = 1
      this.product.sharedResource.push(resourceData)
    },
    async reloadResource (resource) {
      // We need to actually load the resource by itself so we get the capacity and all that shit
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/resources/' + resource.id + '.json?basketitemcount=true&capacity=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      const resourceData = response.data
      this.origResourceCapacity[resource.id] = this.resourceCapacity[resource.id] = resourceData.capacity
      this.resourceUnits[resource.id] = 1
      this.product.sharedResource = this.product.sharedResource.map((existingResource) => {
        return existingResource.id === resource.id ? resourceData : existingResource
      })
    },
    async addResourcepool (resourcepool) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/resourcepools/' + resourcepool.id + '.json?resources=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      const resourcepoolData = response.data
      this.resourcePoolUnits[resourcepool.id] = 1
      this.product.sharedResourcepool.push(resourcepoolData)
    },
    removeResource (resource) {
      this.product.sharedResource = this.product.sharedResource.filter(r => parseInt(r.id, 10) !== parseInt(resource.id))
    },
    removeResourcepool (resourcepool) {
      this.product.sharedResourcepool = this.product.sharedResourcepool.filter(r => parseInt(r.id, 10) !== parseInt(resourcepool.id))
    },
    makeStarttimeDesc(starttime) {
      const _ = this._
      let desc = '<i class="fa fa-fw fa-play"></i> '
      desc += '<i class="fa fa-fw fa-' + (starttime.mode === 'hourly' ? 'clock-o' : 'calendar') + '"></i> '
      let hasModifiers = false
      if (starttime.dateend || starttime.datestart) {
        desc += (starttime.datestart ? DateTime.fromFormat(starttime.datestart, 'd.M.yyyy').toFormat(this.dateFormat) : '') + ' - ' + (starttime.dateend ? DateTime.fromFormat(starttime.dateend, 'd.M.yyyy').toFormat(this.dateFormat) : '') + '; '
        hasModifiers = true
      }
      let weekdays = starttime.weekdays.split(',')
      if(weekdays.length !== 7) {
        let dayNumbers = []
        for (let i = 0; i < weekdays.length; i++) {
          dayNumbers[weekdays[i]] = true
        }
        desc += this.makeDayRangeStr(dayNumbers) + ' '
        hasModifiers = true
      }
      if(starttime.timestart || parseInt(starttime.timestart) === 0 || starttime.timeend || parseInt(starttime.timeend) === 0) {
        if (starttime.mode === 'hourly') {
          desc += _('at') + ' ' + DateTime.fromFormat(this.convertToTime(starttime.timestart), 'H.mm').toFormat(this.timeFormat)
        } else {
          let et = DateTime.fromFormat(this.convertToTime(starttime.timeend), 'H.mm').toFormat(this.timeFormat)
          if (et == '0.00') {
            et = '24.00'
          }
          desc += _('from') + ' ' + DateTime.fromFormat(this.convertToTime(starttime.timestart), 'H.mm').toFormat(this.timeFormat) + ' ' + _('to') + ' ' + et
        }
        hasModifiers = true
      }
      if (!hasModifiers) {
        desc += _('at any time')
      }
      if (starttime.route_id) {
        desc += '; ' + this.getRouteName(starttime.route_id)
      }
      return desc.replace(/[ ,;]+$/, '')
    },
    pricingEngineChanged () {
      if (this.isCalendarPricing) {
        this.product.ownStarttime = this.starttimesForCalendar(this.product.ownStarttime)
      }
      if (this.isActivityCalendarPricing && !this.activityDurations.length) { // The duration is entered in minutes or hours
        this.activityDurations = [this.UNIT_MINUTE, this.UNIT_HOUR].includes(parseInt(this.product.unit_type, 10))
          ? this.parseActivityDurations(Object.assign({}, this.product, { product_units: '' }))
          : [{ value: '', unit: this.UNIT_MINUTE }]
      }
    },
    parseActivityDurations (product) { // product_units ("90m;2h"), or the one duration of product_unit / unit_type
      const rows = []
      String(product.product_units || '').split(/[;,\s]+/).forEach(part => {
        const m = /^(\d+)([mh])$/.exec(part.trim())
        if (m && parseInt(m[1], 10) > 0) {
          rows.push({ value: m[1], unit: m[2] === 'h' ? this.UNIT_HOUR : this.UNIT_MINUTE })
        }
      })
      if (!rows.length) {
        const unit = parseInt(product.product_unit, 10)
        const type = parseInt(product.unit_type, 10) === this.UNIT_HOUR ? this.UNIT_HOUR : this.UNIT_MINUTE
        rows.push({ value: unit > 0 ? String(unit) : '', unit: type })
      }
      return rows
    },
    activityDurationUnits () { // The valid durations, shortest first and without repeats
      const byMinutes = {}
      this.activityDurations.forEach(row => {
        const value = parseInt(row.value, 10)
        if (value > 0) {
          const minutes = parseInt(row.unit, 10) === this.UNIT_HOUR ? value * 60 : value
          byMinutes[minutes] = minutes % 60 === 0 ? { unit: minutes / 60, unitType: this.UNIT_HOUR } : { unit: minutes, unitType: this.UNIT_MINUTE }
        }
      })
      return Object.keys(byMinutes).map(Number).sort((a, b) => a - b).map(m => byMinutes[m])
    },
    starttimesForCalendar (starttimes) {
      if (!starttimes || !starttimes.length) {
        return []
      }
      const daily = starttimes.filter(t => t && t.mode !== 'hourly')
      if (daily.length) {
        return daily
      }
      return starttimes.map(t => Object.assign({}, t, { mode: 'daily' }))
    },
    addStarttime () {
      let starttime = {
        id: 'new' + new Date().getTime(),
        mode: this.defaultStarttimeMode,
				weekdays: '1,2,3,4,5,6,7',
      }
      this.editStarttime(starttime)
    },
    editStarttime (starttime) {
      this.showModal('starttimedetails', StarttimeDetails, {
        props: {
          origStarttime: starttime,
          product: this.product,
          settings: this.settings,
          locale: this.shortLocale,
          routes: this.allRoutes
        },
        events: {
          save: this.saveStarttime,
          remove: this.removeStarttime,
          saveMultiple: this.saveMultipleStarttimes
        },
        handlers: {},
        width: 900
      })
    },
    saveMultipleStarttimes (starttimes) {
      starttimes.forEach(st => this.saveStarttime(st))
    },
    saveStarttime (starttime) {
      var found = false
      for (var i = 0; i < this.product.ownStarttime.length; i++) {
        if (this.product.ownStarttime[i].id === starttime.id) {
          this.product.ownStarttime[i] = starttime
          found = true
          break
        }
      }
      if (!found) {
        this.product.ownStarttime.push(starttime)
      }
    },
    removeStarttime (starttime) {
      for (var i = 0; i < this.product.ownStarttime.length; i++) {
        if (this.product.ownStarttime[i].id === starttime.id) {
          this.product.ownStarttime.splice(i, 1)
          return
        }
      }
    },
    addPreselectedDate() {
      if (!this.preselectedDate) {
        return
      }
      let p = this.preselectedDates
      if (!p.includes(this.preselectedDateStr)) {
        p.push(this.preselectedDateStr)
      }
      this.product.preselecteddates = p.join(';')
      this.preselectedDate = null
    },
    removePreselectedDate(date) {
      this.preselectedDates = this.preselectedDates.filter(d => d !== date)
    },
    removeImage(image) {
      if (image === 'main') { // Remove main image
        this.product.file_id = null
        this.product.file_ext = null
      } else if (image === 'mobile') { // Remove mobile main image
        this.product.mobileimage_id = null
        this.product.mobileimage_ext = null
      } else {
        if (this.isEmbeddedExtraImage(image)) {
          if (!confirm(this._('This image is used in the description. Remove it from the description as well?'))) {
            return
          }
          if (this.product.channeldata) {
            this.product.channeldata.description = stripEmbeddedImage(this.product.channeldata.description, image.id)
          }
        }
        this.product.sharedFile = this.product.sharedFile.filter(i => i.id !== image.id)
      }
    },
    enableInCatalogChanged(type, newValue) {
      if (type === 'global') {
        this.product.enable_catalog = newValue ? this.storefrontversions.join(';') : '0'
      } else {
        const ec = this.product.enable_catalog
        let versions
        let newVersions
        if (!ec || parseInt(ec) === 0) {
          versions = []
        } else if (!ec.match || !ec.match('_')) {
          versions = this.storefrontversions
        } else {
          versions = ec.split(';')
        }
        newVersions = newValue ? [...versions, type] : versions.filter(v => v !== type)
        if (!newVersions.length) {
          this.product.enable_catalog = '0'
        } else if (newVersions.join) {
          this.product.enable_catalog = newVersions.join(';')
        }
      }
    },
    setPublishingStatus (newStatus) {
      this.publishingMode = newStatus
      const currentVersions = this.enabledVersionsList.length
        ? this.enabledVersionsList
        : [...this.storefrontversions]
      const val = currentVersions.length ? currentVersions.join(';') : '0'
      if (newStatus === 'none') {
        this.product.enable_catalog = '0'
        this.product.enable_collection = '0'
      } else if (newStatus === 'all') {
        this.product.enable_catalog = val
        this.product.enable_collection = val
        this.loadCollectionsWithCategories()
      } else if (newStatus === 'selected') {
        this.product.enable_catalog = '0'
        this.product.enable_collection = val
        this.loadCollectionsWithCategories()
      }
    },
    versionsChanged (version, checked) {
      let versions
      if (version === 'global') {
        versions = checked ? [...this.storefrontversions] : []
      } else {
        versions = [...this.enabledVersionsList]
        if (checked) {
          if (!versions.includes(version)) versions.push(version)
        } else {
          versions = versions.filter(v => v !== version)
        }
      }
      const val = versions.length ? versions.join(';') : '0'
      if (this.publishingMode === 'all') {
        this.product.enable_catalog = val
        this.product.enable_collection = val
      } else if (this.publishingMode === 'selected') {
        this.product.enable_catalog = '0'
        this.product.enable_collection = val
      }
    },
    async loadCollectionsWithCategories () {
      if (this.collectionsWithCategories.length) return
      try {
        const listResponse = await axios.get(
          this.baseDomain + this.shopId + '/collections.json?apikey=' + this.apiKey,
          { signal: this.controller.signal }
        )
        const list = listResponse.data || []
        const details = await Promise.all(
          list.map(c => axios.get(
            this.baseDomain + this.shopId + '/collections/' + c.id + '.json?apikey=' + this.apiKey,
            { signal: this.controller.signal }
          ).then(r => r.data).catch(() => null))
        )
        this.collectionsWithCategories = details
          .filter(Boolean)
          .map(collection => {
            const sharedCategory = (collection.sharedCategory || []).map(localCat => {
              const commonCat = (this.product.localSaleschannelCategories || []).find(
                lscc => Number(lscc.source_id) === Number(localCat.id)
              )
              return commonCat ? { id: commonCat.id, name: commonCat.name } : null
            }).filter(Boolean)
            return { id: collection.id, name: collection.name, sharedCategory }
          })
      } catch (e) {
        // silently fail; UI shows 'No collections available'
      }
    },
    isCollectionPublished (collection) {
      if (!collection) return false
      const collectionId = Number(collection.id)
      if (this.enabledPublishedCollections.includes(collectionId)) return true
      const selectedCats = this.enabledLocalSaleschannelCategories.map(Number)
      return (collection.sharedCategory || []).some(cat => selectedCats.includes(Number(cat.id)))
    },
    toggleCollectionPublished (collection, checked) {
      if (!collection) return
      const collectionId = Number(collection.id)
      let ids = [...this.enabledPublishedCollections]
      if (checked) {
        if (!ids.includes(collectionId)) ids.push(collectionId)
      } else {
        ids = ids.filter(id => id !== collectionId)
      }
      this.enabledPublishedCollections = ids
    },
    getResourceType() {
      const types = {
        'default': 'generic',
        '1-3-generic': 'vehicle',
        '1-1-generic': 'cottage',
        '1-1001-generic': 'room',
        '1-1-hotelroom': 'room',
        '1-1-cottage': 'cottage',
        '1-1-villa': 'villa',
        '1-1-otheraccommodation': 'accommodation',
        '1-0-rentalgear': 'rentalgear',
        '1-0-rentalequipment': 'rentalequipment',
        '1-0-meetingvenue': 'meetingroom',
        '1-0-partyvenue': 'space',
        '1-0-othervenue': 'space',
        '1-2-trip': 'guide',
        '1-2-guidedtrip': 'guide'
      }
      const type = this.type
      return types[type] ? types[type] : types.default
    },
    getText(texts, mode) {
      if (!texts || !texts[mode]) {
        return ''
      }
      const type = this.type
      return texts[mode][type] ? texts[mode][type] : texts[mode].default
    },
    getResourceText() {
      const _ = this._
      const map = {
        resource: _('Resource'),
        room: _('Room'),
        vehicle: _('Vehicle'),
        cottage: _('Cottage'),
        villa: _('Villa'),
        accommodation: _('Accommodation'),
        rentalgear: _('Rental gear'),
        rentalequipment: _('Rental equipment'),
        meetingroom: _('Meeting room'),
        space: _('Space'),
        guide: _('Guide'),
        theater: _('Theater'),
        event: _('Venue')
      }
      const texts = {
        'default': map.resource,
        '1-3-generic': map.vehicle,
        '1-1-generic': map.cottage,
        '1-1001-generic': map.room,
        '1-1-hotelroom': map.room,
        '1-1-cottage': map.cottage,
        '1-1-villa': map.villa,
        '1-1-otheraccommodation': map.accommodation,
        '1-0-rentalgear': map.rentalgear,
        '1-0-rentalequipment': map.rentalequipment,
        '1-0-meetingvenue': map.meetingroom,
        '1-0-partyvenue': map.space,
        '1-0-othervenue': map.space,
        '1-2-trip': map.guide,
        '1-2-guidedtrip': map.guide,
        '1-4-generic': map.event,
        '1-4-concert': map.event,
        '1-4-movie': map.theater,
        '1-4-theater': map.theater,
        '1-4-opera': map.theater,
        '1-4-ballet': map.theater,
      }
      const type = this.type
      return texts[type] ? texts[type] : texts.default
    },
    getRadioText(mode) {
      const _ = this._
      const map = {
        single: {
          resource: _('There is only one resource like this'),
          room: _('There is only one room like this'),
          vehicle: _('There is only one vehicle like this'),
          cottage: _('There is only one cottage like this'),
          villa: _('There is only one villa like this'),
          accommodation: _('There is only one accommodation like this'),
          rentalgear: _('There is only one rental gear like this'),
          rentalequipment: _('There is only one rental equipment like this'),
          meetingroom: _('There is only one meeting room like this'),
          space: _('There is only one space like this'),
          guide: _('There is only one guide like this'),
          theater: _('There is only one theater'),
          event: _('There is only one venue')
        },
        multi: {
          resource: _('There are multiple resources like this'),
          room: _('There are multiple rooms like this'),
          vehicle: _('There are multiple vehicles like this'),
          cottage: _('There are multiple cottages like this'),
          villa: _('There are multiple villas like this'),
          accommodation: _('There are multiple accommodations like this'),
          rentalgear: _('There are multiple rental gear like this'),
          rentalequipment: _('There are multiple rental equipment like this'),
          meetingroom: _('There are multiple meeting rooms like this'),
          space: _('There are multiple spaces like this'),
          guide: _('There are multiple guides like this'),
          theater: _('There are multiple theaters'),
          event: _('There are multiple venues')
        },
        existing: {
          resource: _('Add existing resources'),
          room: _('Add existing rooms'),
          vehicle: _('Add existing vehicles'),
          cottage: _('Add existing cottages'),
          villa: _('Add existing villas'),
          accommodation: _('Add existing accommodations'),
          rentalgear: _('Add existing rental gear'),
          rentalequipment: _('Add existing rental equipment'),
          meetingroom: _('Add existing meeting rooms'),
          space: _('Add existing spaces'),
          guide: _('Add existing guides'),
          theater: _('Add existing theaters'),
          event: _('Add existing venues')
        }
      }
      const texts = {
        single: {
          'default': map.single.resource,
          '1-3-generic': map.single.vehicle,
          '1-1-generic': map.single.cottage,
          '1-1001-generic': map.single.room,
          '1-1-hotelroom': map.single.room,
          '1-1-cottage': map.single.cottage,
          '1-1-villa': map.single.villa,
          '1-1-otheraccommodation': map.single.accommodation,
          '1-0-rentalgear': map.single.rentalgear,
          '1-0-rentalequipment': map.single.rentalequipment,
          '1-0-meetingvenue': map.single.meetingroom,
          '1-0-partyvenue': map.single.space,
          '1-0-othervenue': map.single.space,
          '1-2-trip': map.single.guide,
          '1-2-guidedtrip': map.single.guide,
          '1-4-generic': map.single.event,
          '1-4-concert': map.single.event,
          '1-4-movie': map.single.theater,
          '1-4-theater': map.single.theater,
          '1-4-opera': map.single.theater,
          '1-4-ballet': map.single.theater
        },
        multi: {
          'default': map.multi.resource,
          '1-3-generic': map.multi.vehicle,
          '1-1-generic': map.multi.cottage,
          '1-1001-generic': map.multi.room,
          '1-1-hotelroom': map.multi.room,
          '1-1-cottage': map.multi.cottage,
          '1-1-villa': map.multi.villa,
          '1-1-otheraccommodation': map.multi.accommodation,
          '1-0-rentalgear': map.multi.rentalgear,
          '1-0-rentalequipment': map.multi.rentalequipment,
          '1-0-meetingvenue': map.multi.meetingroom,
          '1-0-partyvenue': map.multi.space,
          '1-0-othervenue': map.multi.space,
          '1-2-trip': map.multi.guide,
          '1-2-guidedtrip': map.multi.guide,
          '1-4-generic': map.multi.event,
          '1-4-concert': map.multi.event,
          '1-4-movie': map.multi.theater,
          '1-4-theater': map.multi.theater,
          '1-4-opera': map.multi.theater,
          '1-4-ballet': map.multi.theater
        },
        existing: {
          'default': map.existing.resource,
          '1-3-generic': map.existing.vehicle,
          '1-1-generic': map.existing.cottage,
          '1-1001-generic': map.existing.room,
          '1-1-hotelroom': map.existing.room,
          '1-1-cottage': map.existing.cottage,
          '1-1-villa': map.existing.villa,
          '1-1-otheraccommodation': map.existing.accommodation,
          '1-0-rentalgear': map.existing.rentalgear,
          '1-0-rentalequipment': map.existing.rentalequipment,
          '1-0-meetingvenue': map.existing.meetingroom,
          '1-0-partyvenue': map.existing.space,
          '1-0-othervenue': map.existing.space,
          '1-2-trip': map.existing.guide,
          '1-2-guidedtrip': map.existing.guide,
          '1-4-generic': map.existing.event,
          '1-4-concert': map.existing.event,
          '1-4-movie': map.existing.theater,
          '1-4-theater': map.existing.theater,
          '1-4-opera': map.existing.theater,
          '1-4-ballet': map.existing.theater
        }
      }
      return this.getText(texts, mode)
    },
    getInfoText(mode) {
      const _ = this._
      const map = {
        single: {
          resource: _('Select this option when you have a single resource that has some capacity (seats, participants, etc.) available. Clicking confirm will create a resource and link it to this product.'),
          room: _('Select this option when you have a single room that has one or more beds available. Clicking confirm will create a room resource and link it to this product.'),
          vehicle: _('Select this option when you have a single vehicle that has one or more seats available. Clicking confirm will create a vehicle resource and link it to this product.'),
          cottage: _('Select this option when you have a single cottage that has one or more beds available. Clicking confirm will create a cottage resource and link it to this product.'),
          villa: _('Select this option when you have a single villa that has one or more beds available. Clicking confirm will create a villa resource and link it to this product.'),
          accommodation: _('Select this option when you have a single accommodation that has one or more beds available. Clicking confirm will create an accommodation resource and link it to this product.'),
          rentalgear: _('Select this option when you have a single piece of rental gear that has one or more seats available. Clicking confirm will create a rental gear resource and link it to this product.'),
          rentalequipment: _('Select this option when you have a single piece of rental equipment that has one or more seats available. Clicking confirm will create a rental equipment resource and link it to this product.'),
          meetingroom: _('Select this option when you have a single meeting venue that has one or more seats available. Clicking confirm will create a meeting room resource and link it to this product.'),
          space: _('Select this option when you have a single space that has one or more seats available. Clicking confirm will create a space resource and link it to this product.'),
          guide: _('Select this option when you have a single guide that has some capacity (usually participants) available. Clicking confirm will create a guide resource and link it to this product.'),
          theater: _('Select this option when you have a single theater that has one or more seats available. Clicking confirm will create a theater resource a link it to this product.'),
          event: _('Select this option when you have a single venue that has some capacity available. Clicking confirm will create a venue resource a link it to this product.')
        },
        multi: {
          resource: _('Select this option when you have multiple resources that each have the same capacity (seats, participants, etc.) available. If some of the resources have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with resources and link it to this product.'),
          room: _('Select this option when you have multiple rooms that each have the same number of beds available. If some of the rooms have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with room resources and link it to this product.'),
          vehicle: _('Select this option when you have multiple vehicles that each have the same number of seats available. If some of the vehicles have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with vehicle resources and link it to this product.'),
          cottage: _('Select this option when you have multiple cottages that each have the same number of beds available. If some of the cottages have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with cottage resources and link it to this product.'),
          villa: _('Select this option when you have multiple villas that each have the same number of beds available. If some of the villas have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with villa resources and link it to this product.'),
          accommodation: _('Select this option when you have multiple accommodations that each have the same number of beds available. If some of the accommodations have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with accommodation resources and link it to this product.'),
          rentalgear: _('Select this option when you have multiple pieces of rental gear that each have the same number of seats available. If some of the rental gear have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with rental gear resources and link it to this product.'),
          rentalequipment: _('Select this option when you have multiple pieces of rental equipment that each have the same number of seats available. If some of the rental equipment have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with rental equipment resources and link it to this product.'),
          meetingroom: _('Select this option when you have multiple meeting venues that each have the same number of seats available. If some of the meeting rooms have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with meeting room resources and link it to this product.'),
          space: _('Select this option when you have multiple spaces that each have the same number of seats available. If some of the spaces have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with space resources and link it to this product.'),
          guide: _('Select this option when you have multiple guides that each have the same capacity (usually participants) available. If some of the guides have a different capacity but you still want to rent them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with guide resources and link it to this product.'),
          theater: _('Select this option when you have multiple theaters that each have the same number of seats available. If some of the theaters have a different capacity but you still want to make them available them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with theater resources and link it to this product.'),
          event: _('Select this option when you have multiple venues that each have the same capacity (usually participants). If some of the venues have a different capacity but you still want to make them available them via the same product, just enter the most common one and edit the others manually later. Clicking confirm will create a resource pool with theater resources and link it to this product.')
        },
        existing: {
          resource: _('Select this option if you want to configure resources and resource pools attached to this product manually.'),
          room: _('Select this option if you want to configure rooms and resource pools attached to this product manually.'),
          vehicle: _('Select this option if you want to configure vehicles and resource pools attached to this product manually.'),
          cottage: _('Select this option if you want to configure cottages and resource pools attached to this product manually.'),
          villa: _('Select this option if you want to configure villas and resource pools attached to this product manually.'),
          accommodation: _('Select this option if you want to configure accommodations and resource pools attached to this product manually.'),
          rentalgear: _('Select this option if you want to configure rental gear and resource pools attached to this product manually.'),
          rentalequipment: _('Select this option if you want to configure rental equipment and resource pools attached to this product manually.'),
          meetingroom: _('Select this option if you want to configure meeting rooms and resource pools attached to this product manually.'),
          space: _('Select this option if you want to configure spaces and resource pools attached to this product manually.'),
          guide: _('Select this option if you want to configure guides and resource pools attached to this product manually.'),
          theater: _('Select this option if you want to configure theaters and resource pools attached to this product manually.'),
          event: _('Select this option if you want to configure venues and resource pools attached to this product manually.')
        }
      }
      const texts = {
        single: {
          'default': map.single.resource,
          '1-3-generic': map.single.vehicle,
          '1-1-generic': map.single.cottage,
          '1-1001-generic': map.single.room,
          '1-1-hotelroom': map.single.room,
          '1-1-cottage': map.single.cottage,
          '1-1-villa': map.single.villa,
          '1-1-otheraccommodation': map.single.accommodation,
          '1-0-rentalgear': map.single.rentalgear,
          '1-0-rentalequipment': map.single.rentalequipment,
          '1-0-meetingvenue': map.single.meetingroom,
          '1-0-partyvenue': map.single.space,
          '1-0-othervenue': map.single.space,
          '1-2-trip': map.single.guide,
          '1-2-guidedtrip': map.single.guide,
          '1-4-generic': map.single.event,
          '1-4-concert': map.single.event,
          '1-4-movie': map.single.theater,
          '1-4-theater': map.single.theater,
          '1-4-opera': map.single.theater,
          '1-4-ballet': map.single.theater
        },
        multi: {
          'default': map.multi.resource,
          '1-3-generic': map.multi.vehicle,
          '1-1-generic': map.multi.cottage,
          '1-1001-generic': map.multi.room,
          '1-1-hotelroom': map.multi.room,
          '1-1-cottage': map.multi.cottage,
          '1-1-villa': map.multi.villa,
          '1-1-otheraccommodation': map.multi.accommodation,
          '1-0-rentalgear': map.multi.rentalgear,
          '1-0-rentalequipment': map.multi.rentalequipment,
          '1-0-meetingvenue': map.multi.meetingroom,
          '1-0-partyvenue': map.multi.space,
          '1-0-othervenue': map.multi.space,
          '1-2-trip': map.multi.guide,
          '1-2-guidedtrip': map.multi.guide,
          '1-4-generic': map.multi.event,
          '1-4-concert': map.multi.event,
          '1-4-movie': map.multi.theater,
          '1-4-theater': map.multi.theater,
          '1-4-opera': map.multi.theater,
          '1-4-ballet': map.multi.theater
        },
        existing: {
          'default': map.existing.resource,
          '1-3-generic': map.existing.vehicle,
          '1-1-generic': map.existing.cottage,
          '1-1001-generic': map.existing.room,
          '1-1-hotelroom': map.existing.room,
          '1-1-cottage': map.existing.cottage,
          '1-1-villa': map.existing.villa,
          '1-1-otheraccommodation': map.existing.accommodation,
          '1-0-rentalgear': map.existing.rentalgear,
          '1-0-rentalequipment': map.existing.rentalequipment,
          '1-0-meetingvenue': map.existing.meetingroom,
          '1-0-partyvenue': map.existing.space,
          '1-0-othervenue': map.existing.space,
          '1-2-trip': map.existing.guide,
          '1-2-guidedtrip': map.existing.guide,
          '1-4-generic': map.existing.event,
          '1-4-concert': map.existing.event,
          '1-4-movie': map.existing.theater,
          '1-4-theater': map.existing.theater,
          '1-4-opera': map.existing.theater,
          '1-4-ballet': map.existing.theater
        }
      }
      return this.getText(texts, mode)
    },
    getResourceCountText() {
      const _ = this._
      const texts = {
        'default': _('Number of resources'),
        '1-3-generic': _('Number of vehicles'),
        '1-1-generic': _('Number of cottages'),
        '1-1001-generic': _('Number of rooms'),
        '1-1-hotelroom': _('Number of rooms'),
        '1-1-cottage': _('Number of cottages'),
        '1-1-villa': _('Number of villas'),
        '1-1-otheraccommodation': _('Number of accommodations'),
        '1-0-rentalgear': _('Number of rental gear'),
        '1-0-rentalequipment': _('Number of rental equipment'),
        '1-0-meetingvenue': _('Number of meeting rooms'),
        '1-0-partyvenue': _('Number of spaces'),
        '1-0-othervenue': _('Number of spaces'),
        '1-2-trip': _('Number of guides'),
        '1-2-guidedtrip': _('Number of guides'),
        '1-4-generic': _('Number of venues'),
        '1-4-concert': _('Number of venues'),
        '1-4-movie': _('Number of theaters'),
        '1-4-theater': _('Number of theaters'),
        '1-4-opera': _('Number of theaters'),
        '1-4-ballet': _('Number of theaters')
      }
      const type = this.type
      return texts[type] ? texts[type] : texts.default
    },
    getSeatCountText() {
      const _ = this._
      const map = {
        capacity: _('Capacity'),
        seats: _('Number of seats'),
        beds: _('Number of beds'),
      }
      const texts = {
        'default': map.capacity,
        '1-3-generic': map.seats,
        '1-1-generic': map.beds,
        '1-1001-generic': map.beds,
        '1-1-hotelroom': map.beds,
        '1-1-cottage': map.beds,
        '1-1-villa': map.beds,
        '1-1-otheraccommodation': map.beds,
        '1-0-rentalgear': map.seats,
        '1-0-rentalequipment': map.seats,
        '1-0-meetingvenue': map.seats,
        '1-0-partyvenue': map.seats,
        '1-0-othervenue': map.seats,
        '1-2-trip': map.capacity,
        '1-2-guidedtrip': map.capacity,
        '1-4-generic': map.capacity,
        '1-4-concert': map.capacity,
        '1-4-movie': map.seats,
        '1-4-theater': map.seats,
        '1-4-opera': map.seats,
        '1-4-ballet': map.seats,
      }
      const type = this.type
      return texts[type] ? texts[type] : texts.default
    },
    editResourcepoolDialog (resourcePool) {
      this.showModal('productresourcepooldetails', ResourcepoolDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              resourcepoolId: resourcePool.id,
              modal: true
            }
          }
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    editResourceDialog (resource) {
      this.showModal('productresourcedetails', ResourceDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              resourceId: resource.id,
              modal: true
            }
          }
        },
        events: {
          save: this.reloadResource,
          deleteResource: this.removeResource
        },
        handlers: {},
        width: 1000
      })
    },
    pricetierManagement () {
      this.showModal('settings', Settings, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          focus: 'pricetiers'
        },
        events: {},
        handlers: {},
        width: 1000
      })
      /*
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'Settings',
        title: this._('Settings'),
        width: 6,
        data: {
          trail: this.componentTrail
        }
      })
      */
    },
    getTaskActionTitle (val) {
      switch (val) {
        case 'publish':
          return this._('Restore from archive')
        case 'archive':
          return this._('verb|Archive')
        case 'visibility':
          return this._('Change Storefront visibility')
        default:
          return this._(val)
      }
    },
    openScheduledTask (id) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ScheduledTaskDetails',
        title: this._('Scheduled task') + ' ' + id,
        width: 6,
        data: {
          scheduledTaskId: id,
          trail: this.componentTrail
        }
      })
    },
    updateTag (tagId) {
      if (!this.product || !this.product.sharedTag) {
        return
      }
      const newTag = this.allTags.find(tag => tag.id === tagId)
      const tagIndex = this.product.sharedTag.findIndex(tag => tag.id === tagId)
      if (tagIndex !== -1) {
        this.product.sharedTag[tagIndex].title = newTag.value
      }
    }
  },
  watch: {
    placeTransportIds: {
      immediate: true,
      handler (newValue) {
        (newValue ? newValue.split(',') : []).forEach(id => this.loadTransportRoutes(id))
      }
    },
    publishingMode (newValue) {
      this.loadCollectionsWithCategories()
    },
    gygOptionsProductId: {
      immediate: true,
      handler () {
        this.loadGygOptions()
      }
    },
    bokunRatesProductId: {
      immediate: true,
      handler () {
        this.bokunRates = null // Another product's rates are not kept on screen while loading
        this.loadBokunRates()
      }
    },
    bokunRatesDate () {
      this.loadBokunRates()
    },
    'product.id' (newId) {
      this.publishingMode = newId ? this.publishingStatus : 'none'
      this.collectionsWithCategories = []
      if (newId) {
        this.loadCollectionsWithCategories()
      }
    },
    enableParticipantPricing (newValue) {
      if (!parseInt(newValue)) {
        this.product.sharedPricetier = []
        this.selectedPricetiers = []
      }
    },
    selectedPricetiers: {
      deep: true,
      handler (newValue) {
        if (this.product.sharedPricetier.length) {
          this.product.enable_participant_pricing = 1
        }
      }
    },
    pricerowToggle (newValue) {
      if (newValue) {
        for (let i = 0; i < this.product.ownPricerow.length; i++) {
          if (this.isPricerowVisible(this.product.ownPricerow[i])) { // Rows hidden by the rate filter are not selected
            this.selectedPricerows.push(this.product.ownPricerow[i].id)
          }
        }
      } else {
        this.selectedPricerows = []
      }
    },
    activityDurations: {
      deep: true,
      handler () { // Kept on the product so that editing the durations counts as an unsaved change
        if (!this.isActivityCalendarPricing) {
          return
        }
        const units = this.activityDurationUnits().map(u => u.unit + (u.unitType === this.UNIT_HOUR ? 'h' : 'm')).join(';')
        if (units !== (this.product.product_units || '')) {
          this.product.product_units = units
        }
      }
    },
    'product.sharedResource': {
      deep: true,
      handler (newValue) {
        if (!this.origState) {
          return
        }
        this.resourcesTainted = true
      }
    }
  },
  components: {
    ActivityRatesEditor: defineAsyncComponent(() => import('~/components/ActivityRatesEditor.vue')),
    CalendarPricingEditor: () => import('~/components/CalendarPricingEditor.vue'),
    ChannelPriceRules: defineAsyncComponent(() => import('~/components/ChannelPriceRules.vue')),
    DraggableMultiSelector,
    Editor,
    ModelListSelect,
    MultiListSelect,
    ShowtimesCalendar
  },
  async created () {
    this.controller = new AbortController()
    if (this.component && this.component.initData && !this.loading) {
      try {
        await this.loadProduct(this.component.initData.productId)
      } catch(e) {}
      if (this.isTabActive('prices') && this.product.subtype === "8") {
        this.tab('general')
      }
    }
  },
  async updated () {
    if (this.component && this.component.initData && !this.loading && !this.loadingFailed) {
      if (!this.deleted && this.product && this.product.id && parseInt(this.product.id, 10) !== parseInt(this.component.initData.productId, 10)) {
        try {
          await this.loadProduct(this.component.initData.productId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['productUpdate'] = async (message) => {
        if (message && message.data && message.shopId === this.shopId && this.product && parseInt(message.data.id, 10) === parseInt(this.product.id, 10) && !this.deleted) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            try {
              await this.loadProduct(message.data.id)
            } catch(e) {}
          }
        }
      }
      events['deliverymethodUpdate'] = async (message) => {
        if (message && message.data) {
          try {
            this.loadDeliverymethod(message.data.id)
          } catch(e) {}
        }
      }
      events['pricingUpdate'] = async (message) => {
        if (message && message.data) {
          try {
            this.loadPricingOptions()
          } catch(e) {}
        }
      }
      events['termsUpdate'] = async (message) => {
        if (message && message.data) {
          try {
            this.loadTermsOptions()
          } catch(e) {}
        }
      }
      events['formUpdate'] = async (message) => {
        if (message && message.data) {
          try {
            await this.loadFormOptions()
            const options = Array.isArray(this.formOptions) ? this.formOptions : Object.values(this.formOptions || {})
            const formIds = options.map(formOption => String(formOption.id))
            if (this.product && this.product.form_id != null && !formIds.includes(String(this.product.form_id))) {
              this.product.form_id = null
            }
          } catch(e) {}
        }
      }
      events['tagUpdate'] = async (message) => {
        if (message && message.data) {
          await this.loadTags()
          this.updateTag(message.data.id)
        }
      }
      events['voucherUpdate'] = async (message) => {
        if (message && message.data) {
          try {
            this.loadVouchers()
          } catch(e) {}
        }
      }
      events['settingsUpdate'] = async (message) => { 
        console.log("settingsUpdate", message)
        if (message && message.data) {
          try {
            const settings = await this.loadVersionedSettings()
            this.origSettings = Object.assign({}, settings)
            this.localSettings = Object.assign({}, settings)
            this.settingsLocale = settings.locale
          } catch(e) {}
        }
      }
      this.events = events
    }
    this.enableEventBus()
    const settings = await this.loadVersionedSettings()
    this.origSettings = Object.assign({}, settings)
    this.localSettings = Object.assign({}, settings)
    this.settingsLocale = settings.locale
  },
  async beforeUnmount () {
    this.controller.abort()
    // clearInterval(this.debugInterval)
    // console.log('beforeUnmount', this.loading ? 'loading' : 'not loading', this.component.id)
  }
}
</script>

<style scoped>
.fa-star {
  color: #cccccc;
}
/* Activity pricing: choices of product options, drawn like the storefront's radio list */
.choice-groups {
  margin-bottom: 15px;
}
.choice-group {
  margin-bottom: 10px;
}
.choice-group-heading {
  display: flex;
  align-items: center;
  gap: 8px;
}
.choice-group-handle {
  cursor: move;
}
.choice-group-name {
  flex: 1;
  min-width: 0;
}
.choice-group-remove {
  margin-left: auto;
}
.choice-group-options {
  margin-bottom: 0;
}
.choice-group-option {
  cursor: pointer;
}
.choice-group-option,
.choice-group-none {
  border-left: 0;
  border-right: 0;
}
.choice-group-place,
.choice-group-transport {
  margin-left: 22px;
}
.choice-group-transport {
  cursor: default;
}
.choice-group-transport-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  margin: 4px 0 2px;
}
.choice-group-transport-controls label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-weight: normal;
}
.choice-group-transport-controls select.form-control {
  width: auto;
  max-width: 100%;
}
.choice-group-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
/* While an option is dragged between the option table and a choice, it is shown in the other's style
   until it is dropped (the table row inside a choice's list, or the choice's list item inside the table) */
.choice-group-options > tr.productoption {
  display: block;
  padding: 10px 15px;
  background-color: #ffffff;
  border-top: 1px solid #dddddd;
}
.choice-group-options > tr.productoption > td {
  display: inline;
  padding: 0;
  border: 0;
}
.choice-group-options > tr.productoption > td:not(:first-child) {
  display: none;
}
tbody > li.choice-group-option {
  display: table-row;
}
tbody > li.choice-group-option > .choice-group-option-body {
  display: table-cell;
  padding: 8px;
  border-top: 1px solid #dddddd;
}
.choice-group-empty {
  min-height: 36px;
  border-top: 1px dashed #dddddd;
  border-bottom: 1px dashed #dddddd;
}
.choice-group-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.isDefaultPricerow {
  color: #212121 ! important;
}
.activity-durations {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px
}
.activity-duration {
  width: 280px;
  max-width: 100%
}
.activity-duration .input-group-btn {
  width: auto
}
.activity-duration .input-group-btn .form-control {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: 110px;
  border-radius: 0;
  margin-left: -1px
}
.activity-duration .input-group-btn:last-child > .form-control:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px
}
.activity-duration .input-group-btn .btn {
  margin-left: -1px
}
.activity-duration-add {
  margin-top: 2px
}
.pricetier-item {
  flex-wrap: wrap;
  gap: 4px 12px;
  min-height: 52px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.pricetier-item .pricetier-name {
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
}
.pricetier-item .pricetier-name input {
  width: 16px;
  height: 16px;
  margin: 0;
}
.pricetier-title {
  font-size: 15px;
  font-weight: 600;
  color: #999;
}
.pricetier-item.is-selected .pricetier-title {
  color: #333;
}
.pricetier-default {
  display: flex;
  align-items: center;
  gap: 8px;
}
.pricetier-default-label {
  font-size: 12px;
  color: #777;
}
.pricetier-default-value,
.pricetier-default-value:hover,
.pricetier-default-value:active {
  min-width: 36px;
  cursor: default;
  background-color: #fff;
  box-shadow: none;
  font-variant-numeric: tabular-nums;
}
.pricetier-rules {
  flex-basis: 100%;
  margin: 0 0 0 24px;
  font-size: 12px;
  color: #777;
}
.pricerow-rateplan-filter {
  margin-bottom: 10px;
}
.pricerow-rateplan-filter label {
  margin-right: 8px;
}
ol#additionalImages {
  list-style-type: none;
  padding: 0;
}
#embedPreview {
  height: 600px;
}
#saleschannels .johkuversions {
  border-top: 1px solid #DDD;
  border-bottom: 1px solid #DDD;  
}
.panel-collapse {
  overflow-y: hidden;
}
.header-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pricing-tab-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 15px;
}
.pricing-tab-heading {
  flex: 0 1 auto;
  min-width: 0;
  margin-bottom: 0;
}
.pricing-tab-heading h3 {
  margin-top: 0;
  margin-bottom: 0;
}
.pricing-mode-field {
  flex: 1 1 16em;
  min-width: 11em;
  max-width: 22em;
  margin-bottom: 0;
}
.store-preview-form {
  display: inline-flex;
  margin: 0;
}
#storePreviewButton {
  margin-top: -7px;
  margin-bottom: -7px;
}
@media (max-width: 767px) {
  #storePreviewButton {
    padding: 4px 8px;
    font-size: 12px;
    line-height: 1.4;
    margin-top: -4px;
    margin-bottom: -4px;
  }
  #storePreviewButton .preview-button-label {
    display: none;
  }
}
.publishing-mode-btn {
  display: inline-flex;
  align-items: center;
}
.publishing-mode-btn > .fa {
  margin-right: 0.25em;
}
.publishing-mode-btn > input[type="checkbox"] {
  pointer-events: none;
  margin: 0 0 0 6px;
}
</style>
